import React from "react";

const InvestorIllustration = ({ className }: { className?: string }) => {
  return (
    <svg
      width="334"
      height="234"
      viewBox="0 0 334 234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1185_34932)">
        <path
          d="M302.686 133.686C301.989 133.295 300.88 133.304 300.208 133.705C299.535 134.107 299.553 134.75 300.249 135.141C300.945 135.532 302.054 135.524 302.727 135.122C303.401 134.72 303.382 134.077 302.686 133.686Z"
          fill="#36B4C9"
        />
        <path
          d="M307.084 136.159C306.389 135.768 305.28 135.776 304.607 136.178C303.933 136.58 303.952 137.222 304.647 137.613C305.344 138.004 306.453 137.996 307.126 137.594C307.799 137.192 307.78 136.55 307.084 136.159Z"
          fill="#36B4C9"
        />
        <path
          d="M311.479 138.632C310.783 138.241 309.673 138.249 309.001 138.651C308.327 139.052 308.346 139.696 309.042 140.087C309.738 140.478 310.848 140.469 311.521 140.068C312.194 139.666 312.175 139.023 311.479 138.632"
          fill="#36B4C9"
        />
        <path
          d="M315.877 141.1C315.181 140.709 314.071 140.718 313.399 141.119C312.726 141.521 312.745 142.165 313.441 142.556C314.136 142.947 315.246 142.938 315.919 142.536C316.593 142.135 316.573 141.492 315.878 141.101"
          fill="#36B4C9"
        />
        <path
          d="M320.276 143.577C319.579 143.186 318.47 143.194 317.798 143.596C317.125 143.998 317.143 144.64 317.839 145.032C318.535 145.423 319.645 145.415 320.318 145.013C320.991 144.611 320.972 143.969 320.277 143.578"
          fill="#36B4C9"
        />
        <path
          d="M324.674 146.046C323.978 145.655 322.869 145.663 322.196 146.065C321.523 146.467 321.541 147.109 322.238 147.501C322.933 147.892 324.042 147.884 324.716 147.481C325.389 147.079 325.37 146.437 324.674 146.046Z"
          fill="#36B4C9"
        />
        <path
          d="M329.069 148.518C328.373 148.127 327.264 148.136 326.591 148.537C325.918 148.939 325.936 149.582 326.632 149.973C327.328 150.364 328.437 150.355 329.11 149.954C329.784 149.552 329.764 148.909 329.069 148.518Z"
          fill="#36B4C9"
        />
        <path
          d="M333.467 150.991C332.771 150.6 331.661 150.608 330.989 151.01C330.316 151.412 330.335 152.055 331.03 152.446C331.726 152.837 332.836 152.829 333.509 152.427C334.182 152.025 334.163 151.383 333.468 150.992"
          fill="#36B4C9"
        />
        <path
          d="M298.902 135.944C298.205 135.553 297.095 135.561 296.423 135.963C295.75 136.365 295.768 137.007 296.464 137.399C297.16 137.79 298.27 137.781 298.942 137.379C299.616 136.978 299.597 136.335 298.902 135.944Z"
          fill="#36B4C9"
        />
        <path
          d="M303.295 138.42C302.6 138.029 301.49 138.038 300.817 138.44C300.144 138.842 300.162 139.484 300.858 139.875C301.555 140.266 302.664 140.258 303.337 139.856C304.01 139.455 303.992 138.812 303.295 138.42Z"
          fill="#36B4C9"
        />
        <path
          d="M307.694 140.889C306.999 140.498 305.888 140.507 305.215 140.908C304.542 141.31 304.561 141.954 305.257 142.345C305.953 142.736 307.063 142.727 307.736 142.326C308.409 141.924 308.39 141.28 307.694 140.889Z"
          fill="#36B4C9"
        />
        <path
          d="M312.093 143.366C311.397 142.975 310.286 142.983 309.614 143.385C308.941 143.787 308.96 144.43 309.655 144.821C310.351 145.212 311.462 145.204 312.134 144.802C312.807 144.4 312.788 143.757 312.093 143.366Z"
          fill="#36B4C9"
        />
        <path
          d="M316.488 145.835C315.791 145.444 314.681 145.452 314.009 145.854C313.336 146.256 313.354 146.898 314.05 147.29C314.746 147.681 315.857 147.673 316.529 147.271C317.202 146.869 317.183 146.226 316.488 145.835Z"
          fill="#36B4C9"
        />
        <path
          d="M320.886 148.307C320.189 147.916 319.08 147.925 318.407 148.326C317.734 148.728 317.752 149.371 318.449 149.763C319.144 150.154 320.254 150.144 320.927 149.743C321.6 149.341 321.582 148.698 320.886 148.307Z"
          fill="#36B4C9"
        />
        <path
          d="M325.283 150.78C324.588 150.389 323.478 150.398 322.805 150.8C322.133 151.201 322.15 151.844 322.846 152.235C323.543 152.626 324.652 152.618 325.325 152.216C325.998 151.814 325.98 151.171 325.283 150.78Z"
          fill="#36B4C9"
        />
        <path
          d="M329.679 153.253C328.983 152.862 327.872 152.87 327.2 153.272C326.527 153.674 326.546 154.317 327.241 154.708C327.937 155.099 329.048 155.091 329.72 154.689C330.393 154.287 330.374 153.644 329.679 153.253Z"
          fill="#36B4C9"
        />
        <path
          d="M295.112 138.21C294.415 137.819 293.306 137.827 292.634 138.229C291.961 138.631 291.979 139.273 292.675 139.665C293.371 140.056 294.48 140.048 295.153 139.645C295.826 139.243 295.807 138.601 295.112 138.21Z"
          fill="#36B4C9"
        />
        <path
          d="M299.51 140.678C298.815 140.287 297.706 140.296 297.032 140.698C296.359 141.099 296.377 141.742 297.073 142.133C297.769 142.524 298.878 142.516 299.552 142.114C300.225 141.712 300.206 141.069 299.51 140.678Z"
          fill="#36B4C9"
        />
        <path
          d="M303.904 143.151C303.209 142.76 302.099 142.768 301.426 143.17C300.753 143.572 300.772 144.215 301.468 144.606C302.164 144.997 303.273 144.989 303.947 144.587C304.62 144.185 304.601 143.543 303.905 143.152"
          fill="#36B4C9"
        />
        <path
          d="M308.303 145.624C307.607 145.233 306.497 145.241 305.825 145.643C305.152 146.045 305.171 146.688 305.866 147.079C306.562 147.47 307.672 147.462 308.345 147.06C309.018 146.658 308.999 146.016 308.304 145.625"
          fill="#36B4C9"
        />
        <path
          d="M312.702 148.096C312.005 147.705 310.896 147.714 310.224 148.116C309.55 148.517 309.569 149.16 310.265 149.552C310.961 149.943 312.071 149.934 312.744 149.533C313.417 149.131 313.398 148.488 312.702 148.097"
          fill="#36B4C9"
        />
        <path
          d="M317.1 150.569C316.404 150.178 315.294 150.186 314.622 150.588C313.949 150.99 313.967 151.632 314.664 152.024C315.359 152.415 316.468 152.407 317.141 152.004C317.815 151.603 317.796 150.96 317.1 150.569Z"
          fill="#36B4C9"
        />
        <path
          d="M321.495 153.038C320.799 152.647 319.69 152.655 319.017 153.057C318.343 153.459 318.362 154.101 319.057 154.492C319.754 154.883 320.863 154.875 321.536 154.473C322.209 154.071 322.19 153.429 321.495 153.038Z"
          fill="#36B4C9"
        />
        <path
          d="M325.893 155.51C325.197 155.119 324.087 155.128 323.415 155.53C322.741 155.931 322.761 156.575 323.456 156.966C324.152 157.357 325.262 157.348 325.935 156.947C326.608 156.545 326.589 155.902 325.893 155.511"
          fill="#36B4C9"
        />
        <path
          d="M291.327 140.468C290.631 140.077 289.522 140.085 288.849 140.487C288.175 140.888 288.194 141.531 288.89 141.923C289.586 142.314 290.696 142.305 291.368 141.903C292.041 141.501 292.023 140.859 291.327 140.468Z"
          fill="#36B4C9"
        />
        <path
          d="M295.721 142.94C295.026 142.549 293.916 142.557 293.243 142.96C292.57 143.362 292.588 144.004 293.284 144.395C293.98 144.786 295.089 144.778 295.763 144.376C296.436 143.974 296.418 143.332 295.721 142.94Z"
          fill="#36B4C9"
        />
        <path
          d="M300.12 145.413C299.424 145.022 298.315 145.03 297.641 145.432C296.968 145.834 296.987 146.477 297.683 146.868C298.378 147.259 299.489 147.251 300.162 146.849C300.835 146.447 300.816 145.804 300.12 145.413Z"
          fill="#36B4C9"
        />
        <path
          d="M304.518 147.882C303.823 147.491 302.713 147.499 302.04 147.901C301.366 148.302 301.386 148.946 302.081 149.337C302.777 149.728 303.888 149.719 304.56 149.318C305.233 148.916 305.214 148.273 304.518 147.882Z"
          fill="#36B4C9"
        />
        <path
          d="M308.913 150.354C308.217 149.963 307.108 149.972 306.435 150.373C305.761 150.775 305.78 151.418 306.476 151.809C307.172 152.2 308.282 152.192 308.955 151.79C309.628 151.389 309.609 150.745 308.913 150.354Z"
          fill="#36B4C9"
        />
        <path
          d="M313.312 152.827C312.615 152.436 311.506 152.444 310.833 152.846C310.16 153.248 310.178 153.89 310.874 154.282C311.57 154.673 312.68 154.664 313.352 154.262C314.026 153.86 314.007 153.218 313.312 152.827Z"
          fill="#36B4C9"
        />
        <path
          d="M317.709 155.299C317.014 154.908 315.905 154.917 315.232 155.319C314.558 155.721 314.577 156.364 315.272 156.755C315.969 157.146 317.079 157.137 317.751 156.736C318.424 156.334 318.406 155.691 317.709 155.299Z"
          fill="#36B4C9"
        />
        <path
          d="M322.104 157.772C321.409 157.381 320.299 157.39 319.626 157.791C318.952 158.193 318.971 158.836 319.667 159.227C320.363 159.618 321.474 159.61 322.146 159.208C322.819 158.807 322.8 158.163 322.104 157.772Z"
          fill="#36B4C9"
        />
        <path
          d="M287.538 142.729C286.842 142.338 285.732 142.347 285.06 142.748C284.386 143.15 284.405 143.793 285.101 144.184C285.797 144.575 286.906 144.567 287.579 144.165C288.252 143.763 288.234 143.12 287.538 142.729Z"
          fill="#36B4C9"
        />
        <path
          d="M291.936 145.201C291.24 144.811 290.13 144.82 289.458 145.221C288.785 145.623 288.803 146.266 289.499 146.657C290.195 147.048 291.304 147.039 291.978 146.638C292.651 146.236 292.632 145.593 291.936 145.201Z"
          fill="#36B4C9"
        />
        <path
          d="M296.331 147.671C295.635 147.28 294.525 147.288 293.852 147.69C293.179 148.092 293.198 148.735 293.894 149.126C294.589 149.517 295.699 149.509 296.372 149.107C297.046 148.705 297.027 148.062 296.331 147.671Z"
          fill="#36B4C9"
        />
        <path
          d="M300.729 150.147C300.034 149.756 298.923 149.765 298.251 150.166C297.577 150.568 297.596 151.211 298.292 151.602C298.988 151.993 300.098 151.985 300.771 151.583C301.444 151.182 301.425 150.538 300.729 150.147Z"
          fill="#36B4C9"
        />
        <path
          d="M305.128 152.616C304.432 152.225 303.322 152.233 302.649 152.635C301.976 153.037 301.994 153.679 302.691 154.071C303.387 154.462 304.496 154.454 305.17 154.052C305.843 153.65 305.824 153.007 305.128 152.616Z"
          fill="#36B4C9"
        />
        <path
          d="M309.523 155.089C308.826 154.698 307.716 154.706 307.044 155.108C306.371 155.509 306.389 156.152 307.085 156.544C307.781 156.935 308.89 156.927 309.563 156.524C310.237 156.122 310.218 155.48 309.523 155.089Z"
          fill="#36B4C9"
        />
        <path
          d="M313.92 157.561C313.225 157.17 312.115 157.179 311.442 157.581C310.769 157.983 310.787 158.625 311.483 159.016C312.18 159.407 313.289 159.399 313.962 158.997C314.635 158.595 314.617 157.953 313.92 157.561Z"
          fill="#36B4C9"
        />
        <path
          d="M318.319 160.034C317.624 159.643 316.513 159.651 315.84 160.053C315.167 160.455 315.186 161.098 315.882 161.489C316.578 161.88 317.688 161.872 318.361 161.47C319.034 161.068 319.015 160.425 318.319 160.034Z"
          fill="#36B4C9"
        />
        <path
          d="M283.753 144.991C283.056 144.6 281.947 144.608 281.274 145.01C280.601 145.412 280.62 146.054 281.316 146.445C282.011 146.836 283.12 146.828 283.794 146.426C284.467 146.024 284.448 145.382 283.753 144.991Z"
          fill="#36B4C9"
        />
        <path
          d="M288.147 147.46C287.451 147.069 286.342 147.077 285.669 147.48C284.995 147.881 285.014 148.524 285.71 148.915C286.407 149.306 287.516 149.298 288.188 148.896C288.861 148.494 288.843 147.851 288.147 147.46Z"
          fill="#36B4C9"
        />
        <path
          d="M292.546 149.936C291.85 149.545 290.74 149.554 290.067 149.955C289.394 150.357 289.413 151 290.109 151.391C290.804 151.782 291.914 151.773 292.587 151.372C293.26 150.97 293.241 150.326 292.545 149.935"
          fill="#36B4C9"
        />
        <path
          d="M296.944 152.405C296.249 152.014 295.139 152.022 294.465 152.424C293.792 152.826 293.811 153.468 294.507 153.859C295.203 154.25 296.313 154.242 296.985 153.84C297.658 153.439 297.639 152.795 296.943 152.404"
          fill="#36B4C9"
        />
        <path
          d="M301.339 154.878C300.642 154.487 299.533 154.495 298.86 154.897C298.187 155.299 298.206 155.941 298.902 156.332C299.597 156.723 300.707 156.715 301.379 156.313C302.053 155.911 302.034 155.268 301.338 154.877"
          fill="#36B4C9"
        />
        <path
          d="M305.737 157.35C305.041 156.959 303.932 156.968 303.258 157.369C302.585 157.771 302.604 158.414 303.3 158.805C303.996 159.196 305.105 159.187 305.778 158.786C306.451 158.384 306.433 157.741 305.737 157.35Z"
          fill="#36B4C9"
        />
        <path
          d="M310.135 159.819C309.439 159.428 308.33 159.436 307.657 159.839C306.984 160.241 307.003 160.883 307.698 161.274C308.395 161.665 309.504 161.657 310.176 161.255C310.85 160.853 310.831 160.211 310.135 159.819Z"
          fill="#36B4C9"
        />
        <path
          d="M314.53 162.296C313.835 161.905 312.725 161.913 312.051 162.315C311.378 162.717 311.397 163.359 312.093 163.75C312.789 164.141 313.898 164.133 314.571 163.731C315.244 163.329 315.225 162.686 314.529 162.295"
          fill="#36B4C9"
        />
        <path
          d="M279.964 147.249C279.268 146.858 278.158 146.866 277.485 147.268C276.812 147.67 276.83 148.312 277.527 148.704C278.222 149.095 279.332 149.086 280.005 148.684C280.678 148.282 280.66 147.64 279.964 147.249Z"
          fill="#36B4C9"
        />
        <path
          d="M284.362 149.721C283.666 149.33 282.556 149.339 281.884 149.741C281.211 150.143 281.229 150.785 281.925 151.176C282.621 151.567 283.73 151.559 284.403 151.157C285.077 150.755 285.058 150.113 284.362 149.721Z"
          fill="#36B4C9"
        />
        <path
          d="M288.757 152.194C288.061 151.803 286.95 151.811 286.278 152.213C285.605 152.615 285.624 153.258 286.319 153.649C287.015 154.04 288.126 154.032 288.798 153.63C289.471 153.228 289.452 152.585 288.757 152.194Z"
          fill="#36B4C9"
        />
        <path
          d="M293.155 154.667C292.46 154.276 291.349 154.284 290.676 154.686C290.003 155.088 290.022 155.731 290.718 156.122C291.414 156.513 292.524 156.505 293.197 156.103C293.87 155.701 293.851 155.058 293.155 154.667Z"
          fill="#36B4C9"
        />
        <path
          d="M297.554 157.139C296.857 156.748 295.748 156.757 295.075 157.158C294.402 157.56 294.42 158.203 295.117 158.595C295.812 158.986 296.923 158.977 297.595 158.576C298.269 158.174 298.25 157.53 297.554 157.139Z"
          fill="#36B4C9"
        />
        <path
          d="M301.948 159.608C301.252 159.217 300.142 159.225 299.47 159.627C298.796 160.029 298.815 160.672 299.511 161.063C300.207 161.454 301.317 161.445 301.989 161.043C302.662 160.642 302.644 159.999 301.948 159.608Z"
          fill="#36B4C9"
        />
        <path
          d="M306.346 162.084C305.651 161.693 304.541 161.702 303.868 162.104C303.195 162.506 303.213 163.149 303.909 163.54C304.605 163.931 305.715 163.922 306.388 163.52C307.061 163.119 307.043 162.476 306.346 162.084Z"
          fill="#36B4C9"
        />
        <path
          d="M310.745 164.553C310.049 164.162 308.939 164.171 308.266 164.573C307.593 164.974 307.612 165.618 308.308 166.009C309.003 166.4 310.114 166.391 310.787 165.99C311.46 165.588 311.441 164.944 310.745 164.553Z"
          fill="#36B4C9"
        />
        <path
          d="M276.179 149.51C275.482 149.119 274.373 149.128 273.7 149.53C273.027 149.931 273.046 150.574 273.741 150.965C274.437 151.356 275.546 151.348 276.219 150.946C276.893 150.544 276.874 149.901 276.179 149.51Z"
          fill="#36B4C9"
        />
        <path
          d="M280.572 151.983C279.877 151.592 278.768 151.6 278.094 152.003C277.421 152.405 277.44 153.047 278.136 153.438C278.832 153.829 279.941 153.821 280.614 153.419C281.287 153.017 281.269 152.375 280.572 151.983Z"
          fill="#36B4C9"
        />
        <path
          d="M284.972 154.456C284.276 154.065 283.166 154.073 282.493 154.475C281.82 154.877 281.839 155.519 282.534 155.91C283.23 156.301 284.34 156.293 285.012 155.891C285.686 155.489 285.666 154.846 284.971 154.455"
          fill="#36B4C9"
        />
        <path
          d="M289.37 156.928C288.674 156.537 287.565 156.546 286.891 156.948C286.218 157.349 286.237 157.992 286.933 158.383C287.628 158.774 288.738 158.766 289.411 158.364C290.084 157.962 290.065 157.319 289.369 156.928"
          fill="#36B4C9"
        />
        <path
          d="M293.765 159.397C293.068 159.006 291.959 159.015 291.286 159.416C290.613 159.818 290.632 160.461 291.327 160.852C292.023 161.243 293.133 161.234 293.805 160.833C294.478 160.431 294.459 159.787 293.764 159.396"
          fill="#36B4C9"
        />
        <path
          d="M298.163 161.874C297.467 161.483 296.357 161.491 295.684 161.893C295.011 162.295 295.03 162.937 295.726 163.328C296.421 163.719 297.53 163.711 298.204 163.309C298.877 162.907 298.859 162.265 298.163 161.874Z"
          fill="#36B4C9"
        />
        <path
          d="M302.561 164.342C301.865 163.951 300.756 163.96 300.083 164.362C299.409 164.764 299.429 165.407 300.124 165.798C300.821 166.189 301.93 166.18 302.602 165.779C303.275 165.377 303.257 164.734 302.561 164.342Z"
          fill="#36B4C9"
        />
        <path
          d="M306.956 166.815C306.26 166.424 305.15 166.432 304.477 166.834C303.804 167.236 303.823 167.879 304.519 168.27C305.214 168.661 306.324 168.652 306.997 168.25C307.67 167.849 307.651 167.205 306.955 166.814"
          fill="#36B4C9"
        />
        <path
          d="M272.39 151.772C271.693 151.381 270.584 151.39 269.911 151.791C269.238 152.193 269.256 152.836 269.953 153.227C270.648 153.618 271.758 153.609 272.431 153.207C273.103 152.806 273.086 152.163 272.39 151.772Z"
          fill="#36B4C9"
        />
        <path
          d="M276.788 154.244C276.092 153.853 274.982 153.863 274.31 154.264C273.636 154.666 273.655 155.309 274.35 155.7C275.047 156.091 276.156 156.082 276.829 155.681C277.502 155.279 277.484 154.636 276.788 154.244Z"
          fill="#36B4C9"
        />
        <path
          d="M281.183 156.718C280.487 156.327 279.376 156.335 278.704 156.737C278.031 157.138 278.05 157.782 278.745 158.173C279.441 158.564 280.552 158.555 281.224 158.154C281.897 157.752 281.878 157.109 281.183 156.718Z"
          fill="#36B4C9"
        />
        <path
          d="M285.581 159.186C284.885 158.795 283.775 158.804 283.102 159.205C282.429 159.607 282.448 160.251 283.144 160.641C283.839 161.032 284.95 161.024 285.622 160.622C286.296 160.221 286.277 159.577 285.581 159.186Z"
          fill="#36B4C9"
        />
        <path
          d="M289.98 161.659C289.283 161.268 288.173 161.276 287.501 161.678C286.828 162.08 286.846 162.722 287.542 163.114C288.238 163.505 289.349 163.497 290.021 163.095C290.694 162.693 290.675 162.05 289.98 161.659Z"
          fill="#36B4C9"
        />
        <path
          d="M294.378 164.132C293.682 163.741 292.572 163.749 291.899 164.151C291.226 164.552 291.244 165.195 291.941 165.587C292.637 165.978 293.746 165.969 294.419 165.567C295.092 165.165 295.074 164.523 294.378 164.132Z"
          fill="#36B4C9"
        />
        <path
          d="M298.772 166.604C298.076 166.213 296.966 166.222 296.294 166.624C295.621 167.026 295.639 167.668 296.335 168.059C297.031 168.45 298.141 168.442 298.813 168.04C299.486 167.638 299.468 166.996 298.772 166.604Z"
          fill="#36B4C9"
        />
        <path
          d="M303.171 169.077C302.475 168.686 301.364 168.694 300.692 169.096C300.019 169.498 300.038 170.141 300.734 170.532C301.429 170.923 302.54 170.915 303.212 170.513C303.886 170.111 303.866 169.468 303.171 169.077Z"
          fill="#36B4C9"
        />
        <path
          d="M130.182 56.1199C129.486 55.7289 128.376 55.7372 127.704 56.139C127.031 56.5407 127.049 57.1833 127.746 57.5751C128.441 57.9661 129.55 57.9578 130.224 57.5552C130.897 57.1534 130.878 56.5109 130.182 56.1199Z"
          fill="#36B4C9"
        />
        <path
          d="M134.581 58.5925C133.885 58.2015 132.776 58.2098 132.103 58.6116C131.429 59.0134 131.448 59.6559 132.143 60.0469C132.84 60.4379 133.949 60.4296 134.622 60.0278C135.295 59.626 135.276 58.9835 134.581 58.5925Z"
          fill="#36B4C9"
        />
        <path
          d="M138.975 61.0613C138.279 60.6703 137.169 60.6786 136.497 61.0804C135.824 61.4821 135.843 62.1255 136.538 62.5165C137.234 62.9075 138.344 62.8992 139.017 62.4974C139.69 62.0956 139.671 61.4531 138.976 61.0621"
          fill="#36B4C9"
        />
        <path
          d="M143.373 63.5378C142.677 63.1468 141.568 63.1551 140.895 63.5569C140.222 63.9587 140.241 64.6021 140.937 64.9931C141.632 65.384 142.742 65.3757 143.415 64.974C144.089 64.5722 144.07 63.9297 143.374 63.5387"
          fill="#36B4C9"
        />
        <path
          d="M147.772 66.0066C147.075 65.6156 145.966 65.6239 145.294 66.0257C144.621 66.4275 144.639 67.07 145.335 67.4618C146.031 67.8528 147.141 67.8445 147.814 67.4427C148.487 67.0409 148.468 66.3984 147.773 66.0074"
          fill="#36B4C9"
        />
        <path
          d="M152.17 68.4792C151.474 68.0882 150.365 68.0966 149.692 68.4983C149.019 68.9001 149.037 69.5426 149.734 69.9345C150.43 70.3255 151.539 70.3172 152.212 69.9145C152.885 69.5128 152.866 68.8702 152.17 68.4792Z"
          fill="#36B4C9"
        />
        <path
          d="M156.565 70.9519C155.869 70.5609 154.76 70.5692 154.087 70.971C153.414 71.3728 153.432 72.0153 154.128 72.4063C154.824 72.7973 155.933 72.789 156.606 72.3872C157.28 71.9854 157.261 71.3429 156.565 70.9519Z"
          fill="#36B4C9"
        />
        <path
          d="M160.963 73.4206C160.267 73.0297 159.157 73.038 158.485 73.4397C157.812 73.8415 157.831 74.4849 158.527 74.8759C159.222 75.2669 160.332 75.2586 161.005 74.8568C161.679 74.455 161.659 73.8125 160.964 73.4215"
          fill="#36B4C9"
        />
        <path
          d="M126.393 58.3816C125.697 57.9906 124.587 57.9989 123.915 58.4007C123.242 58.8025 123.26 59.445 123.956 59.8368C124.652 60.2278 125.762 60.2187 126.434 59.8169C127.107 59.4151 127.089 58.7726 126.393 58.3816Z"
          fill="#36B4C9"
        />
        <path
          d="M130.791 60.8499C130.096 60.4589 128.986 60.4681 128.314 60.8699C127.64 61.2716 127.659 61.9142 128.354 62.3051C129.051 62.6961 130.16 62.6878 130.833 62.2861C131.506 61.8843 131.488 61.2417 130.791 60.8499Z"
          fill="#36B4C9"
        />
        <path
          d="M135.19 63.3269C134.495 62.9359 133.384 62.9442 132.712 63.346C132.038 63.7478 132.057 64.3911 132.753 64.7821C133.449 65.1731 134.559 65.1648 135.232 64.763C135.905 64.3612 135.886 63.7179 135.19 63.3269Z"
          fill="#36B4C9"
        />
        <path
          d="M139.589 65.7956C138.893 65.4047 137.782 65.413 137.11 65.8147C136.437 66.2165 136.456 66.8599 137.152 67.2509C137.847 67.6419 138.958 67.6336 139.63 67.2318C140.304 66.83 140.284 66.1866 139.589 65.7956Z"
          fill="#36B4C9"
        />
        <path
          d="M143.984 68.2683C143.287 67.8773 142.177 67.8856 141.505 68.2874C140.832 68.6892 140.85 69.3317 141.546 69.7235C142.242 70.1145 143.353 70.1062 144.025 69.7044C144.698 69.3026 144.679 68.6593 143.984 68.2683Z"
          fill="#36B4C9"
        />
        <path
          d="M148.382 70.741C147.686 70.35 146.576 70.3583 145.903 70.7601C145.23 71.1618 145.248 71.8044 145.945 72.1962C146.64 72.5872 147.75 72.578 148.423 72.1763C149.095 71.7745 149.078 71.132 148.382 70.741Z"
          fill="#36B4C9"
        />
        <path
          d="M152.78 73.2132C152.084 72.8222 150.974 72.8313 150.302 73.2331C149.629 73.6349 149.647 74.2774 150.343 74.6684C151.039 75.0594 152.149 75.0511 152.821 74.6493C153.495 74.2476 153.476 73.605 152.78 73.2132Z"
          fill="#36B4C9"
        />
        <path
          d="M157.175 75.6863C156.479 75.2953 155.368 75.3036 154.696 75.7054C154.023 76.1071 154.042 76.7505 154.737 77.1415C155.433 77.5325 156.544 77.5242 157.216 77.1224C157.889 76.7206 157.87 76.0773 157.175 75.6863Z"
          fill="#36B4C9"
        />
        <path
          d="M122.608 60.6394C121.911 60.2484 120.802 60.2567 120.13 60.6585C119.457 61.0603 119.475 61.7028 120.171 62.0946C120.867 62.4856 121.976 62.4773 122.649 62.0747C123.323 61.6729 123.303 61.0304 122.608 60.6394Z"
          fill="#36B4C9"
        />
        <path
          d="M127.006 63.1121C126.311 62.7211 125.202 62.7294 124.528 63.1311C123.855 63.5329 123.873 64.1754 124.569 64.5664C125.266 64.9574 126.375 64.9491 127.048 64.5473C127.721 64.1456 127.702 63.503 127.006 63.1121Z"
          fill="#36B4C9"
        />
        <path
          d="M131.4 65.5847C130.705 65.1937 129.595 65.202 128.923 65.6038C128.249 66.0056 128.268 66.6489 128.964 67.0399C129.66 67.4309 130.77 67.4226 131.443 67.0208C132.116 66.619 132.097 65.9765 131.401 65.5855"
          fill="#36B4C9"
        />
        <path
          d="M135.799 68.0574C135.103 67.6664 133.993 67.6747 133.321 68.0765C132.648 68.4782 132.667 69.1216 133.362 69.5126C134.058 69.9036 135.168 69.8953 135.841 69.4935C136.514 69.0917 136.495 68.4492 135.8 68.0582"
          fill="#36B4C9"
        />
        <path
          d="M140.198 70.53C139.501 70.139 138.392 70.1473 137.72 70.5491C137.046 70.9509 137.065 71.5934 137.761 71.9852C138.457 72.3762 139.567 72.3679 140.24 71.9661C140.913 71.5644 140.894 70.9218 140.198 70.5308"
          fill="#36B4C9"
        />
        <path
          d="M144.596 72.9988C143.9 72.6078 142.791 72.6161 142.118 73.0179C141.445 73.4196 141.463 74.0622 142.16 74.454C142.855 74.845 143.964 74.8367 144.638 74.4341C145.311 74.0323 145.292 73.3898 144.596 72.9988Z"
          fill="#36B4C9"
        />
        <path
          d="M148.991 75.4753C148.295 75.0843 147.186 75.0926 146.513 75.4944C145.84 75.8962 145.858 76.5387 146.553 76.9297C147.25 77.3207 148.359 77.3124 149.032 76.9106C149.705 76.5088 149.686 75.8663 148.991 75.4753Z"
          fill="#36B4C9"
        />
        <path
          d="M153.389 77.9441C152.693 77.5531 151.583 77.5614 150.911 77.9632C150.238 78.365 150.257 79.0083 150.952 79.3993C151.648 79.7903 152.758 79.782 153.431 79.3802C154.104 78.9784 154.085 78.3359 153.39 77.9449"
          fill="#36B4C9"
        />
        <path
          d="M118.82 62.9011C118.123 62.5101 117.014 62.5184 116.341 62.9202C115.668 63.322 115.686 63.9645 116.382 64.3563C117.078 64.7473 118.188 64.7382 118.86 64.3364C119.533 63.9346 119.515 63.2921 118.82 62.9011Z"
          fill="#36B4C9"
        />
        <path
          d="M123.217 65.3737C122.522 64.9827 121.413 64.991 120.739 65.3936C120.066 65.7954 120.084 66.4379 120.78 66.8289C121.476 67.2199 122.586 67.2116 123.259 66.8098C123.932 66.408 123.914 65.7655 123.217 65.3737Z"
          fill="#36B4C9"
        />
        <path
          d="M127.616 67.8464C126.92 67.4554 125.811 67.4637 125.137 67.8655C124.464 68.2673 124.483 68.9107 125.179 69.3016C125.875 69.6926 126.985 69.6843 127.658 69.2826C128.331 68.8808 128.312 68.2374 127.616 67.8464Z"
          fill="#36B4C9"
        />
        <path
          d="M132.015 70.3191C131.319 69.9281 130.209 69.9364 129.536 70.3382C128.863 70.74 128.882 71.3833 129.577 71.7743C130.273 72.1653 131.384 72.157 132.056 71.7552C132.729 71.3534 132.71 70.7101 132.015 70.3191Z"
          fill="#36B4C9"
        />
        <path
          d="M136.409 72.7878C135.713 72.3968 134.604 72.4051 133.931 72.8069C133.257 73.2087 133.276 73.8512 133.972 74.2431C134.668 74.634 135.779 74.6257 136.451 74.224C137.124 73.8222 137.105 73.1788 136.409 72.7878Z"
          fill="#36B4C9"
        />
        <path
          d="M140.808 75.2644C140.111 74.8734 139.002 74.8817 138.329 75.2835C137.656 75.6853 137.674 76.3278 138.371 76.7196C139.066 77.1106 140.176 77.1015 140.849 76.6997C141.522 76.2979 141.503 75.6554 140.808 75.2644Z"
          fill="#36B4C9"
        />
        <path
          d="M145.202 77.733C144.506 77.3421 143.397 77.3504 142.724 77.753C142.05 78.1548 142.069 78.7973 142.764 79.1883C143.461 79.5793 144.571 79.571 145.243 79.1692C145.916 78.7674 145.898 78.1249 145.202 77.733Z"
          fill="#36B4C9"
        />
        <path
          d="M149.601 80.2058C148.905 79.8148 147.795 79.8231 147.122 80.2249C146.449 80.6267 146.468 81.27 147.163 81.661C147.859 82.052 148.97 82.0437 149.642 81.6419C150.315 81.2401 150.296 80.5968 149.601 80.2058Z"
          fill="#36B4C9"
        />
        <path
          d="M115.034 65.1628C114.338 64.7718 113.228 64.7801 112.556 65.1819C111.882 65.5837 111.901 66.2262 112.597 66.6181C113.293 67.009 114.402 67.0007 115.075 66.5981C115.748 66.1963 115.73 65.5538 115.034 65.1628Z"
          fill="#36B4C9"
        />
        <path
          d="M119.432 67.6351C118.736 67.2441 117.627 67.2532 116.954 67.655C116.281 68.0568 116.299 68.6993 116.995 69.0903C117.691 69.4813 118.8 69.473 119.474 69.0712C120.147 68.6694 120.129 68.0269 119.432 67.6351Z"
          fill="#36B4C9"
        />
        <path
          d="M123.827 70.1081C123.131 69.7172 122.021 69.7255 121.348 70.1272C120.675 70.529 120.694 71.1724 121.39 71.5634C122.085 71.9544 123.195 71.9461 123.869 71.5443C124.542 71.1425 124.523 70.4991 123.827 70.1081Z"
          fill="#36B4C9"
        />
        <path
          d="M128.226 72.5769C127.53 72.1859 126.419 72.1942 125.747 72.596C125.074 72.9978 125.093 73.6411 125.788 74.0321C126.484 74.4231 127.594 74.4148 128.267 74.013C128.94 73.6112 128.921 72.9679 128.226 72.5769Z"
          fill="#36B4C9"
        />
        <path
          d="M132.624 75.0496C131.928 74.6586 130.818 74.6669 130.145 75.0686C129.472 75.4704 129.491 76.1129 130.187 76.5048C130.883 76.8958 131.993 76.8875 132.666 76.4857C133.339 76.0839 133.32 75.4405 132.624 75.0496Z"
          fill="#36B4C9"
        />
        <path
          d="M137.019 77.5222C136.322 77.1312 135.212 77.1395 134.54 77.5413C133.867 77.9431 133.885 78.5856 134.582 78.9774C135.277 79.3684 136.386 79.3601 137.059 78.9575C137.733 78.5557 137.714 77.9132 137.019 77.5222Z"
          fill="#36B4C9"
        />
        <path
          d="M141.416 79.9945C140.721 79.6035 139.611 79.6126 138.939 80.0144C138.265 80.4162 138.284 81.0587 138.979 81.4497C139.676 81.8407 140.785 81.8324 141.458 81.4306C142.131 81.0288 142.113 80.3863 141.416 79.9945Z"
          fill="#36B4C9"
        />
        <path
          d="M145.815 82.4675C145.12 82.0765 144.009 82.0848 143.337 82.4866C142.663 82.8884 142.682 83.5317 143.378 83.9227C144.074 84.3137 145.184 84.3054 145.857 83.9036C146.53 83.5019 146.511 82.8585 145.815 82.4675Z"
          fill="#36B4C9"
        />
        <path
          d="M111.249 67.4246C110.552 67.0336 109.443 67.0419 108.77 67.4436C108.097 67.8454 108.116 68.4879 108.812 68.8789C109.507 69.2699 110.616 69.2616 111.29 68.8598C111.963 68.4581 111.945 67.8155 111.249 67.4246Z"
          fill="#36B4C9"
        />
        <path
          d="M115.643 69.8971C114.947 69.5061 113.838 69.5144 113.165 69.917C112.491 70.3188 112.511 70.9613 113.206 71.3523C113.903 71.7433 115.012 71.735 115.684 71.3332C116.357 70.9315 116.339 70.2889 115.643 69.8971Z"
          fill="#36B4C9"
        />
        <path
          d="M120.042 72.366C119.346 71.975 118.236 71.9833 117.563 72.3851C116.89 72.7868 116.909 73.4294 117.605 73.8204C118.3 74.2113 119.41 74.203 120.083 73.8013C120.756 73.3995 120.737 72.7561 120.041 72.3651"
          fill="#36B4C9"
        />
        <path
          d="M124.436 74.8386C123.741 74.4476 122.631 74.4559 121.958 74.8577C121.284 75.2595 121.304 75.902 121.999 76.293C122.695 76.684 123.805 76.6757 124.477 76.2739C125.15 75.8721 125.131 75.2288 124.436 74.8378"
          fill="#36B4C9"
        />
        <path
          d="M128.835 77.3113C128.138 76.9203 127.029 76.9286 126.356 77.3304C125.683 77.7321 125.702 78.3747 126.398 78.7657C127.093 79.1567 128.203 79.1484 128.876 78.7466C129.549 78.3448 129.53 77.7014 128.834 77.3104"
          fill="#36B4C9"
        />
        <path
          d="M133.233 79.78C132.537 79.389 131.428 79.3973 130.755 79.7991C130.081 80.2009 130.1 80.8434 130.796 81.2344C131.492 81.6254 132.601 81.6171 133.274 81.2153C133.947 80.8135 133.929 80.171 133.233 79.78Z"
          fill="#36B4C9"
        />
        <path
          d="M137.631 82.2565C136.935 81.8655 135.826 81.8738 135.153 82.2764C134.48 82.6782 134.499 83.3207 135.194 83.7117C135.891 84.1027 137 84.0944 137.672 83.6926C138.346 83.2908 138.327 82.6483 137.631 82.2565Z"
          fill="#36B4C9"
        />
        <path
          d="M142.026 84.7253C141.331 84.3343 140.221 84.3426 139.548 84.7444C138.874 85.1462 138.893 85.7887 139.589 86.1797C140.285 86.5707 141.395 86.5624 142.067 86.1606C142.74 85.7589 142.721 85.1155 142.025 84.7245"
          fill="#36B4C9"
        />
        <path
          d="M107.46 69.6863C106.763 69.2953 105.654 69.3036 104.981 69.7054C104.309 70.1071 104.326 70.7497 105.023 71.1415C105.718 71.5325 106.828 71.5234 107.501 71.1216C108.174 70.7198 108.156 70.0773 107.46 69.6863Z"
          fill="#36B4C9"
        />
        <path
          d="M111.858 72.1546C111.162 71.7636 110.052 71.7728 109.38 72.1745C108.707 72.5763 108.725 73.2188 109.421 73.6098C110.117 74.0008 111.226 73.9925 111.899 73.5907C112.573 73.189 112.554 72.5464 111.858 72.1546Z"
          fill="#36B4C9"
        />
        <path
          d="M116.253 74.6277C115.557 74.2367 114.446 74.245 113.774 74.6468C113.101 75.0486 113.12 75.6919 113.816 76.0829C114.511 76.4739 115.622 76.4656 116.294 76.0638C116.968 75.662 116.949 75.0187 116.253 74.6277Z"
          fill="#36B4C9"
        />
        <path
          d="M120.651 77.1003C119.956 76.7093 118.845 76.7176 118.173 77.1194C117.499 77.5212 117.518 78.1646 118.214 78.5556C118.91 78.9465 120.02 78.9382 120.693 78.5365C121.366 78.1347 121.347 77.4913 120.651 77.1003Z"
          fill="#36B4C9"
        />
        <path
          d="M125.05 79.5691C124.354 79.1781 123.244 79.1864 122.571 79.5882C121.898 79.99 121.916 80.6325 122.613 81.0243C123.308 81.4153 124.419 81.407 125.092 81.0052C125.765 80.6034 125.746 79.9601 125.05 79.5691Z"
          fill="#36B4C9"
        />
        <path
          d="M129.445 82.0456C128.748 81.6547 127.638 81.663 126.966 82.0647C126.293 82.4665 126.311 83.109 127.007 83.5009C127.703 83.8919 128.813 83.8827 129.485 83.4809C130.158 83.0792 130.14 82.4366 129.445 82.0456Z"
          fill="#36B4C9"
        />
        <path
          d="M133.842 84.514C133.147 84.123 132.037 84.1321 131.364 84.5339C130.691 84.9357 130.709 85.5782 131.405 85.9692C132.101 86.3602 133.211 86.3519 133.884 85.9501C134.557 85.5483 134.539 84.9058 133.842 84.514Z"
          fill="#36B4C9"
        />
        <path
          d="M138.241 86.9871C137.545 86.5961 136.435 86.6044 135.762 87.0061C135.089 87.4079 135.108 88.0513 135.804 88.4423C136.5 88.8333 137.61 88.825 138.283 88.4232C138.956 88.0214 138.937 87.378 138.241 86.9871Z"
          fill="#36B4C9"
        />
        <path
          d="M103.675 71.9441C102.978 71.5531 101.869 71.5614 101.196 71.9632C100.523 72.365 100.542 73.0075 101.237 73.3985C101.933 73.7895 103.042 73.7812 103.715 73.3794C104.389 72.9776 104.37 72.3351 103.675 71.9441Z"
          fill="#36B4C9"
        />
        <path
          d="M108.068 74.4166C107.373 74.0256 106.264 74.0339 105.59 74.4366C104.917 74.8383 104.936 75.4809 105.632 75.8719C106.328 76.2629 107.438 76.2546 108.11 75.8528C108.783 75.451 108.765 74.8085 108.068 74.4166Z"
          fill="#36B4C9"
        />
        <path
          d="M112.468 76.8894C111.772 76.4984 110.662 76.5067 109.989 76.9085C109.316 77.3103 109.335 77.9528 110.03 78.3438C110.726 78.7348 111.836 78.7265 112.508 78.3247C113.182 77.9229 113.163 77.2796 112.467 76.8886"
          fill="#36B4C9"
        />
        <path
          d="M116.862 79.3581C116.167 78.9672 115.057 78.9755 114.383 79.3772C113.71 79.779 113.729 80.4215 114.425 80.8125C115.121 81.2035 116.23 81.1952 116.903 80.7934C117.576 80.3917 117.557 79.7483 116.861 79.3573"
          fill="#36B4C9"
        />
        <path
          d="M121.261 81.8347C120.564 81.4437 119.455 81.452 118.782 81.8538C118.109 82.2556 118.128 82.8981 118.823 83.2891C119.519 83.6801 120.629 83.6718 121.301 83.27C121.975 82.8682 121.955 82.2249 121.26 81.8339"
          fill="#36B4C9"
        />
        <path
          d="M125.659 84.3035C124.963 83.9125 123.854 83.9208 123.18 84.3226C122.507 84.7243 122.526 85.3669 123.222 85.7578C123.917 86.1488 125.027 86.1405 125.7 85.7388C126.373 85.337 126.355 84.6944 125.659 84.3035Z"
          fill="#36B4C9"
        />
        <path
          d="M130.057 86.776C129.361 86.385 128.252 86.3933 127.579 86.7959C126.906 87.1977 126.925 87.8402 127.62 88.2312C128.317 88.6222 129.426 88.6139 130.098 88.2121C130.771 87.8104 130.753 87.1678 130.057 86.776Z"
          fill="#36B4C9"
        />
        <path
          d="M134.452 89.2488C133.756 88.8578 132.647 88.8661 131.973 89.2679C131.3 89.6696 131.319 90.3122 132.015 90.7032C132.71 91.0942 133.82 91.0859 134.493 90.6841C135.166 90.2823 135.147 89.6389 134.451 89.2479"
          fill="#36B4C9"
        />
        <path
          d="M99.886 74.2058C99.1895 73.8148 98.0796 73.8231 97.4072 74.2249C96.734 74.6267 96.7522 75.2692 97.4487 75.661C98.1444 76.052 99.2542 76.0429 99.9266 75.6411C100.6 75.2393 100.582 74.5968 99.886 74.2058Z"
          fill="#36B4C9"
        />
        <path
          d="M104.283 76.6781C103.588 76.2871 102.478 76.2962 101.805 76.698C101.133 77.0998 101.15 77.7423 101.846 78.1333C102.543 78.5243 103.652 78.516 104.325 78.1142C104.998 77.7124 104.98 77.0699 104.283 76.6781Z"
          fill="#36B4C9"
        />
        <path
          d="M108.679 79.1472C107.983 78.7562 106.872 78.7645 106.2 79.1663C105.527 79.5681 105.546 80.2114 106.241 80.6024C106.937 80.9934 108.048 80.9851 108.72 80.5833C109.393 80.1816 109.374 79.5382 108.679 79.1472Z"
          fill="#36B4C9"
        />
        <path
          d="M113.077 81.6238C112.381 81.2328 111.271 81.2411 110.598 81.6429C109.925 82.0446 109.944 82.688 110.64 83.079C111.335 83.47 112.446 83.4617 113.119 83.0599C113.792 82.6581 113.773 82.0148 113.077 81.6238Z"
          fill="#36B4C9"
        />
        <path
          d="M117.476 84.0925C116.779 83.7015 115.669 83.7098 114.997 84.1116C114.324 84.5134 114.342 85.1559 115.039 85.5477C115.734 85.9387 116.845 85.9304 117.517 85.5287C118.191 85.1269 118.171 84.4835 117.476 84.0925Z"
          fill="#36B4C9"
        />
        <path
          d="M121.87 86.5652C121.174 86.1742 120.064 86.1825 119.392 86.5843C118.718 86.9861 118.737 87.6286 119.433 88.0204C120.129 88.4114 121.239 88.4023 121.911 88.0005C122.584 87.5987 122.566 86.9562 121.87 86.5652Z"
          fill="#36B4C9"
        />
        <path
          d="M126.268 89.0374C125.572 88.6464 124.463 88.6556 123.79 89.0574C123.117 89.4591 123.135 90.1017 123.831 90.4926C124.527 90.8836 125.637 90.8753 126.31 90.4736C126.983 90.0718 126.965 89.4293 126.268 89.0374Z"
          fill="#36B4C9"
        />
        <path
          d="M130.667 91.5066C129.971 91.1156 128.861 91.1239 128.188 91.5257C127.515 91.9275 127.534 92.5708 128.23 92.9618C128.925 93.3528 130.036 93.3445 130.708 92.9427C131.382 92.5409 131.363 91.8976 130.667 91.5066Z"
          fill="#36B4C9"
        />
        <path
          d="M207.147 83.5066C206.45 83.1156 205.341 83.1239 204.669 83.5257C203.996 83.9275 204.014 84.57 204.71 84.9618C205.406 85.3528 206.515 85.3445 207.188 84.9419C207.862 84.5401 207.842 83.8976 207.147 83.5066Z"
          fill="#36B4C9"
        />
        <path
          d="M211.545 85.9753C210.85 85.5843 209.741 85.5926 209.067 85.9944C208.394 86.3962 208.412 87.0387 209.108 87.4297C209.805 87.8207 210.914 87.8124 211.587 87.4106C212.26 87.0089 212.241 86.3663 211.545 85.9753Z"
          fill="#36B4C9"
        />
        <path
          d="M215.94 88.4519C215.244 88.0609 214.134 88.0692 213.462 88.471C212.788 88.8728 212.807 89.5161 213.503 89.9071C214.199 90.2981 215.309 90.2898 215.982 89.888C216.655 89.4862 216.636 88.8437 215.94 88.4527"
          fill="#36B4C9"
        />
        <path
          d="M220.338 90.9206C219.642 90.5297 218.532 90.538 217.86 90.9397C217.187 91.3415 217.206 91.9849 217.902 92.3759C218.597 92.7669 219.707 92.7586 220.38 92.3568C221.054 91.955 221.034 91.3125 220.339 90.9215"
          fill="#36B4C9"
        />
        <path
          d="M224.737 93.3972C224.04 93.0062 222.931 93.0145 222.259 93.4163C221.586 93.8181 221.604 94.4606 222.3 94.8524C222.996 95.2434 224.106 95.2351 224.779 94.8333C225.452 94.4316 225.433 93.789 224.738 93.398"
          fill="#36B4C9"
        />
        <path
          d="M229.135 95.866C228.439 95.475 227.33 95.4833 226.657 95.8851C225.984 96.2868 226.002 96.9294 226.699 97.3212C227.394 97.7122 228.503 97.7039 229.177 97.3013C229.85 96.8995 229.831 96.257 229.135 95.866Z"
          fill="#36B4C9"
        />
        <path
          d="M233.53 98.3347C232.834 97.9437 231.725 97.952 231.052 98.3538C230.379 98.7556 230.397 99.3981 231.093 99.7891C231.789 100.18 232.898 100.172 233.571 99.77C234.244 99.3682 234.225 98.7257 233.53 98.3347Z"
          fill="#36B4C9"
        />
        <path
          d="M237.928 100.811C237.232 100.42 236.122 100.429 235.45 100.83C234.777 101.232 234.796 101.875 235.491 102.266C236.187 102.657 237.297 102.649 237.97 102.247C238.643 101.846 238.624 101.203 237.929 100.812"
          fill="#36B4C9"
        />
        <path
          d="M203.363 85.7644C202.666 85.3734 201.556 85.3817 200.884 85.7835C200.211 86.1853 200.229 86.8278 200.925 87.2196C201.621 87.6106 202.731 87.6015 203.403 87.1997C204.076 86.7979 204.058 86.1554 203.363 85.7644Z"
          fill="#36B4C9"
        />
        <path
          d="M207.756 88.2406C207.061 87.8496 205.951 87.8587 205.278 88.2605C204.605 88.6623 204.623 89.3048 205.319 89.6958C206.016 90.0868 207.125 90.0785 207.798 89.6767C208.471 89.2749 208.453 88.6324 207.756 88.2406Z"
          fill="#36B4C9"
        />
        <path
          d="M212.155 90.7097C211.46 90.3187 210.349 90.327 209.676 90.7288C209.003 91.1306 209.022 91.7739 209.718 92.1649C210.414 92.5559 211.524 92.5476 212.197 92.1458C212.87 91.7441 212.851 91.1007 212.155 90.7097Z"
          fill="#36B4C9"
        />
        <path
          d="M216.554 93.1824C215.858 92.7914 214.747 92.7997 214.075 93.2015C213.402 93.6032 213.421 94.2466 214.116 94.6376C214.812 95.0286 215.923 95.0203 216.595 94.6185C217.268 94.2167 217.249 93.5734 216.554 93.1824Z"
          fill="#36B4C9"
        />
        <path
          d="M220.948 95.655C220.252 95.264 219.142 95.2723 218.469 95.6741C217.797 96.0759 217.814 96.7184 218.511 97.1102C219.207 97.5012 220.317 97.4929 220.99 97.0911C221.663 96.6894 221.644 96.046 220.948 95.655Z"
          fill="#36B4C9"
        />
        <path
          d="M225.347 98.1277C224.65 97.7367 223.541 97.745 222.868 98.1468C222.195 98.5486 222.213 99.1911 222.91 99.5829C223.605 99.9739 224.715 99.9648 225.388 99.563C226.061 99.1612 226.043 98.5187 225.347 98.1277Z"
          fill="#36B4C9"
        />
        <path
          d="M229.745 100.6C229.049 100.209 227.939 100.218 227.267 100.62C226.593 101.022 226.612 101.664 227.307 102.055C228.004 102.446 229.114 102.438 229.786 102.036C230.459 101.634 230.441 100.992 229.745 100.6Z"
          fill="#36B4C9"
        />
        <path
          d="M234.14 103.069C233.444 102.678 232.333 102.686 231.661 103.088C230.988 103.49 231.007 104.133 231.702 104.524C232.398 104.915 233.509 104.907 234.181 104.505C234.854 104.103 234.835 103.46 234.14 103.069Z"
          fill="#36B4C9"
        />
        <path
          d="M199.573 88.03C198.876 87.639 197.767 87.6473 197.095 88.0491C196.421 88.4509 196.44 89.0934 197.136 89.4852C197.832 89.8762 198.941 89.8679 199.614 89.4653C200.287 89.0635 200.268 88.421 199.573 88.03Z"
          fill="#36B4C9"
        />
        <path
          d="M203.971 90.4988C203.276 90.1078 202.166 90.1161 201.493 90.5179C200.82 90.9196 200.838 91.5622 201.534 91.9532C202.23 92.3442 203.339 92.3359 204.013 91.9341C204.686 91.5323 204.667 90.8898 203.971 90.4988Z"
          fill="#36B4C9"
        />
        <path
          d="M208.369 92.9714C207.674 92.5804 206.564 92.5887 205.891 92.9905C205.218 93.3923 205.237 94.0357 205.933 94.4267C206.628 94.8176 207.738 94.8093 208.412 94.4076C209.085 94.0058 209.066 93.3633 208.37 92.9723"
          fill="#36B4C9"
        />
        <path
          d="M212.764 95.4441C212.068 95.0531 210.958 95.0614 210.286 95.4632C209.613 95.865 209.632 96.5083 210.327 96.8993C211.023 97.2903 212.133 97.282 212.806 96.8802C213.479 96.4784 213.46 95.8359 212.765 95.4449"
          fill="#36B4C9"
        />
        <path
          d="M217.162 97.9128C216.466 97.5218 215.357 97.5301 214.685 97.9319C214.011 98.3337 214.03 98.9762 214.726 99.368C215.422 99.759 216.532 99.7507 217.205 99.349C217.878 98.9472 217.859 98.3047 217.163 97.9137"
          fill="#36B4C9"
        />
        <path
          d="M221.557 100.389C220.861 99.9984 219.751 100.007 219.079 100.408C218.406 100.81 218.424 101.453 219.121 101.845C219.816 102.236 220.925 102.227 221.599 101.825C222.272 101.423 222.253 100.78 221.557 100.389Z"
          fill="#36B4C9"
        />
        <path
          d="M225.956 102.858C225.26 102.467 224.151 102.475 223.478 102.877C222.804 103.279 222.823 103.922 223.518 104.313C224.215 104.704 225.324 104.695 225.997 104.293C226.67 103.892 226.651 103.249 225.956 102.858Z"
          fill="#36B4C9"
        />
        <path
          d="M230.354 105.331C229.658 104.94 228.548 104.948 227.876 105.35C227.202 105.752 227.221 106.395 227.917 106.786C228.613 107.177 229.723 107.169 230.396 106.767C231.069 106.365 231.05 105.723 230.354 105.332"
          fill="#36B4C9"
        />
        <path
          d="M195.788 90.2878C195.092 89.8968 193.983 89.9051 193.31 90.3069C192.636 90.7087 192.655 91.3512 193.351 91.743C194.047 92.134 195.157 92.1249 195.829 91.7231C196.502 91.3213 196.484 90.6788 195.788 90.2878Z"
          fill="#36B4C9"
        />
        <path
          d="M200.182 92.7604C199.486 92.3694 198.377 92.3777 197.704 92.7803C197.031 93.1821 197.049 93.8246 197.745 94.2156C198.441 94.6066 199.55 94.5983 200.224 94.1965C200.897 93.7947 200.879 93.1522 200.182 92.7604Z"
          fill="#36B4C9"
        />
        <path
          d="M204.581 95.2331C203.885 94.8422 202.775 94.8505 202.102 95.2522C201.429 95.654 201.448 96.2974 202.144 96.6884C202.839 97.0794 203.95 97.0711 204.622 96.6693C205.296 96.2675 205.277 95.6241 204.581 95.2331Z"
          fill="#36B4C9"
        />
        <path
          d="M208.979 97.7019C208.284 97.3109 207.174 97.3192 206.501 97.721C205.827 98.1228 205.846 98.7661 206.542 99.1571C207.238 99.5481 208.349 99.5398 209.021 99.138C209.694 98.7362 209.675 98.0929 208.979 97.7019Z"
          fill="#36B4C9"
        />
        <path
          d="M213.374 100.178C212.678 99.7875 211.569 99.7958 210.895 100.198C210.222 100.599 210.241 101.242 210.937 101.634C211.633 102.025 212.743 102.016 213.416 101.615C214.089 101.213 214.07 100.569 213.374 100.178Z"
          fill="#36B4C9"
        />
        <path
          d="M217.773 102.647C217.076 102.256 215.967 102.265 215.294 102.666C214.621 103.068 214.639 103.711 215.335 104.102C216.031 104.493 217.141 104.484 217.813 104.082C218.487 103.681 218.468 103.038 217.773 102.647Z"
          fill="#36B4C9"
        />
        <path
          d="M222.17 105.12C221.475 104.729 220.366 104.737 219.692 105.14C219.019 105.541 219.037 106.184 219.733 106.575C220.43 106.966 221.54 106.958 222.212 106.556C222.885 106.154 222.867 105.512 222.17 105.12Z"
          fill="#36B4C9"
        />
        <path
          d="M226.565 107.593C225.87 107.202 224.76 107.21 224.087 107.612C223.413 108.013 223.432 108.657 224.128 109.048C224.824 109.439 225.934 109.43 226.607 109.029C227.28 108.627 227.261 107.984 226.565 107.593Z"
          fill="#36B4C9"
        />
        <path
          d="M191.999 92.5496C191.303 92.1586 190.193 92.1669 189.52 92.5686C188.847 92.9704 188.866 93.613 189.562 94.0048C190.258 94.3958 191.367 94.3875 192.04 93.9848C192.713 93.5831 192.695 92.9405 191.999 92.5496Z"
          fill="#36B4C9"
        />
        <path
          d="M196.397 95.0218C195.701 94.6308 194.591 94.6399 193.919 95.0417C193.246 95.4435 193.264 96.086 193.96 96.477C194.656 96.868 195.765 96.8597 196.438 96.4579C197.112 96.0561 197.093 95.4136 196.397 95.0218Z"
          fill="#36B4C9"
        />
        <path
          d="M200.792 97.491C200.096 97.1 198.986 97.1083 198.313 97.5101C197.64 97.9118 197.659 98.5552 198.355 98.9462C199.05 99.3372 200.16 99.3289 200.833 98.9271C201.507 98.5253 201.488 97.8819 200.792 97.491Z"
          fill="#36B4C9"
        />
        <path
          d="M205.19 99.9675C204.495 99.5765 203.384 99.5848 202.712 99.9866C202.038 100.388 202.057 101.032 202.753 101.423C203.449 101.814 204.559 101.805 205.232 101.404C205.905 101.002 205.886 100.359 205.19 99.9675Z"
          fill="#36B4C9"
        />
        <path
          d="M209.589 102.436C208.893 102.045 207.783 102.054 207.11 102.455C206.437 102.857 206.455 103.5 207.152 103.891C207.847 104.282 208.957 104.274 209.631 103.872C210.304 103.471 210.285 102.827 209.589 102.436Z"
          fill="#36B4C9"
        />
        <path
          d="M213.988 104.909C213.291 104.518 212.181 104.526 211.509 104.928C210.836 105.33 210.854 105.972 211.55 106.364C212.246 106.755 213.355 106.747 214.028 106.344C214.701 105.942 214.683 105.3 213.988 104.909Z"
          fill="#36B4C9"
        />
        <path
          d="M218.381 107.381C217.686 106.99 216.576 106.999 215.903 107.401C215.23 107.803 215.248 108.445 215.944 108.836C216.641 109.227 217.75 109.219 218.423 108.817C219.096 108.416 219.078 107.773 218.381 107.381Z"
          fill="#36B4C9"
        />
        <path
          d="M222.78 109.85C222.085 109.459 220.974 109.468 220.301 109.869C219.628 110.271 219.647 110.915 220.343 111.306C221.039 111.697 222.148 111.688 222.822 111.286C223.495 110.885 223.476 110.241 222.78 109.85Z"
          fill="#36B4C9"
        />
        <path
          d="M188.21 94.8113C187.513 94.4203 186.404 94.4286 185.731 94.8304C185.058 95.2321 185.077 95.8747 185.773 96.2657C186.468 96.6567 187.577 96.6484 188.251 96.2466C188.924 95.8448 188.906 95.2023 188.21 94.8113Z"
          fill="#36B4C9"
        />
        <path
          d="M192.607 97.2799C191.912 96.8889 190.803 96.8972 190.13 97.2998C189.456 97.7016 189.475 98.3441 190.171 98.7351C190.868 99.1261 191.977 99.1178 192.649 98.716C193.322 98.3143 193.304 97.6717 192.607 97.2799Z"
          fill="#36B4C9"
        />
        <path
          d="M197.007 99.7527C196.311 99.3617 195.201 99.37 194.528 99.7718C193.855 100.174 193.874 100.816 194.569 101.207C195.265 101.598 196.375 101.59 197.047 101.188C197.721 100.786 197.702 100.143 197.006 99.7518"
          fill="#36B4C9"
        />
        <path
          d="M201.405 102.225C200.71 101.834 199.6 101.843 198.926 102.244C198.253 102.646 198.272 103.289 198.968 103.68C199.664 104.071 200.773 104.062 201.446 103.661C202.119 103.259 202.1 102.615 201.404 102.225"
          fill="#36B4C9"
        />
        <path
          d="M205.8 104.698C205.103 104.307 203.994 104.315 203.321 104.717C202.648 105.119 202.667 105.761 203.362 106.152C204.058 106.543 205.168 106.535 205.84 106.133C206.514 105.732 206.495 105.088 205.799 104.697"
          fill="#36B4C9"
        />
        <path
          d="M210.198 107.171C209.502 106.78 208.393 106.788 207.719 107.19C207.046 107.592 207.065 108.234 207.761 108.625C208.457 109.016 209.566 109.008 210.239 108.606C210.912 108.204 210.894 107.562 210.198 107.171Z"
          fill="#36B4C9"
        />
        <path
          d="M214.596 109.639C213.9 109.248 212.791 109.257 212.118 109.659C211.445 110.061 211.464 110.704 212.159 111.095C212.856 111.486 213.965 111.477 214.637 111.075C215.311 110.674 215.292 110.031 214.596 109.639Z"
          fill="#36B4C9"
        />
        <path
          d="M218.991 112.112C218.295 111.721 217.186 111.729 216.512 112.131C215.839 112.533 215.858 113.175 216.554 113.566C217.25 113.957 218.359 113.949 219.032 113.547C219.705 113.146 219.686 112.502 218.99 112.111"
          fill="#36B4C9"
        />
        <path
          d="M184.425 97.0691C183.728 96.6781 182.618 96.6864 181.946 97.0882C181.274 97.49 181.291 98.1325 181.987 98.5243C182.683 98.9153 183.793 98.9062 184.465 98.5044C185.139 98.1026 185.12 97.4601 184.425 97.0691Z"
          fill="#36B4C9"
        />
        <path
          d="M188.823 99.5413C188.127 99.1503 187.017 99.1595 186.345 99.5613C185.672 99.963 185.69 100.606 186.385 100.997C187.082 101.388 188.191 101.379 188.864 100.977C189.537 100.576 189.519 99.9332 188.823 99.5413Z"
          fill="#36B4C9"
        />
        <path
          d="M193.218 102.014C192.522 101.623 191.411 101.632 190.739 102.033C190.066 102.435 190.085 103.079 190.78 103.47C191.476 103.861 192.587 103.852 193.259 103.451C193.932 103.049 193.913 102.405 193.218 102.014Z"
          fill="#36B4C9"
        />
        <path
          d="M197.616 104.483C196.92 104.092 195.81 104.1 195.137 104.502C194.464 104.904 194.483 105.547 195.179 105.938C195.875 106.329 196.985 106.321 197.658 105.919C198.331 105.517 198.312 104.874 197.616 104.483Z"
          fill="#36B4C9"
        />
        <path
          d="M202.015 106.96C201.318 106.569 200.208 106.577 199.536 106.979C198.863 107.381 198.881 108.023 199.577 108.415C200.273 108.806 201.384 108.798 202.056 108.396C202.729 107.994 202.71 107.351 202.015 106.96Z"
          fill="#36B4C9"
        />
        <path
          d="M206.413 109.428C205.717 109.037 204.607 109.046 203.935 109.448C203.261 109.849 203.28 110.492 203.976 110.884C204.672 111.275 205.782 111.266 206.454 110.864C207.126 110.462 207.109 109.819 206.413 109.428Z"
          fill="#36B4C9"
        />
        <path
          d="M210.807 111.901C210.111 111.51 209.002 111.519 208.329 111.921C207.656 112.322 207.674 112.965 208.37 113.356C209.066 113.747 210.176 113.739 210.849 113.337C211.522 112.935 211.504 112.293 210.807 111.901Z"
          fill="#36B4C9"
        />
        <path
          d="M215.206 114.374C214.51 113.983 213.4 113.991 212.727 114.393C212.054 114.795 212.073 115.438 212.769 115.829C213.464 116.22 214.575 116.212 215.247 115.81C215.921 115.408 215.902 114.765 215.206 114.374Z"
          fill="#36B4C9"
        />
        <path
          d="M180.64 99.3308C179.943 98.9398 178.834 98.9481 178.161 99.3499C177.488 99.7517 177.507 100.394 178.202 100.785C178.898 101.176 180.007 101.168 180.68 100.766C181.353 100.364 181.335 99.7218 180.64 99.3308Z"
          fill="#36B4C9"
        />
        <path
          d="M185.033 101.803C184.338 101.412 183.229 101.421 182.555 101.823C181.882 102.225 181.901 102.868 182.597 103.259C183.293 103.65 184.402 103.641 185.075 103.239C185.748 102.838 185.73 102.195 185.033 101.803Z"
          fill="#36B4C9"
        />
        <path
          d="M189.433 104.272C188.737 103.881 187.627 103.89 186.954 104.291C186.281 104.693 186.3 105.336 186.995 105.727C187.691 106.118 188.801 106.109 189.473 105.707C190.146 105.306 190.127 104.662 189.432 104.271"
          fill="#36B4C9"
        />
        <path
          d="M193.831 106.749C193.135 106.358 192.025 106.366 191.352 106.768C190.679 107.17 190.698 107.812 191.394 108.203C192.089 108.594 193.199 108.586 193.872 108.184C194.545 107.782 194.526 107.139 193.83 106.748"
          fill="#36B4C9"
        />
        <path
          d="M198.225 109.218C197.529 108.827 196.42 108.835 195.747 109.237C195.074 109.638 195.093 110.281 195.788 110.672C196.484 111.063 197.594 111.055 198.266 110.653C198.939 110.251 198.92 109.608 198.225 109.217"
          fill="#36B4C9"
        />
        <path
          d="M202.624 111.694C201.927 111.303 200.818 111.311 200.145 111.713C199.472 112.115 199.491 112.757 200.187 113.148C200.882 113.539 201.991 113.531 202.665 113.129C203.338 112.728 203.32 112.085 202.624 111.694Z"
          fill="#36B4C9"
        />
        <path
          d="M207.022 114.163C206.326 113.772 205.217 113.78 204.544 114.183C203.87 114.584 203.889 115.227 204.585 115.618C205.282 116.009 206.391 116.001 207.063 115.599C207.736 115.197 207.718 114.555 207.022 114.163Z"
          fill="#36B4C9"
        />
        <path
          d="M211.417 116.635C210.721 116.244 209.611 116.253 208.938 116.655C208.265 117.056 208.284 117.699 208.98 118.09C209.675 118.481 210.785 118.473 211.458 118.071C212.131 117.669 212.112 117.026 211.416 116.635"
          fill="#36B4C9"
        />
        <path
          d="M176.851 101.593C176.154 101.202 175.044 101.21 174.372 101.612C173.699 102.013 173.717 102.656 174.414 103.048C175.109 103.439 176.219 103.43 176.891 103.028C177.565 102.626 177.546 101.984 176.851 101.593Z"
          fill="#36B4C9"
        />
        <path
          d="M181.249 104.061C180.553 103.67 179.443 103.679 178.771 104.081C178.097 104.483 178.116 105.125 178.811 105.516C179.508 105.907 180.617 105.899 181.29 105.497C181.963 105.095 181.945 104.453 181.249 104.061Z"
          fill="#36B4C9"
        />
        <path
          d="M185.643 106.538C184.948 106.147 183.837 106.155 183.165 106.557C182.491 106.959 182.511 107.602 183.206 107.993C183.902 108.384 185.013 108.376 185.685 107.974C186.358 107.572 186.339 106.929 185.643 106.538Z"
          fill="#36B4C9"
        />
        <path
          d="M190.042 109.007C189.346 108.616 188.236 108.624 187.563 109.026C186.89 109.427 186.909 110.071 187.605 110.462C188.3 110.853 189.411 110.844 190.083 110.443C190.757 110.041 190.738 109.398 190.042 109.007Z"
          fill="#36B4C9"
        />
        <path
          d="M194.441 111.479C193.744 111.088 192.634 111.097 191.962 111.498C191.289 111.9 191.307 112.543 192.003 112.934C192.699 113.325 193.81 113.317 194.482 112.915C195.155 112.514 195.136 111.87 194.441 111.479Z"
          fill="#36B4C9"
        />
        <path
          d="M198.839 113.952C198.143 113.561 197.033 113.569 196.36 113.971C195.687 114.373 195.705 115.015 196.402 115.407C197.097 115.798 198.207 115.789 198.88 115.387C199.553 114.985 199.535 114.343 198.839 113.952Z"
          fill="#36B4C9"
        />
        <path
          d="M203.233 116.42C202.537 116.029 201.427 116.038 200.755 116.44C200.082 116.842 200.1 117.484 200.796 117.875C201.492 118.266 202.602 118.258 203.274 117.856C203.948 117.455 203.929 116.812 203.233 116.42Z"
          fill="#36B4C9"
        />
        <path
          d="M207.632 118.897C206.936 118.506 205.825 118.515 205.153 118.916C204.48 119.318 204.499 119.961 205.194 120.352C205.89 120.743 207.001 120.735 207.673 120.333C208.346 119.932 208.327 119.288 207.632 118.897Z"
          fill="#36B4C9"
        />
        <path
          d="M125.135 114.503C124.439 114.112 123.329 114.12 122.657 114.522C121.984 114.924 122.003 115.567 122.698 115.958C123.394 116.349 124.504 116.341 125.177 115.939C125.85 115.537 125.831 114.894 125.136 114.504"
          fill="#36B4C9"
        />
        <path
          d="M129.534 116.975C128.837 116.584 127.728 116.593 127.056 116.994C126.382 117.396 126.401 118.039 127.097 118.431C127.793 118.822 128.902 118.813 129.575 118.411C130.248 118.009 130.229 117.366 129.534 116.975Z"
          fill="#36B4C9"
        />
        <path
          d="M133.928 119.444C133.232 119.053 132.123 119.062 131.45 119.463C130.777 119.865 130.795 120.508 131.492 120.9C132.187 121.291 133.296 121.282 133.97 120.88C134.643 120.478 134.624 119.835 133.928 119.444Z"
          fill="#36B4C9"
        />
        <path
          d="M138.326 121.921C137.631 121.53 136.521 121.538 135.848 121.94C135.175 122.342 135.194 122.985 135.89 123.376C136.586 123.767 137.695 123.759 138.369 123.357C139.042 122.955 139.023 122.312 138.327 121.921"
          fill="#36B4C9"
        />
        <path
          d="M142.725 124.389C142.029 123.998 140.919 124.007 140.247 124.408C139.574 124.81 139.593 125.454 140.288 125.845C140.984 126.236 142.094 126.227 142.767 125.826C143.44 125.424 143.421 124.781 142.726 124.39"
          fill="#36B4C9"
        />
        <path
          d="M147.123 126.862C146.427 126.471 145.318 126.479 144.645 126.881C143.972 127.283 143.991 127.926 144.687 128.317C145.382 128.708 146.492 128.7 147.165 128.298C147.839 127.896 147.82 127.254 147.124 126.863"
          fill="#36B4C9"
        />
        <path
          d="M151.518 129.335C150.821 128.944 149.712 128.952 149.04 129.354C148.367 129.756 148.385 130.398 149.082 130.79C149.777 131.181 150.886 131.173 151.559 130.77C152.233 130.368 152.214 129.726 151.518 129.335Z"
          fill="#36B4C9"
        />
        <path
          d="M155.916 131.807C155.22 131.416 154.111 131.425 153.438 131.826C152.765 132.228 152.783 132.871 153.48 133.263C154.176 133.654 155.285 133.645 155.958 133.243C156.631 132.841 156.612 132.198 155.916 131.807Z"
          fill="#36B4C9"
        />
        <path
          d="M160.311 134.28C159.615 133.889 158.506 133.897 157.833 134.299C157.16 134.701 157.178 135.343 157.874 135.734C158.57 136.125 159.679 136.117 160.353 135.715C161.026 135.314 161.007 134.671 160.311 134.28Z"
          fill="#36B4C9"
        />
        <path
          d="M164.709 136.749C164.013 136.358 162.904 136.366 162.231 136.768C161.558 137.17 161.577 137.813 162.273 138.204C162.968 138.595 164.078 138.587 164.751 138.185C165.425 137.783 165.406 137.141 164.71 136.75"
          fill="#36B4C9"
        />
        <path
          d="M169.107 139.221C168.412 138.83 167.302 138.839 166.63 139.241C165.956 139.642 165.975 140.286 166.671 140.677C167.367 141.068 168.477 141.059 169.15 140.658C169.823 140.256 169.804 139.613 169.108 139.222"
          fill="#36B4C9"
        />
        <path
          d="M173.506 141.694C172.81 141.303 171.701 141.311 171.028 141.713C170.355 142.115 170.373 142.757 171.07 143.149C171.765 143.54 172.875 143.532 173.549 143.13C174.222 142.728 174.203 142.086 173.507 141.695"
          fill="#36B4C9"
        />
        <path
          d="M177.901 144.167C177.204 143.776 176.095 143.784 175.423 144.186C174.75 144.588 174.768 145.23 175.464 145.622C176.16 146.013 177.269 146.005 177.942 145.602C178.616 145.2 178.596 144.558 177.901 144.167Z"
          fill="#36B4C9"
        />
        <path
          d="M182.299 146.639C181.604 146.248 180.495 146.257 179.821 146.658C179.148 147.06 179.166 147.703 179.862 148.094C180.559 148.485 181.668 148.476 182.341 148.075C183.014 147.673 182.995 147.03 182.299 146.639Z"
          fill="#36B4C9"
        />
        <path
          d="M186.697 149.108C186.002 148.717 184.892 148.725 184.219 149.127C183.546 149.529 183.565 150.172 184.261 150.563C184.957 150.954 186.066 150.946 186.74 150.544C187.413 150.142 187.394 149.5 186.698 149.109"
          fill="#36B4C9"
        />
        <path
          d="M121.347 116.764C120.651 116.373 119.54 116.382 118.868 116.783C118.195 117.185 118.214 117.829 118.909 118.22C119.605 118.611 120.716 118.602 121.388 118.201C122.061 117.799 122.042 117.155 121.347 116.764Z"
          fill="#36B4C9"
        />
        <path
          d="M125.745 119.233C125.049 118.842 123.939 118.85 123.267 119.252C122.593 119.654 122.612 120.297 123.308 120.688C124.004 121.079 125.114 121.07 125.786 120.668C126.459 120.267 126.441 119.624 125.745 119.233Z"
          fill="#36B4C9"
        />
        <path
          d="M130.143 121.71C129.447 121.318 128.337 121.327 127.665 121.729C126.992 122.131 127.01 122.773 127.706 123.165C128.402 123.556 129.512 123.547 130.184 123.145C130.857 122.744 130.839 122.101 130.143 121.71Z"
          fill="#36B4C9"
        />
        <path
          d="M134.538 124.178C133.842 123.787 132.732 123.796 132.059 124.198C131.386 124.599 131.405 125.243 132.101 125.634C132.797 126.025 133.907 126.016 134.58 125.615C135.253 125.213 135.234 124.57 134.538 124.178Z"
          fill="#36B4C9"
        />
        <path
          d="M138.936 126.651C138.241 126.26 137.13 126.268 136.458 126.67C135.784 127.072 135.804 127.715 136.499 128.106C137.195 128.497 138.306 128.489 138.978 128.087C139.651 127.685 139.632 127.042 138.936 126.651Z"
          fill="#36B4C9"
        />
        <path
          d="M143.335 129.124C142.639 128.733 141.529 128.741 140.856 129.143C140.183 129.545 140.202 130.188 140.898 130.579C141.593 130.97 142.703 130.962 143.376 130.56C144.05 130.158 144.031 129.515 143.335 129.124Z"
          fill="#36B4C9"
        />
        <path
          d="M147.73 131.593C147.033 131.202 145.923 131.21 145.251 131.612C144.578 132.013 144.596 132.656 145.292 133.048C145.988 133.439 147.098 133.43 147.77 133.028C148.444 132.626 148.425 131.984 147.73 131.593Z"
          fill="#36B4C9"
        />
        <path
          d="M152.128 134.069C151.432 133.678 150.322 133.686 149.649 134.088C148.976 134.49 148.994 135.132 149.691 135.524C150.387 135.915 151.496 135.906 152.169 135.504C152.842 135.103 152.824 134.46 152.128 134.069Z"
          fill="#36B4C9"
        />
        <path
          d="M156.526 136.537C155.83 136.146 154.72 136.156 154.048 136.557C153.375 136.959 153.393 137.602 154.088 137.993C154.785 138.384 155.894 138.375 156.567 137.974C157.24 137.572 157.222 136.929 156.526 136.537Z"
          fill="#36B4C9"
        />
        <path
          d="M160.925 139.01C160.229 138.619 159.118 138.628 158.446 139.03C157.773 139.431 157.792 140.075 158.487 140.466C159.183 140.857 160.294 140.848 160.966 140.447C161.639 140.045 161.62 139.401 160.925 139.01Z"
          fill="#36B4C9"
        />
        <path
          d="M165.319 141.483C164.624 141.092 163.513 141.1 162.84 141.502C162.167 141.904 162.186 142.547 162.882 142.938C163.578 143.329 164.688 143.321 165.361 142.919C166.034 142.517 166.015 141.874 165.319 141.483Z"
          fill="#36B4C9"
        />
        <path
          d="M169.718 143.956C169.022 143.565 167.912 143.573 167.239 143.975C166.566 144.377 166.584 145.019 167.281 145.411C167.976 145.802 169.087 145.794 169.76 145.392C170.433 144.99 170.414 144.347 169.718 143.956Z"
          fill="#36B4C9"
        />
        <path
          d="M174.116 146.428C173.42 146.037 172.31 146.046 171.638 146.448C170.964 146.849 170.983 147.492 171.679 147.884C172.375 148.275 173.485 148.266 174.157 147.864C174.83 147.462 174.812 146.819 174.116 146.428Z"
          fill="#36B4C9"
        />
        <path
          d="M178.51 148.897C177.815 148.506 176.705 148.515 176.032 148.917C175.359 149.319 175.377 149.961 176.073 150.352C176.769 150.743 177.879 150.735 178.552 150.333C179.225 149.931 179.207 149.289 178.51 148.897Z"
          fill="#36B4C9"
        />
        <path
          d="M182.909 151.37C182.213 150.979 181.102 150.987 180.43 151.389C179.758 151.791 179.776 152.434 180.472 152.825C181.167 153.216 182.278 153.208 182.95 152.806C183.624 152.404 183.604 151.761 182.909 151.37Z"
          fill="#36B4C9"
        />
        <path
          d="M117.561 119.022C116.865 118.631 115.755 118.64 115.083 119.041C114.409 119.443 114.429 120.086 115.124 120.477C115.82 120.868 116.93 120.86 117.603 120.458C118.276 120.057 118.257 119.414 117.561 119.023"
          fill="#36B4C9"
        />
        <path
          d="M121.959 121.499C121.263 121.108 120.154 121.116 119.481 121.518C118.808 121.92 118.826 122.562 119.523 122.954C120.219 123.345 121.328 123.337 122.001 122.934C122.674 122.532 122.655 121.89 121.959 121.499Z"
          fill="#36B4C9"
        />
        <path
          d="M126.354 123.968C125.657 123.576 124.548 123.585 123.876 123.987C123.203 124.389 123.221 125.031 123.917 125.423C124.613 125.814 125.722 125.806 126.395 125.403C127.069 125.001 127.05 124.359 126.354 123.968Z"
          fill="#36B4C9"
        />
        <path
          d="M130.752 126.44C130.056 126.049 128.946 126.057 128.274 126.459C127.601 126.861 127.62 127.504 128.316 127.895C129.012 128.286 130.121 128.278 130.794 127.876C131.468 127.475 131.449 126.832 130.753 126.441"
          fill="#36B4C9"
        />
        <path
          d="M135.15 128.913C134.455 128.522 133.345 128.53 132.673 128.932C131.999 129.334 132.018 129.977 132.714 130.368C133.41 130.759 134.52 130.751 135.193 130.349C135.866 129.947 135.847 129.305 135.151 128.914"
          fill="#36B4C9"
        />
        <path
          d="M139.549 131.382C138.853 130.991 137.743 130.999 137.071 131.401C136.398 131.802 136.417 132.446 137.112 132.837C137.808 133.228 138.918 133.219 139.591 132.818C140.264 132.416 140.245 131.773 139.55 131.382"
          fill="#36B4C9"
        />
        <path
          d="M143.944 133.858C143.247 133.467 142.138 133.475 141.466 133.877C140.793 134.279 140.811 134.922 141.507 135.313C142.203 135.704 143.312 135.696 143.985 135.293C144.658 134.892 144.639 134.249 143.944 133.858Z"
          fill="#36B4C9"
        />
        <path
          d="M148.342 136.327C147.646 135.936 146.537 135.944 145.864 136.346C145.191 136.748 145.209 137.39 145.906 137.782C146.601 138.173 147.71 138.165 148.384 137.762C149.057 137.36 149.038 136.718 148.342 136.327Z"
          fill="#36B4C9"
        />
        <path
          d="M152.737 138.8C152.041 138.409 150.932 138.417 150.259 138.819C149.586 139.22 149.604 139.863 150.3 140.254C150.996 140.645 152.105 140.637 152.778 140.235C153.452 139.833 153.432 139.191 152.737 138.8Z"
          fill="#36B4C9"
        />
        <path
          d="M157.135 141.272C156.439 140.881 155.329 140.89 154.657 141.291C153.984 141.693 154.003 142.336 154.698 142.727C155.394 143.118 156.504 143.11 157.177 142.708C157.85 142.307 157.831 141.664 157.136 141.273"
          fill="#36B4C9"
        />
        <path
          d="M161.533 143.745C160.838 143.354 159.728 143.362 159.055 143.764C158.382 144.166 158.401 144.809 159.097 145.2C159.792 145.591 160.902 145.583 161.576 145.181C162.249 144.779 162.23 144.137 161.534 143.746"
          fill="#36B4C9"
        />
        <path
          d="M165.932 146.218C165.236 145.827 164.126 145.835 163.454 146.237C162.781 146.638 162.799 147.281 163.496 147.673C164.191 148.064 165.301 148.055 165.974 147.654C166.648 147.252 166.628 146.609 165.933 146.218"
          fill="#36B4C9"
        />
        <path
          d="M170.327 148.686C169.63 148.295 168.521 148.304 167.849 148.705C167.175 149.107 167.194 149.75 167.89 150.141C168.586 150.532 169.695 150.524 170.368 150.122C171.041 149.72 171.022 149.077 170.327 148.686Z"
          fill="#36B4C9"
        />
        <path
          d="M174.725 151.159C174.029 150.768 172.92 150.776 172.247 151.178C171.574 151.58 171.592 152.222 172.288 152.613C172.984 153.004 174.093 152.996 174.767 152.594C175.44 152.192 175.421 151.55 174.725 151.159Z"
          fill="#36B4C9"
        />
        <path
          d="M179.123 153.632C178.427 153.241 177.318 153.249 176.645 153.651C175.972 154.052 175.991 154.696 176.687 155.087C177.382 155.478 178.492 155.469 179.165 155.068C179.839 154.666 179.82 154.023 179.124 153.632"
          fill="#36B4C9"
        />
        <path
          d="M113.772 121.284C113.077 120.893 111.967 120.901 111.294 121.303C110.62 121.705 110.639 122.348 111.335 122.739C112.031 123.13 113.141 123.122 113.814 122.72C114.487 122.318 114.468 121.675 113.772 121.284Z"
          fill="#36B4C9"
        />
        <path
          d="M118.171 123.757C117.475 123.366 116.366 123.374 115.692 123.776C115.019 124.177 115.037 124.82 115.734 125.212C116.43 125.603 117.539 125.594 118.212 125.192C118.885 124.79 118.867 124.148 118.171 123.757Z"
          fill="#36B4C9"
        />
        <path
          d="M122.57 126.23C121.873 125.838 120.764 125.847 120.091 126.249C119.418 126.65 119.436 127.293 120.132 127.685C120.828 128.076 121.938 128.067 122.61 127.665C123.283 127.263 123.265 126.621 122.57 126.23Z"
          fill="#36B4C9"
        />
        <path
          d="M126.964 128.702C126.268 128.311 125.158 128.319 124.485 128.721C123.812 129.123 123.831 129.766 124.527 130.157C125.223 130.548 126.333 130.54 127.005 130.138C127.679 129.736 127.66 129.094 126.964 128.702Z"
          fill="#36B4C9"
        />
        <path
          d="M131.362 131.171C130.667 130.78 129.557 130.788 128.883 131.19C128.21 131.592 128.229 132.235 128.925 132.626C129.621 133.017 130.731 133.009 131.404 132.607C132.077 132.205 132.058 131.562 131.362 131.171Z"
          fill="#36B4C9"
        />
        <path
          d="M135.761 133.647C135.065 133.256 133.955 133.265 133.282 133.666C132.609 134.068 132.628 134.711 133.323 135.102C134.019 135.493 135.129 135.485 135.802 135.083C136.475 134.682 136.456 134.038 135.761 133.647Z"
          fill="#36B4C9"
        />
        <path
          d="M140.155 136.116C139.459 135.725 138.35 135.733 137.677 136.135C137.003 136.537 137.022 137.179 137.718 137.571C138.414 137.962 139.524 137.953 140.196 137.551C140.869 137.149 140.851 136.507 140.155 136.116Z"
          fill="#36B4C9"
        />
        <path
          d="M144.554 138.589C143.857 138.198 142.748 138.206 142.075 138.608C141.402 139.009 141.42 139.652 142.117 140.044C142.812 140.435 143.922 140.426 144.595 140.024C145.268 139.622 145.25 138.98 144.554 138.589Z"
          fill="#36B4C9"
        />
        <path
          d="M148.952 141.061C148.256 140.67 147.147 140.678 146.474 141.081C145.8 141.483 145.819 142.125 146.514 142.516C147.211 142.907 148.32 142.899 148.993 142.497C149.666 142.096 149.648 141.453 148.952 141.061Z"
          fill="#36B4C9"
        />
        <path
          d="M153.351 143.53C152.655 143.139 151.545 143.147 150.872 143.549C150.199 143.951 150.218 144.594 150.913 144.985C151.609 145.376 152.72 145.368 153.392 144.966C154.065 144.564 154.046 143.921 153.351 143.53Z"
          fill="#36B4C9"
        />
        <path
          d="M157.745 146.007C157.049 145.616 155.94 145.624 155.266 146.026C154.593 146.427 154.612 147.071 155.308 147.462C156.003 147.853 157.114 147.844 157.787 147.443C158.46 147.041 158.441 146.398 157.745 146.007Z"
          fill="#36B4C9"
        />
        <path
          d="M162.144 148.475C161.447 148.084 160.338 148.093 159.665 148.494C158.992 148.896 159.01 149.539 159.707 149.931C160.402 150.322 161.513 150.313 162.185 149.911C162.859 149.51 162.839 148.866 162.144 148.475Z"
          fill="#36B4C9"
        />
        <path
          d="M166.542 150.948C165.846 150.557 164.737 150.565 164.063 150.967C163.39 151.369 163.408 152.011 164.105 152.403C164.801 152.794 165.91 152.785 166.583 152.383C167.256 151.982 167.238 151.339 166.542 150.948Z"
          fill="#36B4C9"
        />
        <path
          d="M170.936 153.421C170.24 153.03 169.131 153.038 168.458 153.44C167.785 153.842 167.803 154.485 168.499 154.876C169.195 155.267 170.305 155.258 170.978 154.857C171.651 154.455 171.632 153.812 170.936 153.421Z"
          fill="#36B4C9"
        />
        <path
          d="M175.335 155.889C174.639 155.498 173.529 155.507 172.856 155.908C172.183 156.31 172.202 156.954 172.898 157.345C173.593 157.736 174.704 157.727 175.376 157.326C176.05 156.924 176.031 156.28 175.335 155.889Z"
          fill="#36B4C9"
        />
        <path
          d="M109.987 123.546C109.292 123.155 108.181 123.163 107.508 123.565C106.835 123.967 106.854 124.61 107.55 125.001C108.246 125.392 109.355 125.384 110.029 124.982C110.702 124.58 110.683 123.937 109.987 123.546Z"
          fill="#36B4C9"
        />
        <path
          d="M114.386 126.018C113.689 125.627 112.58 125.636 111.907 126.037C111.234 126.439 111.252 127.082 111.949 127.474C112.644 127.865 113.753 127.856 114.427 127.454C115.1 127.052 115.082 126.409 114.386 126.018Z"
          fill="#36B4C9"
        />
        <path
          d="M118.78 128.491C118.084 128.099 116.974 128.109 116.302 128.51C115.628 128.912 115.647 129.555 116.343 129.946C117.039 130.337 118.148 130.329 118.821 129.927C119.494 129.525 119.476 128.882 118.78 128.491Z"
          fill="#36B4C9"
        />
        <path
          d="M123.179 130.96C122.483 130.569 121.372 130.577 120.7 130.979C120.027 131.381 120.046 132.024 120.741 132.415C121.438 132.806 122.547 132.798 123.22 132.396C123.893 131.994 123.875 131.352 123.179 130.96Z"
          fill="#36B4C9"
        />
        <path
          d="M127.577 133.432C126.881 133.041 125.771 133.05 125.098 133.451C124.425 133.853 124.444 134.497 125.14 134.888C125.835 135.279 126.945 135.27 127.619 134.868C128.292 134.467 128.273 133.823 127.577 133.432Z"
          fill="#36B4C9"
        />
        <path
          d="M131.972 135.905C131.276 135.514 130.165 135.522 129.493 135.924C128.82 136.326 128.839 136.969 129.534 137.36C130.23 137.751 131.34 137.743 132.013 137.341C132.686 136.939 132.667 136.296 131.972 135.905Z"
          fill="#36B4C9"
        />
        <path
          d="M136.37 138.378C135.674 137.987 134.564 137.995 133.892 138.397C133.218 138.799 133.237 139.441 133.933 139.833C134.629 140.224 135.738 140.216 136.411 139.813C137.084 139.411 137.066 138.769 136.37 138.378Z"
          fill="#36B4C9"
        />
        <path
          d="M140.769 140.85C140.072 140.459 138.962 140.468 138.29 140.869C137.617 141.271 137.635 141.914 138.332 142.306C139.027 142.697 140.136 142.688 140.809 142.286C141.483 141.884 141.464 141.241 140.769 140.85Z"
          fill="#36B4C9"
        />
        <path
          d="M145.166 143.319C144.471 142.928 143.361 142.937 142.689 143.339C142.015 143.74 142.034 144.383 142.729 144.774C143.426 145.165 144.535 145.157 145.208 144.755C145.881 144.353 145.863 143.711 145.166 143.319Z"
          fill="#36B4C9"
        />
        <path
          d="M149.561 145.796C148.866 145.405 147.755 145.413 147.083 145.815C146.409 146.217 146.429 146.86 147.124 147.251C147.82 147.642 148.93 147.634 149.603 147.232C150.276 146.83 150.257 146.187 149.561 145.796Z"
          fill="#36B4C9"
        />
        <path
          d="M153.96 148.264C153.264 147.873 152.154 147.882 151.481 148.283C150.808 148.685 150.827 149.329 151.523 149.72C152.218 150.111 153.328 150.102 154.001 149.701C154.675 149.299 154.656 148.655 153.96 148.264Z"
          fill="#36B4C9"
        />
        <path
          d="M158.355 150.737C157.658 150.346 156.548 150.354 155.876 150.756C155.203 151.158 155.221 151.8 155.917 152.192C156.613 152.583 157.723 152.575 158.396 152.173C159.069 151.771 159.05 151.128 158.355 150.737Z"
          fill="#36B4C9"
        />
        <path
          d="M162.753 153.21C162.057 152.819 160.947 152.827 160.274 153.229C159.601 153.631 159.619 154.273 160.316 154.665C161.012 155.056 162.121 155.048 162.794 154.645C163.467 154.243 163.449 153.601 162.753 153.21Z"
          fill="#36B4C9"
        />
        <path
          d="M167.151 155.678C166.455 155.287 165.345 155.296 164.673 155.698C164 156.1 164.018 156.742 164.714 157.133C165.41 157.524 166.519 157.516 167.192 157.114C167.866 156.712 167.847 156.07 167.151 155.678Z"
          fill="#36B4C9"
        />
        <path
          d="M171.55 158.155C170.854 157.764 169.743 157.772 169.071 158.174C168.398 158.576 168.417 159.219 169.112 159.61C169.808 160.001 170.918 159.993 171.591 159.591C172.264 159.189 172.245 158.546 171.55 158.155Z"
          fill="#36B4C9"
        />
        <path
          d="M106.198 125.807C105.503 125.416 104.393 125.425 103.719 125.826C103.046 126.228 103.065 126.871 103.761 127.262C104.457 127.653 105.566 127.644 106.239 127.243C106.912 126.841 106.893 126.198 106.197 125.807"
          fill="#36B4C9"
        />
        <path
          d="M110.597 128.28C109.9 127.889 108.791 127.897 108.118 128.299C107.445 128.701 107.464 129.343 108.159 129.734C108.855 130.125 109.964 130.117 110.637 129.715C111.311 129.314 111.292 128.671 110.597 128.28Z"
          fill="#36B4C9"
        />
        <path
          d="M114.995 130.749C114.299 130.357 113.19 130.366 112.516 130.768C111.843 131.17 111.862 131.812 112.558 132.203C113.253 132.594 114.362 132.586 115.036 132.184C115.709 131.783 115.691 131.14 114.995 130.749Z"
          fill="#36B4C9"
        />
        <path
          d="M119.39 133.221C118.694 132.83 117.584 132.839 116.911 133.241C116.238 133.642 116.257 134.285 116.952 134.676C117.649 135.067 118.758 135.059 119.43 134.657C120.103 134.255 120.085 133.612 119.389 133.221"
          fill="#36B4C9"
        />
        <path
          d="M123.788 135.694C123.092 135.303 121.982 135.311 121.309 135.713C120.636 136.115 120.655 136.757 121.351 137.148C122.046 137.539 123.156 137.531 123.829 137.129C124.502 136.728 124.483 136.084 123.787 135.693"
          fill="#36B4C9"
        />
        <path
          d="M128.186 138.167C127.491 137.776 126.381 137.784 125.708 138.186C125.034 138.588 125.054 139.23 125.749 139.621C126.445 140.012 127.555 140.004 128.227 139.602C128.9 139.2 128.881 138.557 128.186 138.166"
          fill="#36B4C9"
        />
        <path
          d="M132.585 140.639C131.888 140.248 130.779 140.257 130.106 140.658C129.433 141.06 129.452 141.703 130.148 142.094C130.843 142.485 131.952 142.476 132.626 142.075C133.299 141.673 133.281 141.03 132.585 140.639Z"
          fill="#36B4C9"
        />
        <path
          d="M136.979 143.108C136.283 142.717 135.174 142.725 134.501 143.127C133.827 143.529 133.846 144.172 134.542 144.563C135.238 144.954 136.347 144.945 137.02 144.543C137.693 144.142 137.675 143.499 136.979 143.108Z"
          fill="#36B4C9"
        />
        <path
          d="M141.377 145.585C140.681 145.194 139.572 145.202 138.899 145.605C138.226 146.006 138.245 146.649 138.941 147.04C139.637 147.431 140.746 147.423 141.419 147.021C142.092 146.619 142.074 145.976 141.377 145.585Z"
          fill="#36B4C9"
        />
        <path
          d="M145.776 148.053C145.081 147.662 143.971 147.671 143.298 148.073C142.624 148.474 142.643 149.117 143.339 149.508C144.035 149.899 145.145 149.891 145.817 149.489C146.49 149.087 146.471 148.444 145.775 148.053"
          fill="#36B4C9"
        />
        <path
          d="M150.171 150.526C149.475 150.135 148.365 150.143 147.692 150.545C147.019 150.947 147.038 151.59 147.734 151.981C148.429 152.371 149.539 152.363 150.211 151.961C150.885 151.56 150.866 150.916 150.17 150.525"
          fill="#36B4C9"
        />
        <path
          d="M154.569 152.999C153.873 152.608 152.764 152.616 152.09 153.018C151.417 153.42 151.436 154.062 152.132 154.453C152.828 154.844 153.938 154.836 154.61 154.434C155.283 154.032 155.264 153.389 154.568 152.998"
          fill="#36B4C9"
        />
        <path
          d="M158.968 155.468C158.271 155.077 157.162 155.085 156.489 155.487C155.816 155.888 155.835 156.531 156.53 156.922C157.226 157.313 158.335 157.305 159.008 156.903C159.682 156.501 159.663 155.859 158.968 155.468Z"
          fill="#36B4C9"
        />
        <path
          d="M163.365 157.944C162.67 157.553 161.561 157.561 160.887 157.964C160.214 158.366 160.233 159.008 160.929 159.399C161.625 159.79 162.734 159.782 163.407 159.38C164.08 158.978 164.062 158.336 163.365 157.944Z"
          fill="#36B4C9"
        />
        <path
          d="M167.761 160.413C167.065 160.022 165.955 160.03 165.282 160.432C164.609 160.834 164.628 161.476 165.323 161.867C166.019 162.258 167.129 162.25 167.801 161.848C168.475 161.446 168.455 160.803 167.76 160.412"
          fill="#36B4C9"
        />
        <path
          d="M102.413 128.069C101.717 127.678 100.607 127.686 99.9342 128.088C99.261 128.49 99.2801 129.133 99.9757 129.524C100.671 129.915 101.782 129.907 102.455 129.505C103.128 129.103 103.109 128.46 102.413 128.069Z"
          fill="#36B4C9"
        />
        <path
          d="M106.812 130.538C106.115 130.147 105.005 130.155 104.333 130.557C103.66 130.959 103.678 131.601 104.374 131.993C105.07 132.384 106.18 132.375 106.852 131.973C107.526 131.571 107.507 130.929 106.812 130.538Z"
          fill="#36B4C9"
        />
        <path
          d="M111.206 133.011C110.509 132.619 109.4 132.628 108.727 133.03C108.055 133.432 108.072 134.074 108.769 134.466C109.464 134.857 110.574 134.848 111.247 134.446C111.92 134.044 111.902 133.402 111.206 133.011Z"
          fill="#36B4C9"
        />
        <path
          d="M115.604 135.483C114.909 135.092 113.798 135.1 113.126 135.502C112.452 135.904 112.471 136.547 113.167 136.938C113.864 137.329 114.974 137.321 115.646 136.919C116.319 136.517 116.301 135.875 115.604 135.483Z"
          fill="#36B4C9"
        />
        <path
          d="M120.003 137.952C119.307 137.561 118.196 137.569 117.524 137.971C116.851 138.373 116.87 139.016 117.565 139.407C118.261 139.798 119.372 139.79 120.044 139.388C120.717 138.986 120.698 138.343 120.003 137.952Z"
          fill="#36B4C9"
        />
        <path
          d="M124.397 140.428C123.702 140.037 122.591 140.046 121.919 140.448C121.245 140.849 121.264 141.493 121.96 141.884C122.656 142.275 123.766 142.266 124.439 141.865C125.112 141.463 125.093 140.819 124.397 140.428Z"
          fill="#36B4C9"
        />
        <path
          d="M128.796 142.897C128.099 142.506 126.989 142.515 126.317 142.916C125.645 143.318 125.662 143.961 126.359 144.352C127.054 144.743 128.164 144.734 128.836 144.332C129.51 143.931 129.491 143.288 128.796 142.897Z"
          fill="#36B4C9"
        />
        <path
          d="M133.195 145.37C132.498 144.979 131.388 144.987 130.716 145.389C130.043 145.791 130.061 146.433 130.757 146.825C131.453 147.216 132.563 147.207 133.235 146.805C133.908 146.403 133.89 145.761 133.195 145.37Z"
          fill="#36B4C9"
        />
        <path
          d="M137.592 147.842C136.897 147.451 135.787 147.46 135.114 147.862C134.441 148.264 134.459 148.906 135.155 149.297C135.851 149.688 136.961 149.68 137.634 149.278C138.307 148.876 138.289 148.234 137.592 147.842Z"
          fill="#36B4C9"
        />
        <path
          d="M141.987 150.315C141.292 149.924 140.181 149.932 139.508 150.334C138.835 150.736 138.854 151.379 139.55 151.77C140.246 152.161 141.356 152.153 142.029 151.751C142.702 151.35 142.683 150.706 141.987 150.315Z"
          fill="#36B4C9"
        />
        <path
          d="M146.386 152.788C145.69 152.397 144.579 152.405 143.907 152.807C143.234 153.209 143.253 153.852 143.948 154.243C144.644 154.634 145.755 154.626 146.427 154.224C147.1 153.822 147.081 153.179 146.386 152.788Z"
          fill="#36B4C9"
        />
        <path
          d="M150.78 155.257C150.084 154.866 148.974 154.874 148.302 155.276C147.628 155.677 147.647 156.32 148.343 156.712C149.039 157.103 150.15 157.094 150.822 156.693C151.495 156.291 151.476 155.648 150.78 155.257Z"
          fill="#36B4C9"
        />
        <path
          d="M155.179 157.729C154.482 157.338 153.373 157.347 152.7 157.748C152.027 158.15 152.045 158.793 152.742 159.184C153.437 159.575 154.547 159.566 155.22 159.165C155.893 158.763 155.875 158.12 155.179 157.729Z"
          fill="#36B4C9"
        />
        <path
          d="M159.577 160.201C158.881 159.811 157.771 159.82 157.099 160.221C156.425 160.623 156.444 161.266 157.139 161.657C157.836 162.048 158.946 162.039 159.618 161.638C160.291 161.236 160.273 160.593 159.577 160.201Z"
          fill="#36B4C9"
        />
        <path
          d="M163.975 162.675C163.28 162.284 162.169 162.292 161.496 162.694C160.824 163.095 160.842 163.739 161.538 164.13C162.234 164.521 163.344 164.512 164.017 164.111C164.69 163.709 164.671 163.066 163.975 162.675Z"
          fill="#36B4C9"
        />
        <path
          d="M98.6239 130.327C97.9283 129.936 96.8184 129.944 96.1452 130.346C95.4719 130.748 95.491 131.39 96.1867 131.781C96.8823 132.172 97.9922 132.164 98.6646 131.762C99.3379 131.36 99.3188 130.717 98.6231 130.326"
          fill="#36B4C9"
        />
        <path
          d="M103.022 132.8C102.326 132.409 101.217 132.417 100.544 132.819C99.8704 133.22 99.8895 133.863 100.585 134.254C101.281 134.645 102.39 134.637 103.063 134.235C103.736 133.833 103.718 133.191 103.022 132.8Z"
          fill="#36B4C9"
        />
        <path
          d="M107.421 135.273C106.724 134.881 105.615 134.89 104.942 135.292C104.269 135.693 104.288 136.336 104.984 136.727C105.679 137.118 106.788 137.11 107.461 136.708C108.135 136.306 108.116 135.664 107.421 135.273Z"
          fill="#36B4C9"
        />
        <path
          d="M111.815 137.741C111.12 137.35 110.01 137.358 109.337 137.76C108.663 138.162 108.682 138.804 109.378 139.195C110.075 139.586 111.184 139.578 111.856 139.176C112.529 138.774 112.511 138.132 111.815 137.74"
          fill="#36B4C9"
        />
        <path
          d="M116.214 140.218C115.518 139.827 114.408 139.835 113.735 140.237C113.062 140.638 113.081 141.281 113.777 141.672C114.472 142.063 115.582 142.055 116.254 141.653C116.928 141.251 116.909 140.608 116.213 140.217"
          fill="#36B4C9"
        />
        <path
          d="M120.612 142.686C119.917 142.295 118.807 142.304 118.133 142.705C117.46 143.107 117.479 143.75 118.175 144.141C118.871 144.532 119.981 144.523 120.653 144.122C121.326 143.72 121.307 143.076 120.611 142.685"
          fill="#36B4C9"
        />
        <path
          d="M125.011 145.159C124.314 144.768 123.205 144.776 122.532 145.178C121.859 145.58 121.878 146.222 122.573 146.613C123.269 147.004 124.378 146.996 125.051 146.594C125.725 146.192 125.706 145.55 125.011 145.159Z"
          fill="#36B4C9"
        />
        <path
          d="M129.405 147.632C128.709 147.241 127.6 147.249 126.926 147.651C126.253 148.052 126.272 148.695 126.968 149.086C127.664 149.477 128.773 149.469 129.446 149.067C130.119 148.665 130.101 148.023 129.405 147.632Z"
          fill="#36B4C9"
        />
        <path
          d="M133.803 150.1C133.107 149.709 131.998 149.718 131.325 150.12C130.652 150.522 130.671 151.164 131.366 151.555C132.063 151.946 133.172 151.938 133.844 151.536C134.518 151.135 134.499 150.492 133.803 150.1Z"
          fill="#36B4C9"
        />
        <path
          d="M138.198 152.577C137.503 152.186 136.393 152.194 135.719 152.596C135.046 152.998 135.065 153.64 135.761 154.031C136.457 154.422 137.566 154.414 138.239 154.012C138.912 153.61 138.893 152.967 138.197 152.576"
          fill="#36B4C9"
        />
        <path
          d="M142.597 155.046C141.901 154.655 140.791 154.663 140.118 155.065C139.445 155.467 139.464 156.109 140.159 156.5C140.855 156.891 141.965 156.883 142.637 156.481C143.311 156.079 143.291 155.436 142.596 155.045"
          fill="#36B4C9"
        />
        <path
          d="M146.995 157.518C146.299 157.127 145.19 157.136 144.516 157.537C143.843 157.939 143.862 158.582 144.558 158.973C145.253 159.364 146.363 159.355 147.036 158.954C147.709 158.552 147.69 157.908 146.994 157.517"
          fill="#36B4C9"
        />
        <path
          d="M151.393 159.991C150.697 159.6 149.588 159.608 148.915 160.01C148.241 160.412 148.261 161.054 148.956 161.445C149.652 161.836 150.761 161.828 151.434 161.426C152.107 161.024 152.089 160.382 151.393 159.991Z"
          fill="#36B4C9"
        />
        <path
          d="M155.787 162.464C155.092 162.073 153.982 162.081 153.309 162.483C152.636 162.885 152.655 163.528 153.351 163.919C154.047 164.31 155.156 164.301 155.829 163.9C156.502 163.498 156.484 162.855 155.787 162.464Z"
          fill="#36B4C9"
        />
        <path
          d="M160.186 164.936C159.491 164.545 158.381 164.554 157.708 164.955C157.034 165.357 157.054 166 157.749 166.391C158.445 166.782 159.555 166.773 160.227 166.372C160.9 165.97 160.881 165.326 160.186 164.935"
          fill="#36B4C9"
        />
        <path
          d="M94.8388 132.589C94.1431 132.198 93.0324 132.206 92.36 132.608C91.6868 133.009 91.7059 133.653 92.4015 134.044C93.0972 134.435 94.2079 134.427 94.8803 134.025C95.5535 133.623 95.5344 132.98 94.8388 132.589Z"
          fill="#36B4C9"
        />
        <path
          d="M99.2375 135.061C98.5411 134.67 97.4312 134.679 96.7588 135.08C96.0855 135.482 96.1038 136.125 96.8003 136.516C97.4959 136.907 98.6058 136.898 99.2782 136.497C99.9514 136.095 99.9332 135.452 99.2375 135.061Z"
          fill="#36B4C9"
        />
        <path
          d="M103.632 137.53C102.936 137.139 101.826 137.148 101.153 137.549C100.48 137.951 100.498 138.594 101.195 138.986C101.89 139.377 103 139.367 103.673 138.966C104.346 138.564 104.328 137.921 103.632 137.53Z"
          fill="#36B4C9"
        />
        <path
          d="M108.03 140.007C107.335 139.616 106.224 139.624 105.551 140.026C104.878 140.427 104.897 141.071 105.593 141.462C106.289 141.853 107.399 141.844 108.072 141.443C108.745 141.041 108.727 140.398 108.03 140.007Z"
          fill="#36B4C9"
        />
        <path
          d="M112.429 142.475C111.733 142.084 110.622 142.093 109.95 142.494C109.277 142.896 109.296 143.54 109.991 143.931C110.687 144.322 111.798 144.313 112.47 143.911C113.143 143.51 113.124 142.866 112.429 142.475Z"
          fill="#36B4C9"
        />
        <path
          d="M116.823 144.948C116.128 144.557 115.017 144.565 114.344 144.967C113.671 145.369 113.69 146.012 114.386 146.403C115.082 146.794 116.191 146.786 116.865 146.384C117.538 145.982 117.519 145.339 116.823 144.948Z"
          fill="#36B4C9"
        />
        <path
          d="M121.222 147.421C120.525 147.03 119.416 147.038 118.743 147.44C118.07 147.842 118.088 148.484 118.785 148.876C119.48 149.267 120.59 149.258 121.263 148.856C121.936 148.454 121.918 147.812 121.222 147.421Z"
          fill="#36B4C9"
        />
        <path
          d="M125.62 149.889C124.924 149.498 123.814 149.507 123.141 149.908C122.469 150.31 122.486 150.953 123.183 151.345C123.878 151.736 124.988 151.726 125.661 151.325C126.334 150.923 126.316 150.28 125.62 149.889Z"
          fill="#36B4C9"
        />
        <path
          d="M130.018 152.366C129.322 151.975 128.213 151.984 127.54 152.385C126.867 152.787 126.885 153.43 127.581 153.821C128.277 154.212 129.386 154.203 130.06 153.802C130.733 153.4 130.715 152.757 130.018 152.366Z"
          fill="#36B4C9"
        />
        <path
          d="M134.413 154.835C133.717 154.444 132.607 154.452 131.934 154.854C131.261 155.256 131.28 155.899 131.976 156.29C132.671 156.681 133.782 156.673 134.455 156.271C135.128 155.869 135.109 155.226 134.413 154.835Z"
          fill="#36B4C9"
        />
        <path
          d="M138.811 157.307C138.116 156.916 137.005 156.925 136.333 157.326C135.659 157.728 135.679 158.372 136.374 158.763C137.07 159.154 138.181 159.145 138.853 158.743C139.526 158.342 139.507 157.698 138.811 157.307Z"
          fill="#36B4C9"
        />
        <path
          d="M143.206 159.78C142.51 159.389 141.4 159.397 140.728 159.799C140.054 160.201 140.073 160.843 140.769 161.235C141.465 161.626 142.575 161.618 143.248 161.216C143.921 160.814 143.902 160.171 143.206 159.78Z"
          fill="#36B4C9"
        />
        <path
          d="M147.605 162.253C146.908 161.862 145.798 161.87 145.126 162.272C144.453 162.674 144.471 163.316 145.167 163.708C145.863 164.099 146.973 164.09 147.645 163.688C148.319 163.286 148.3 162.644 147.605 162.253Z"
          fill="#36B4C9"
        />
        <path
          d="M152.002 164.725C151.307 164.334 150.197 164.343 149.524 164.745C148.851 165.147 148.87 165.789 149.565 166.18C150.262 166.571 151.372 166.563 152.044 166.161C152.717 165.759 152.699 165.117 152.002 164.725Z"
          fill="#36B4C9"
        />
        <path
          d="M156.401 167.194C155.706 166.803 154.595 166.811 153.923 167.213C153.249 167.615 153.268 168.258 153.964 168.649C154.66 169.04 155.77 169.032 156.443 168.63C157.116 168.228 157.097 167.585 156.401 167.194Z"
          fill="#36B4C9"
        />
        <path
          d="M91.0528 134.85C90.3572 134.459 89.2473 134.468 88.5749 134.869C87.9016 135.271 87.9207 135.915 88.6164 136.306C89.312 136.697 90.4219 136.688 91.0951 136.286C91.7684 135.885 91.7493 135.242 91.0536 134.851"
          fill="#36B4C9"
        />
        <path
          d="M95.4476 137.319C94.7512 136.928 93.6421 136.936 92.9697 137.338C92.2965 137.74 92.3147 138.382 93.0112 138.774C93.7069 139.165 94.8159 139.157 95.4891 138.754C96.1624 138.353 96.1433 137.71 95.4476 137.319Z"
          fill="#36B4C9"
        />
        <path
          d="M99.8461 139.796C99.1496 139.404 98.0405 139.413 97.3681 139.815C96.6949 140.217 96.7132 140.859 97.4096 141.251C98.1053 141.642 99.2144 141.634 99.8876 141.231C100.561 140.829 100.542 140.187 99.8461 139.796Z"
          fill="#36B4C9"
        />
        <path
          d="M104.244 142.264C103.549 141.873 102.439 141.882 101.766 142.283C101.093 142.685 101.112 143.329 101.808 143.72C102.504 144.111 103.613 144.102 104.287 143.701C104.96 143.299 104.941 142.656 104.245 142.265"
          fill="#36B4C9"
        />
        <path
          d="M108.639 144.737C107.943 144.346 106.833 144.354 106.161 144.756C105.488 145.158 105.507 145.801 106.202 146.192C106.898 146.583 108.008 146.575 108.681 146.173C109.354 145.771 109.335 145.129 108.64 144.738"
          fill="#36B4C9"
        />
        <path
          d="M113.037 147.21C112.342 146.819 111.232 146.827 110.559 147.229C109.886 147.631 109.905 148.274 110.601 148.665C111.296 149.056 112.406 149.048 113.08 148.646C113.753 148.244 113.734 147.602 113.038 147.211"
          fill="#36B4C9"
        />
        <path
          d="M117.436 149.678C116.739 149.287 115.63 149.296 114.958 149.698C114.285 150.099 114.303 150.742 114.999 151.134C115.695 151.525 116.804 151.516 117.477 151.114C118.151 150.712 118.132 150.069 117.436 149.678Z"
          fill="#36B4C9"
        />
        <path
          d="M121.83 152.155C121.134 151.764 120.025 151.772 119.353 152.174C118.679 152.576 118.698 153.218 119.394 153.61C120.09 154.001 121.199 153.993 121.872 153.59C122.545 153.189 122.526 152.546 121.83 152.155Z"
          fill="#36B4C9"
        />
        <path
          d="M126.229 154.624C125.533 154.233 124.424 154.241 123.751 154.643C123.078 155.045 123.096 155.687 123.792 156.078C124.488 156.469 125.597 156.461 126.27 156.059C126.944 155.657 126.925 155.015 126.229 154.624Z"
          fill="#36B4C9"
        />
        <path
          d="M130.627 157.096C129.931 156.705 128.821 156.714 128.149 157.116C127.476 157.517 127.495 158.161 128.191 158.552C128.886 158.943 129.996 158.934 130.669 158.533C131.343 158.131 131.324 157.488 130.628 157.097"
          fill="#36B4C9"
        />
        <path
          d="M135.022 159.569C134.326 159.178 133.216 159.186 132.544 159.588C131.87 159.99 131.889 160.633 132.585 161.024C133.281 161.415 134.391 161.407 135.064 161.005C135.737 160.603 135.718 159.961 135.022 159.57"
          fill="#36B4C9"
        />
        <path
          d="M139.42 162.042C138.724 161.651 137.615 161.659 136.942 162.061C136.269 162.463 136.287 163.105 136.984 163.497C137.68 163.888 138.789 163.88 139.463 163.478C140.136 163.076 140.117 162.434 139.421 162.043"
          fill="#36B4C9"
        />
        <path
          d="M143.819 164.514C143.122 164.123 142.013 164.132 141.341 164.533C140.668 164.935 140.686 165.578 141.382 165.97C142.078 166.361 143.187 166.352 143.86 165.95C144.533 165.548 144.514 164.905 143.819 164.514Z"
          fill="#36B4C9"
        />
        <path
          d="M148.213 166.983C147.518 166.592 146.409 166.6 145.735 167.002C145.062 167.404 145.08 168.047 145.776 168.438C146.473 168.829 147.582 168.82 148.255 168.418C148.928 168.017 148.909 167.374 148.213 166.983Z"
          fill="#36B4C9"
        />
        <path
          d="M152.611 169.456C151.916 169.065 150.806 169.073 150.133 169.475C149.46 169.877 149.479 170.52 150.175 170.911C150.871 171.302 151.98 171.294 152.654 170.892C153.327 170.49 153.308 169.848 152.612 169.457"
          fill="#36B4C9"
        />
        <path
          d="M87.2646 137.108C86.5689 136.717 85.4582 136.725 84.7858 137.127C84.1126 137.529 84.1317 138.172 84.8273 138.563C85.523 138.954 86.6337 138.946 87.3061 138.544C87.9793 138.142 87.9602 137.499 87.2646 137.108Z"
          fill="#36B4C9"
        />
        <path
          d="M91.6633 139.581C90.9668 139.19 89.8569 139.198 89.1845 139.6C88.5113 140.002 88.5296 140.644 89.226 141.036C89.9217 141.427 91.0316 141.418 91.704 141.016C92.3772 140.614 92.359 139.972 91.6633 139.581Z"
          fill="#36B4C9"
        />
        <path
          d="M96.0579 142.054C95.3614 141.662 94.2515 141.671 93.5791 142.073C92.9058 142.475 92.9241 143.117 93.6206 143.509C94.3162 143.9 95.4261 143.891 96.0985 143.489C96.7718 143.087 96.7535 142.445 96.0579 142.054Z"
          fill="#36B4C9"
        />
        <path
          d="M100.456 144.526C99.7603 144.135 98.6496 144.143 97.9772 144.545C97.304 144.947 97.3231 145.59 98.0187 145.981C98.7152 146.372 99.8251 146.364 100.497 145.962C101.17 145.56 101.152 144.918 100.456 144.526Z"
          fill="#36B4C9"
        />
        <path
          d="M104.854 146.999C104.159 146.608 103.048 146.616 102.376 147.018C101.702 147.42 101.721 148.063 102.417 148.454C103.113 148.845 104.224 148.837 104.896 148.435C105.569 148.033 105.55 147.39 104.854 146.999Z"
          fill="#36B4C9"
        />
        <path
          d="M109.249 149.468C108.553 149.077 107.443 149.085 106.77 149.487C106.097 149.888 106.116 150.532 106.812 150.923C107.507 151.314 108.617 151.305 109.29 150.904C109.964 150.502 109.945 149.859 109.249 149.468Z"
          fill="#36B4C9"
        />
        <path
          d="M113.648 151.944C112.951 151.553 111.841 151.561 111.169 151.963C110.496 152.365 110.514 153.007 111.21 153.399C111.906 153.79 113.016 153.781 113.688 153.379C114.362 152.978 114.343 152.335 113.648 151.944Z"
          fill="#36B4C9"
        />
        <path
          d="M118.046 154.413C117.35 154.022 116.24 154.03 115.567 154.432C114.894 154.834 114.912 155.476 115.609 155.868C116.305 156.259 117.414 156.25 118.087 155.848C118.759 155.446 118.742 154.804 118.046 154.413Z"
          fill="#36B4C9"
        />
        <path
          d="M122.44 156.885C121.744 156.494 120.634 156.503 119.962 156.905C119.289 157.307 119.307 157.949 120.003 158.34C120.699 158.731 121.808 158.723 122.481 158.321C123.155 157.919 123.136 157.277 122.44 156.885Z"
          fill="#36B4C9"
        />
        <path
          d="M126.839 159.358C126.143 158.967 125.032 158.975 124.36 159.377C123.687 159.779 123.706 160.422 124.402 160.813C125.097 161.204 126.208 161.196 126.88 160.794C127.554 160.392 127.534 159.749 126.839 159.358Z"
          fill="#36B4C9"
        />
        <path
          d="M131.237 161.827C130.542 161.436 129.431 161.444 128.758 161.846C128.085 162.248 128.104 162.891 128.8 163.282C129.496 163.673 130.606 163.665 131.279 163.263C131.952 162.861 131.933 162.218 131.237 161.827Z"
          fill="#36B4C9"
        />
        <path
          d="M135.636 164.303C134.939 163.912 133.83 163.921 133.157 164.323C132.484 164.724 132.502 165.367 133.199 165.759C133.894 166.15 135.005 166.141 135.677 165.74C136.351 165.338 136.332 164.694 135.636 164.303Z"
          fill="#36B4C9"
        />
        <path
          d="M140.03 166.772C139.334 166.381 138.224 166.39 137.552 166.791C136.878 167.193 136.897 167.836 137.593 168.227C138.289 168.618 139.399 168.609 140.071 168.208C140.744 167.806 140.726 167.163 140.03 166.772Z"
          fill="#36B4C9"
        />
        <path
          d="M144.428 169.244C143.733 168.853 142.623 168.863 141.95 169.264C141.277 169.666 141.295 170.309 141.991 170.7C142.687 171.091 143.797 171.082 144.47 170.681C145.143 170.279 145.125 169.636 144.428 169.244Z"
          fill="#36B4C9"
        />
        <path
          d="M148.827 171.718C148.131 171.327 147.021 171.335 146.348 171.737C145.675 172.138 145.694 172.782 146.39 173.173C147.085 173.564 148.196 173.555 148.869 173.154C149.542 172.752 149.523 172.109 148.827 171.718Z"
          fill="#36B4C9"
        />
        <path
          d="M83.4786 139.374C82.7829 138.983 81.673 138.991 81.0006 139.393C80.3274 139.795 80.3465 140.438 81.0421 140.829C81.7378 141.22 82.8477 141.212 83.5209 140.81C84.1942 140.408 84.1751 139.766 83.4794 139.375"
          fill="#36B4C9"
        />
        <path
          d="M87.8734 141.843C87.1769 141.452 86.0679 141.46 85.3955 141.862C84.7222 142.263 84.7405 142.906 85.437 143.298C86.1326 143.689 87.2417 143.68 87.9149 143.278C88.5882 142.876 88.5691 142.234 87.8734 141.843Z"
          fill="#36B4C9"
        />
        <path
          d="M92.2719 144.312C91.5754 143.92 90.4663 143.929 89.7939 144.331C89.1207 144.732 89.1389 145.375 89.8354 145.767C90.5311 146.158 91.6401 146.149 92.3134 145.747C92.9866 145.345 92.9675 144.703 92.2719 144.312Z"
          fill="#36B4C9"
        />
        <path
          d="M96.67 146.788C95.9743 146.397 94.8645 146.405 94.192 146.807C93.5188 147.209 93.5379 147.852 94.2336 148.243C94.93 148.634 96.0391 148.626 96.7123 148.224C97.3856 147.822 97.3665 147.18 96.6708 146.789"
          fill="#36B4C9"
        />
        <path
          d="M101.065 149.257C100.369 148.866 99.259 148.874 98.5866 149.276C97.9133 149.677 97.9324 150.321 98.6281 150.712C99.3237 151.103 100.434 151.094 101.107 150.693C101.78 150.291 101.761 149.648 101.065 149.257"
          fill="#36B4C9"
        />
        <path
          d="M105.463 151.733C104.767 151.342 103.657 151.35 102.985 151.752C102.312 152.154 102.331 152.797 103.027 153.188C103.722 153.579 104.832 153.571 105.505 153.169C106.179 152.767 106.159 152.125 105.464 151.734"
          fill="#36B4C9"
        />
        <path
          d="M109.862 154.202C109.165 153.811 108.056 153.819 107.384 154.221C106.711 154.623 106.729 155.265 107.425 155.657C108.121 156.048 109.23 156.04 109.903 155.637C110.576 155.235 110.557 154.593 109.862 154.202Z"
          fill="#36B4C9"
        />
        <path
          d="M114.256 156.675C113.56 156.284 112.451 156.292 111.778 156.694C111.105 157.095 111.123 157.738 111.82 158.13C112.515 158.521 113.625 158.512 114.298 158.11C114.971 157.708 114.952 157.066 114.256 156.675Z"
          fill="#36B4C9"
        />
        <path
          d="M118.655 159.147C117.959 158.756 116.85 158.765 116.177 159.166C115.504 159.568 115.522 160.211 116.218 160.602C116.914 160.993 118.023 160.984 118.696 160.583C119.37 160.181 119.35 159.538 118.655 159.147Z"
          fill="#36B4C9"
        />
        <path
          d="M123.053 161.616C122.357 161.225 121.247 161.233 120.575 161.635C119.902 162.037 119.921 162.68 120.616 163.071C121.312 163.462 122.422 163.454 123.095 163.052C123.768 162.65 123.749 162.008 123.054 161.617"
          fill="#36B4C9"
        />
        <path
          d="M127.447 164.093C126.752 163.702 125.642 163.71 124.969 164.112C124.296 164.513 124.315 165.157 125.011 165.548C125.707 165.939 126.816 165.93 127.49 165.529C128.163 165.127 128.144 164.484 127.448 164.093"
          fill="#36B4C9"
        />
        <path
          d="M131.846 166.561C131.15 166.17 130.041 166.179 129.368 166.58C128.695 166.982 128.713 167.625 129.41 168.016C130.105 168.407 131.215 168.399 131.888 167.997C132.562 167.596 132.543 166.953 131.847 166.562"
          fill="#36B4C9"
        />
        <path
          d="M136.245 169.034C135.548 168.643 134.439 168.651 133.767 169.053C133.093 169.455 133.112 170.097 133.808 170.489C134.504 170.88 135.613 170.872 136.286 170.469C136.959 170.067 136.94 169.425 136.245 169.034Z"
          fill="#36B4C9"
        />
        <path
          d="M140.639 171.507C139.943 171.116 138.834 171.124 138.161 171.526C137.488 171.927 137.506 172.57 138.202 172.961C138.898 173.352 140.007 173.344 140.681 172.942C141.354 172.54 141.335 171.898 140.639 171.507Z"
          fill="#36B4C9"
        />
        <path
          d="M145.037 173.975C144.342 173.584 143.232 173.593 142.559 173.994C141.886 174.396 141.905 175.04 142.601 175.431C143.296 175.822 144.406 175.813 145.08 175.411C145.753 175.01 145.734 174.367 145.038 173.976"
          fill="#36B4C9"
        />
        <path
          d="M79.6904 141.632C78.9947 141.241 77.8848 141.249 77.2116 141.651C76.5383 142.052 76.5574 142.696 77.2531 143.087C77.9487 143.478 79.0595 143.469 79.7319 143.068C80.4051 142.666 80.386 142.023 79.6904 141.632Z"
          fill="#36B4C9"
        />
        <path
          d="M84.0852 144.104C83.3887 143.713 82.2797 143.722 81.6064 144.123C80.9332 144.525 80.9514 145.168 81.6479 145.559C82.3436 145.95 83.4535 145.941 84.1259 145.54C84.7991 145.138 84.7808 144.495 84.0852 144.104Z"
          fill="#36B4C9"
        />
        <path
          d="M88.4836 146.577C87.7871 146.185 86.6781 146.195 86.0049 146.596C85.3316 146.998 85.3499 147.641 86.0464 148.032C86.742 148.423 87.8519 148.414 88.5243 148.013C89.1975 147.611 89.1793 146.968 88.4836 146.577Z"
          fill="#36B4C9"
        />
        <path
          d="M92.8818 149.046C92.1861 148.655 91.0762 148.663 90.403 149.065C89.7298 149.467 89.7488 150.11 90.4445 150.501C91.141 150.892 92.2509 150.884 92.9233 150.482C93.5965 150.08 93.5782 149.437 92.8818 149.046Z"
          fill="#36B4C9"
        />
        <path
          d="M97.2802 151.518C96.5845 151.127 95.4747 151.136 94.8014 151.537C94.1282 151.939 94.1473 152.583 94.8429 152.974C95.5386 153.365 96.6493 153.356 97.3217 152.954C97.9949 152.553 97.9758 151.909 97.2802 151.518Z"
          fill="#36B4C9"
        />
        <path
          d="M101.675 153.991C100.979 153.6 99.8692 153.608 99.196 154.01C98.5227 154.412 98.5418 155.055 99.2375 155.446C99.9331 155.837 101.043 155.829 101.716 155.427C102.389 155.025 102.37 154.382 101.675 153.991Z"
          fill="#36B4C9"
        />
        <path
          d="M106.073 156.464C105.377 156.073 104.268 156.081 103.595 156.483C102.921 156.884 102.94 157.527 103.636 157.919C104.332 158.31 105.442 158.301 106.114 157.899C106.787 157.497 106.769 156.855 106.073 156.464Z"
          fill="#36B4C9"
        />
        <path
          d="M110.472 158.936C109.775 158.545 108.666 158.554 107.993 158.955C107.32 159.357 107.338 160 108.035 160.391C108.73 160.782 109.84 160.773 110.513 160.372C111.186 159.97 111.168 159.327 110.472 158.936Z"
          fill="#36B4C9"
        />
        <path
          d="M114.866 161.405C114.17 161.014 113.061 161.022 112.388 161.425C111.715 161.827 111.733 162.469 112.428 162.86C113.125 163.251 114.234 163.243 114.907 162.841C115.58 162.439 115.562 161.797 114.866 161.405Z"
          fill="#36B4C9"
        />
        <path
          d="M119.265 163.882C118.569 163.491 117.459 163.499 116.786 163.901C116.113 164.302 116.132 164.946 116.827 165.337C117.523 165.728 118.634 165.719 119.306 165.318C119.979 164.916 119.96 164.273 119.265 163.882Z"
          fill="#36B4C9"
        />
        <path
          d="M123.663 166.35C122.967 165.959 121.857 165.968 121.184 166.369C120.511 166.771 120.53 167.415 121.226 167.806C121.921 168.197 123.032 168.188 123.705 167.786C124.378 167.385 124.359 166.741 123.663 166.35Z"
          fill="#36B4C9"
        />
        <path
          d="M128.062 168.823C127.365 168.432 126.256 168.44 125.583 168.842C124.91 169.244 124.928 169.886 125.624 170.278C126.32 170.669 127.431 170.661 128.103 170.259C128.776 169.857 128.757 169.214 128.062 168.823Z"
          fill="#36B4C9"
        />
        <path
          d="M132.456 171.296C131.76 170.905 130.651 170.913 129.978 171.315C129.304 171.717 129.323 172.359 130.019 172.751C130.715 173.142 131.825 173.133 132.497 172.731C133.17 172.329 133.152 171.687 132.456 171.296Z"
          fill="#36B4C9"
        />
        <path
          d="M136.854 173.764C136.158 173.373 135.049 173.382 134.376 173.784C133.703 174.186 133.721 174.829 134.417 175.22C135.113 175.611 136.223 175.602 136.895 175.2C137.569 174.799 137.55 174.156 136.854 173.764Z"
          fill="#36B4C9"
        />
        <path
          d="M141.249 176.241C140.553 175.85 139.443 175.858 138.77 176.26C138.097 176.662 138.116 177.305 138.812 177.696C139.507 178.087 140.618 178.079 141.29 177.677C141.964 177.275 141.945 176.632 141.249 176.241Z"
          fill="#36B4C9"
        />
        <path
          d="M75.9013 143.889C75.2056 143.498 74.0949 143.507 73.4225 143.908C72.7493 144.31 72.7684 144.954 73.464 145.345C74.1597 145.736 75.2696 145.727 75.9428 145.326C76.616 144.924 76.5969 144.28 75.9013 143.889Z"
          fill="#36B4C9"
        />
        <path
          d="M80.3 146.366C79.6036 145.975 78.4937 145.983 77.8213 146.385C77.148 146.787 77.1663 147.429 77.8628 147.821C78.5584 148.212 79.6675 148.204 80.3407 147.801C81.0139 147.399 80.9957 146.757 80.3 146.366Z"
          fill="#36B4C9"
        />
        <path
          d="M84.6985 148.835C84.002 148.443 82.8921 148.452 82.2197 148.854C81.5465 149.256 81.5647 149.898 82.2612 150.29C82.9569 150.681 84.0659 150.673 84.7391 150.27C85.4124 149.869 85.3941 149.226 84.6985 148.835Z"
          fill="#36B4C9"
        />
        <path
          d="M89.0927 151.307C88.397 150.916 87.2863 150.925 86.6139 151.326C85.9407 151.728 85.9598 152.372 86.6554 152.763C87.3519 153.154 88.461 153.145 89.1342 152.743C89.8074 152.342 89.7892 151.699 89.0927 151.307Z"
          fill="#36B4C9"
        />
        <path
          d="M93.4911 153.78C92.7955 153.389 91.6848 153.397 91.0124 153.799C90.3391 154.201 90.3582 154.844 91.0539 155.235C91.7495 155.626 92.8594 155.618 93.5326 155.216C94.2059 154.814 94.1868 154.171 93.4911 153.78Z"
          fill="#36B4C9"
        />
        <path
          d="M97.8896 156.249C97.1939 155.858 96.0832 155.866 95.4108 156.268C94.7376 156.67 94.7567 157.313 95.4523 157.704C96.148 158.095 97.2578 158.087 97.9311 157.685C98.6043 157.283 98.5852 156.64 97.8896 156.249Z"
          fill="#36B4C9"
        />
        <path
          d="M102.288 158.725C101.592 158.334 100.482 158.343 99.8095 158.744C99.1363 159.146 99.1546 159.789 99.851 160.181C100.547 160.572 101.656 160.563 102.329 160.161C103.002 159.759 102.984 159.116 102.288 158.725Z"
          fill="#36B4C9"
        />
        <path
          d="M106.683 161.194C105.986 160.803 104.876 160.811 104.204 161.213C103.531 161.615 103.549 162.257 104.246 162.649C104.941 163.04 106.05 163.032 106.724 162.629C107.397 162.228 107.378 161.585 106.683 161.194Z"
          fill="#36B4C9"
        />
        <path
          d="M111.081 163.666C110.385 163.275 109.275 163.284 108.603 163.686C107.929 164.088 107.948 164.731 108.643 165.122C109.34 165.513 110.449 165.504 111.122 165.102C111.795 164.701 111.777 164.058 111.081 163.666Z"
          fill="#36B4C9"
        />
        <path
          d="M115.479 166.139C114.784 165.748 113.673 165.757 113.001 166.158C112.327 166.56 112.346 167.204 113.042 167.595C113.738 167.986 114.848 167.977 115.521 167.576C116.194 167.174 116.175 166.53 115.479 166.139Z"
          fill="#36B4C9"
        />
        <path
          d="M119.874 168.612C119.178 168.221 118.068 168.229 117.395 168.631C116.722 169.033 116.741 169.676 117.437 170.067C118.132 170.458 119.242 170.45 119.915 170.048C120.589 169.646 120.57 169.003 119.874 168.612Z"
          fill="#36B4C9"
        />
        <path
          d="M124.273 171.085C123.576 170.694 122.466 170.702 121.794 171.104C121.121 171.506 121.139 172.148 121.835 172.54C122.531 172.931 123.641 172.923 124.314 172.521C124.987 172.119 124.968 171.476 124.273 171.085Z"
          fill="#36B4C9"
        />
        <path
          d="M128.671 173.553C127.975 173.162 126.865 173.171 126.192 173.573C125.519 173.974 125.537 174.617 126.234 175.009C126.93 175.4 128.039 175.391 128.712 174.989C129.385 174.587 129.367 173.944 128.671 173.553Z"
          fill="#36B4C9"
        />
        <path
          d="M133.069 176.03C132.373 175.639 131.263 175.648 130.591 176.05C129.918 176.451 129.936 177.094 130.632 177.485C131.328 177.876 132.437 177.868 133.11 177.466C133.784 177.064 133.765 176.421 133.069 176.03Z"
          fill="#36B4C9"
        />
        <path
          d="M137.464 178.499C136.768 178.108 135.657 178.116 134.985 178.518C134.312 178.92 134.331 179.563 135.027 179.954C135.722 180.345 136.832 180.337 137.505 179.935C138.179 179.533 138.159 178.89 137.464 178.499Z"
          fill="#36B4C9"
        />
        <path
          d="M72.1161 146.155C71.4205 145.764 70.3106 145.772 69.6374 146.174C68.9641 146.576 68.9832 147.218 69.6789 147.609C70.3745 148 71.4844 147.992 72.1568 147.59C72.83 147.189 72.811 146.545 72.1153 146.154"
          fill="#36B4C9"
        />
        <path
          d="M76.5146 148.624C75.8181 148.233 74.709 148.241 74.0358 148.643C73.3626 149.045 73.3817 149.687 74.0773 150.078C74.773 150.469 75.882 150.461 76.5553 150.059C77.2285 149.657 77.2102 149.015 76.5146 148.624Z"
          fill="#36B4C9"
        />
        <path
          d="M80.9091 151.096C80.2126 150.705 79.1036 150.714 78.4303 151.116C77.7571 151.517 77.7762 152.16 78.4718 152.551C79.1675 152.942 80.2765 152.934 80.9498 152.532C81.623 152.13 81.6048 151.487 80.9091 151.096Z"
          fill="#36B4C9"
        />
        <path
          d="M85.3075 153.569C84.6119 153.178 83.502 153.186 82.8288 153.588C82.1555 153.99 82.1746 154.632 82.8703 155.023C83.5668 155.414 84.6758 155.406 85.3482 155.004C86.0215 154.603 86.0032 153.96 85.3067 153.568"
          fill="#36B4C9"
        />
        <path
          d="M89.706 156.038C89.0103 155.647 87.9004 155.655 87.2272 156.057C86.554 156.459 86.5731 157.101 87.2687 157.492C87.9644 157.883 89.0742 157.875 89.7467 157.473C90.4199 157.071 90.4008 156.428 89.7051 156.037"
          fill="#36B4C9"
        />
        <path
          d="M94.1005 158.514C93.4049 158.123 92.295 158.132 91.6217 158.533C90.9485 158.935 90.9676 159.578 91.6632 159.969C92.3589 160.36 93.4688 160.351 94.1412 159.95C94.8144 159.548 94.7953 158.905 94.0997 158.514"
          fill="#36B4C9"
        />
        <path
          d="M98.4989 160.983C97.8025 160.592 96.6934 160.6 96.0202 161.002C95.3469 161.404 95.366 162.047 96.0617 162.438C96.7573 162.829 97.8664 162.82 98.5396 162.418C99.2129 162.017 99.1946 161.374 98.4989 160.983Z"
          fill="#36B4C9"
        />
        <path
          d="M102.897 163.456C102.201 163.065 101.092 163.073 100.419 163.475C99.7454 163.877 99.7645 164.519 100.46 164.91C101.156 165.301 102.265 165.293 102.938 164.891C103.611 164.489 103.593 163.847 102.897 163.456Z"
          fill="#36B4C9"
        />
        <path
          d="M107.295 165.928C106.599 165.537 105.49 165.546 104.817 165.948C104.144 166.35 104.163 166.993 104.859 167.384C105.555 167.775 106.664 167.766 107.336 167.364C108.01 166.963 107.991 166.32 107.295 165.928Z"
          fill="#36B4C9"
        />
        <path
          d="M111.69 168.397C110.995 168.006 109.885 168.015 109.212 168.416C108.538 168.818 108.557 169.461 109.253 169.852C109.949 170.243 111.059 170.234 111.731 169.833C112.404 169.431 112.385 168.787 111.69 168.396"
          fill="#36B4C9"
        />
        <path
          d="M116.089 170.874C115.393 170.483 114.283 170.491 113.61 170.893C112.937 171.295 112.956 171.937 113.652 172.328C114.347 172.719 115.457 172.711 116.129 172.309C116.803 171.907 116.784 171.264 116.088 170.873"
          fill="#36B4C9"
        />
        <path
          d="M120.483 173.343C119.787 172.952 118.678 172.96 118.005 173.362C117.331 173.763 117.35 174.406 118.046 174.797C118.742 175.188 119.852 175.18 120.524 174.778C121.197 174.376 121.178 173.733 120.482 173.342"
          fill="#36B4C9"
        />
        <path
          d="M124.882 175.819C124.185 175.428 123.076 175.436 122.403 175.838C121.73 176.24 121.749 176.882 122.444 177.273C123.14 177.664 124.249 177.656 124.922 177.254C125.596 176.853 125.577 176.21 124.882 175.819Z"
          fill="#36B4C9"
        />
        <path
          d="M129.279 178.288C128.584 177.897 127.475 177.905 126.801 178.308C126.128 178.709 126.147 179.352 126.843 179.743C127.539 180.134 128.648 180.126 129.321 179.724C129.994 179.322 129.976 178.68 129.279 178.288Z"
          fill="#36B4C9"
        />
        <path
          d="M133.679 180.76C132.983 180.369 131.873 180.378 131.2 180.78C130.527 181.181 130.546 181.824 131.241 182.215C131.937 182.606 133.047 182.598 133.719 182.196C134.393 181.794 134.373 181.151 133.678 180.76"
          fill="#36B4C9"
        />
        <path
          d="M68.3271 148.413C67.6314 148.022 66.5207 148.03 65.8483 148.432C65.1751 148.834 65.1942 149.477 65.8898 149.868C66.5855 150.259 67.6962 150.251 68.3686 149.849C69.0418 149.447 69.0227 148.804 68.3271 148.413Z"
          fill="#36B4C9"
        />
        <path
          d="M72.7258 150.885C72.0293 150.494 70.9194 150.503 70.247 150.905C69.5738 151.306 69.5921 151.949 70.2885 152.341C70.9842 152.732 72.0941 152.723 72.7665 152.321C73.4397 151.919 73.4215 151.276 72.7258 150.885Z"
          fill="#36B4C9"
        />
        <path
          d="M77.1243 153.358C76.4278 152.967 75.3179 152.976 74.6455 153.378C73.9722 153.779 73.9905 154.422 74.687 154.814C75.3826 155.205 76.4925 155.196 77.1649 154.794C77.8382 154.392 77.8199 153.749 77.1243 153.358Z"
          fill="#36B4C9"
        />
        <path
          d="M81.5185 155.827C80.8228 155.436 79.7121 155.444 79.0397 155.846C78.3665 156.248 78.3856 156.891 79.0812 157.282C79.7777 157.673 80.8876 157.665 81.56 157.263C82.2332 156.861 82.215 156.219 81.5185 155.827Z"
          fill="#36B4C9"
        />
        <path
          d="M85.9169 158.303C85.2213 157.912 84.1105 157.921 83.4381 158.323C82.7649 158.724 82.784 159.368 83.4796 159.759C84.1753 160.15 85.286 160.141 85.9584 159.74C86.6317 159.338 86.6126 158.694 85.9169 158.303Z"
          fill="#36B4C9"
        />
        <path
          d="M90.3154 160.772C89.6197 160.381 88.509 160.39 87.8366 160.791C87.1633 161.193 87.1824 161.836 87.8781 162.227C88.5737 162.618 89.6836 162.61 90.3569 162.208C91.0301 161.807 91.011 161.163 90.3154 160.772Z"
          fill="#36B4C9"
        />
        <path
          d="M94.7141 163.245C94.0176 162.854 92.9077 162.862 92.2353 163.264C91.5621 163.666 91.5803 164.308 92.2768 164.7C92.9725 165.091 94.0824 165.082 94.7548 164.68C95.428 164.278 95.4097 163.636 94.7141 163.245Z"
          fill="#36B4C9"
        />
        <path
          d="M99.1086 165.718C98.4122 165.327 97.3023 165.335 96.6299 165.737C95.9566 166.138 95.9749 166.781 96.6714 167.173C97.367 167.564 98.4769 167.555 99.1493 167.153C99.8225 166.751 99.8043 166.109 99.1086 165.718Z"
          fill="#36B4C9"
        />
        <path
          d="M103.506 168.19C102.811 167.799 101.701 167.808 101.028 168.21C100.355 168.611 100.373 169.254 101.069 169.645C101.766 170.036 102.875 170.028 103.548 169.626C104.221 169.224 104.203 168.582 103.506 168.19Z"
          fill="#36B4C9"
        />
        <path
          d="M107.905 170.663C107.21 170.272 106.099 170.28 105.426 170.682C104.753 171.084 104.772 171.727 105.468 172.118C106.164 172.509 107.274 172.501 107.947 172.099C108.62 171.697 108.601 171.054 107.905 170.663Z"
          fill="#36B4C9"
        />
        <path
          d="M112.3 173.132C111.604 172.741 110.493 172.749 109.821 173.151C109.148 173.552 109.167 174.196 109.862 174.587C110.558 174.978 111.669 174.969 112.341 174.568C113.014 174.166 112.995 173.523 112.3 173.132Z"
          fill="#36B4C9"
        />
        <path
          d="M116.698 175.604C116.002 175.213 114.892 175.222 114.22 175.623C113.546 176.025 113.565 176.668 114.261 177.059C114.957 177.45 116.068 177.442 116.74 177.04C117.413 176.639 117.394 175.995 116.698 175.604Z"
          fill="#36B4C9"
        />
        <path
          d="M121.097 178.077C120.4 177.686 119.291 177.694 118.618 178.096C117.945 178.498 117.963 179.14 118.66 179.532C119.355 179.923 120.465 179.914 121.138 179.512C121.811 179.11 121.793 178.468 121.097 178.077Z"
          fill="#36B4C9"
        />
        <path
          d="M125.491 180.545C124.795 180.154 123.685 180.163 123.013 180.565C122.34 180.967 122.358 181.609 123.053 182C123.75 182.391 124.86 182.383 125.532 181.981C126.205 181.58 126.187 180.937 125.491 180.545Z"
          fill="#36B4C9"
        />
        <path
          d="M129.89 183.022C129.194 182.631 128.083 182.64 127.411 183.041C126.738 183.443 126.757 184.086 127.452 184.477C128.148 184.868 129.259 184.86 129.931 184.458C130.604 184.057 130.585 183.413 129.89 183.022Z"
          fill="#36B4C9"
        />
        <path
          d="M64.5419 150.675C63.8463 150.284 62.7364 150.292 62.0631 150.694C61.3899 151.095 61.409 151.738 62.1046 152.129C62.8003 152.52 63.9102 152.512 64.5826 152.11C65.2558 151.708 65.2367 151.065 64.5411 150.674"
          fill="#36B4C9"
        />
        <path
          d="M68.9404 153.147C68.2439 152.756 67.1348 152.765 66.4616 153.166C65.7883 153.568 65.8074 154.211 66.5031 154.602C67.1987 154.993 68.3078 154.984 68.981 154.583C69.6543 154.181 69.636 153.538 68.9404 153.147Z"
          fill="#36B4C9"
        />
        <path
          d="M73.3349 155.616C72.6384 155.224 71.5293 155.234 70.8561 155.635C70.1829 156.037 70.202 156.68 70.8976 157.071C71.5933 157.462 72.7023 157.453 73.3756 157.052C74.0488 156.65 74.0305 156.007 73.3349 155.616Z"
          fill="#36B4C9"
        />
        <path
          d="M77.7333 158.089C77.0377 157.698 75.9278 157.706 75.2545 158.108C74.5813 158.509 74.6004 159.152 75.2961 159.543C75.9925 159.934 77.1016 159.926 77.774 159.524C78.4472 159.122 78.429 158.48 77.7325 158.088"
          fill="#36B4C9"
        />
        <path
          d="M82.1318 160.561C81.4361 160.17 80.3262 160.179 79.653 160.58C78.9798 160.982 78.9988 161.625 79.6945 162.016C80.3901 162.407 81.5 162.398 82.1724 161.997C82.8457 161.595 82.8266 160.951 82.1309 160.56"
          fill="#36B4C9"
        />
        <path
          d="M86.5263 163.034C85.8306 162.643 84.7208 162.651 84.0475 163.053C83.3743 163.455 83.3934 164.097 84.089 164.488C84.7847 164.879 85.8946 164.871 86.567 164.469C87.2402 164.067 87.2211 163.424 86.5255 163.033"
          fill="#36B4C9"
        />
        <path
          d="M90.9247 165.507C90.2282 165.116 89.1192 165.124 88.446 165.526C87.7727 165.927 87.7918 166.57 88.4875 166.961C89.1831 167.352 90.2922 167.344 90.9654 166.942C91.6386 166.54 91.6204 165.898 90.9247 165.507Z"
          fill="#36B4C9"
        />
        <path
          d="M95.3232 167.975C94.6267 167.584 93.5176 167.593 92.8444 167.994C92.1712 168.396 92.1902 169.039 92.8859 169.43C93.5815 169.821 94.6906 169.812 95.3638 169.411C96.0371 169.009 96.0188 168.366 95.3232 167.975Z"
          fill="#36B4C9"
        />
        <path
          d="M99.7208 170.452C99.0251 170.061 97.9161 170.069 97.2428 170.472C96.5696 170.874 96.5887 171.516 97.2843 171.907C97.9808 172.298 99.0899 172.29 99.7623 171.888C100.436 171.486 100.417 170.844 99.7208 170.452Z"
          fill="#36B4C9"
        />
        <path
          d="M104.116 172.921C103.42 172.53 102.311 172.538 101.637 172.94C100.964 173.342 100.983 173.984 101.679 174.375C102.375 174.766 103.484 174.758 104.157 174.356C104.83 173.954 104.811 173.311 104.115 172.92"
          fill="#36B4C9"
        />
        <path
          d="M108.515 175.393C107.819 175.002 106.709 175.011 106.036 175.412C105.363 175.814 105.382 176.457 106.077 176.848C106.773 177.239 107.883 177.23 108.555 176.829C109.228 176.427 109.209 175.783 108.514 175.392"
          fill="#36B4C9"
        />
        <path
          d="M112.909 177.866C112.213 177.475 111.104 177.483 110.43 177.885C109.757 178.287 109.776 178.929 110.472 179.32C111.167 179.711 112.277 179.703 112.95 179.301C113.623 178.899 113.604 178.256 112.908 177.865"
          fill="#36B4C9"
        />
        <path
          d="M117.308 180.339C116.611 179.948 115.502 179.956 114.829 180.358C114.156 180.759 114.175 181.402 114.87 181.793C115.566 182.184 116.675 182.176 117.348 181.774C118.021 181.372 118.003 180.73 117.308 180.339Z"
          fill="#36B4C9"
        />
        <path
          d="M121.705 182.811C121.009 182.42 119.9 182.428 119.227 182.831C118.554 183.233 118.573 183.875 119.269 184.266C119.965 184.657 121.074 184.649 121.747 184.247C122.42 183.846 122.402 183.203 121.705 182.811Z"
          fill="#36B4C9"
        />
        <path
          d="M126.104 185.28C125.409 184.889 124.299 184.897 123.626 185.299C122.952 185.701 122.971 186.343 123.667 186.734C124.363 187.125 125.473 187.117 126.145 186.715C126.818 186.314 126.799 185.67 126.104 185.279"
          fill="#36B4C9"
        />
        <path
          d="M60.7564 152.936C60.0608 152.545 58.9501 152.554 58.2777 152.955C57.6053 153.357 57.6235 154 58.3192 154.391C59.0148 154.782 60.1255 154.774 60.7979 154.372C61.4712 153.971 61.4521 153.327 60.7564 152.936Z"
          fill="#36B4C9"
        />
        <path
          d="M65.1516 155.405C64.4551 155.014 63.3452 155.022 62.6728 155.424C61.9996 155.826 62.0178 156.468 62.7143 156.86C63.41 157.251 64.5199 157.242 65.1923 156.84C65.8655 156.439 65.8472 155.796 65.1516 155.405Z"
          fill="#36B4C9"
        />
        <path
          d="M69.55 157.878C68.8536 157.486 67.7437 157.495 67.0713 157.897C66.398 158.299 66.4163 158.941 67.1128 159.333C67.8084 159.724 68.9183 159.715 69.5907 159.313C70.2639 158.912 70.2457 158.269 69.55 157.878Z"
          fill="#36B4C9"
        />
        <path
          d="M73.9482 160.35C73.2525 159.959 72.1418 159.968 71.4694 160.369C70.7962 160.771 70.8152 161.415 71.5109 161.806C72.2074 162.197 73.3173 162.188 73.9897 161.786C74.6629 161.385 74.6446 160.742 73.9482 160.35Z"
          fill="#36B4C9"
        />
        <path
          d="M78.3427 162.823C77.6471 162.432 76.5363 162.44 75.8639 162.842C75.1907 163.244 75.2098 163.887 75.9054 164.278C76.6011 164.669 77.7118 164.661 78.3842 164.259C79.0574 163.857 79.0384 163.214 78.3427 162.823Z"
          fill="#36B4C9"
        />
        <path
          d="M82.7411 165.296C82.0455 164.905 80.9348 164.913 80.2624 165.315C79.5891 165.717 79.6082 166.36 80.3039 166.751C80.9995 167.142 82.1094 167.134 82.7826 166.732C83.4559 166.33 83.4368 165.687 82.7411 165.296Z"
          fill="#36B4C9"
        />
        <path
          d="M87.1396 167.764C86.4431 167.373 85.3332 167.382 84.6608 167.783C83.9884 168.185 84.0058 168.828 84.7023 169.22C85.3979 169.611 86.5078 169.601 87.1802 169.2C87.8535 168.798 87.8352 168.155 87.1396 167.764Z"
          fill="#36B4C9"
        />
        <path
          d="M91.5344 170.241C90.8379 169.85 89.728 169.858 89.0556 170.26C88.3824 170.662 88.4007 171.304 89.0971 171.696C89.7928 172.087 90.9027 172.078 91.5751 171.676C92.2483 171.274 92.2301 170.632 91.5344 170.241Z"
          fill="#36B4C9"
        />
        <path
          d="M95.9321 172.709C95.2365 172.318 94.1266 172.327 93.4542 172.729C92.7809 173.131 92.7992 173.774 93.4948 174.165C94.1913 174.556 95.3004 174.547 95.9736 174.145C96.6469 173.744 96.6286 173.101 95.9321 172.709Z"
          fill="#36B4C9"
        />
        <path
          d="M100.331 175.182C99.6353 174.791 98.5246 174.8 97.8522 175.201C97.179 175.603 97.1981 176.247 97.8937 176.638C98.5894 177.029 99.7001 177.02 100.372 176.618C101.046 176.217 101.027 175.573 100.331 175.182Z"
          fill="#36B4C9"
        />
        <path
          d="M104.726 177.655C104.03 177.264 102.919 177.272 102.247 177.674C101.574 178.076 101.593 178.719 102.288 179.11C102.984 179.501 104.095 179.493 104.767 179.091C105.439 178.689 105.421 178.046 104.726 177.655Z"
          fill="#36B4C9"
        />
        <path
          d="M109.124 180.124C108.428 179.733 107.318 179.741 106.645 180.143C105.972 180.545 105.991 181.187 106.687 181.579C107.383 181.97 108.493 181.962 109.166 181.56C109.839 181.158 109.82 180.515 109.124 180.124Z"
          fill="#36B4C9"
        />
        <path
          d="M113.523 182.6C112.826 182.209 111.716 182.218 111.044 182.619C110.371 183.021 110.389 183.664 111.085 184.056C111.781 184.447 112.891 184.437 113.563 184.036C114.237 183.634 114.218 182.991 113.523 182.6Z"
          fill="#36B4C9"
        />
        <path
          d="M117.916 185.069C117.221 184.678 116.111 184.687 115.438 185.089C114.766 185.49 114.783 186.133 115.479 186.524C116.175 186.915 117.285 186.907 117.958 186.505C118.631 186.103 118.613 185.461 117.916 185.069Z"
          fill="#36B4C9"
        />
        <path
          d="M122.315 187.542C121.62 187.151 120.509 187.159 119.837 187.561C119.163 187.963 119.182 188.606 119.878 188.997C120.574 189.388 121.684 189.38 122.357 188.978C123.03 188.576 123.011 187.933 122.315 187.542Z"
          fill="#36B4C9"
        />
        <path
          d="M56.9669 155.194C56.2712 154.803 55.1613 154.811 54.4889 155.213C53.8157 155.615 53.8348 156.258 54.5304 156.649C55.2261 157.04 56.336 157.032 57.0092 156.63C57.6824 156.228 57.6634 155.586 56.9677 155.195"
          fill="#36B4C9"
        />
        <path
          d="M61.3656 157.671C60.6691 157.28 59.5601 157.288 58.8877 157.69C58.2144 158.092 58.2327 158.734 58.9292 159.126C59.6248 159.517 60.7339 159.509 61.4071 159.106C62.0803 158.704 62.0613 158.062 61.3656 157.671Z"
          fill="#36B4C9"
        />
        <path
          d="M65.7601 160.14C65.0637 159.748 63.9546 159.757 63.2822 160.159C62.609 160.561 62.6272 161.203 63.3237 161.595C64.0194 161.986 65.1284 161.978 65.8016 161.575C66.4749 161.173 66.4558 160.531 65.7601 160.14Z"
          fill="#36B4C9"
        />
        <path
          d="M70.1583 162.612C69.4626 162.221 68.3527 162.229 67.6803 162.631C67.0071 163.033 67.0262 163.676 67.7218 164.067C68.4183 164.458 69.5274 164.45 70.2006 164.048C70.8738 163.646 70.8548 163.004 70.1591 162.613"
          fill="#36B4C9"
        />
        <path
          d="M74.5567 165.085C73.8611 164.694 72.7512 164.702 72.0788 165.104C71.4055 165.506 71.4246 166.149 72.1203 166.54C72.8159 166.931 73.9258 166.923 74.599 166.521C75.2723 166.119 75.2532 165.477 74.5575 165.086"
          fill="#36B4C9"
        />
        <path
          d="M78.9551 167.553C78.2595 167.162 77.1496 167.171 76.4772 167.573C75.804 167.974 75.8231 168.618 76.5187 169.009C77.2144 169.4 78.3242 169.391 78.9975 168.99C79.6707 168.588 79.6516 167.945 78.956 167.554"
          fill="#36B4C9"
        />
        <path
          d="M83.35 170.026C82.6535 169.635 81.5444 169.643 80.872 170.045C80.1988 170.447 80.2171 171.09 80.9135 171.481C81.6092 171.872 82.7183 171.864 83.3915 171.461C84.0647 171.06 84.0456 170.417 83.35 170.026Z"
          fill="#36B4C9"
        />
        <path
          d="M87.7484 172.499C87.0519 172.108 85.9429 172.116 85.2705 172.518C84.5972 172.92 84.6155 173.562 85.312 173.954C86.0076 174.345 87.1167 174.337 87.7899 173.934C88.4632 173.532 88.4441 172.89 87.7484 172.499Z"
          fill="#36B4C9"
        />
        <path
          d="M92.147 174.971C91.4513 174.58 90.3423 174.589 89.669 174.991C88.9958 175.392 89.014 176.035 89.7097 176.426C90.4062 176.817 91.5152 176.809 92.1885 176.407C92.8617 176.005 92.8426 175.362 92.147 174.971Z"
          fill="#36B4C9"
        />
        <path
          d="M96.5411 177.444C95.8454 177.053 94.7355 177.061 94.0631 177.463C93.3899 177.865 93.409 178.508 94.1046 178.899C94.8003 179.29 95.9102 179.282 96.5834 178.88C97.2567 178.478 97.2376 177.836 96.5419 177.445"
          fill="#36B4C9"
        />
        <path
          d="M100.94 179.913C100.244 179.522 99.134 179.53 98.4616 179.932C97.7883 180.334 97.8074 180.977 98.5031 181.368C99.1987 181.759 100.309 181.751 100.982 181.349C101.655 180.947 101.636 180.305 100.94 179.914"
          fill="#36B4C9"
        />
        <path
          d="M105.338 182.389C104.642 181.998 103.533 182.007 102.86 182.408C102.187 182.81 102.205 183.453 102.902 183.845C103.597 184.236 104.707 184.227 105.381 183.826C106.054 183.424 106.035 182.781 105.339 182.39"
          fill="#36B4C9"
        />
        <path
          d="M109.733 184.858C109.036 184.467 107.927 184.475 107.255 184.877C106.582 185.279 106.6 185.922 107.296 186.313C107.992 186.704 109.101 186.696 109.774 186.293C110.448 185.892 110.428 185.249 109.733 184.858Z"
          fill="#36B4C9"
        />
        <path
          d="M114.131 187.331C113.436 186.94 112.327 186.948 111.653 187.35C110.98 187.752 110.998 188.394 111.694 188.785C112.391 189.176 113.5 189.168 114.173 188.766C114.846 188.364 114.827 187.722 114.131 187.331Z"
          fill="#36B4C9"
        />
        <path
          d="M118.529 189.803C117.834 189.412 116.724 189.421 116.051 189.823C115.378 190.224 115.397 190.868 116.093 191.259C116.789 191.65 117.898 191.641 118.572 191.24C119.245 190.838 119.226 190.195 118.53 189.804"
          fill="#36B4C9"
        />
        <path
          d="M53.1786 157.456C52.483 157.065 51.3723 157.073 50.6999 157.475C50.0266 157.877 50.0457 158.52 50.7414 158.911C51.437 159.302 52.5477 159.294 53.2201 158.892C53.8934 158.49 53.8743 157.847 53.1786 157.456Z"
          fill="#36B4C9"
        />
        <path
          d="M57.5774 159.928C56.8809 159.537 55.771 159.546 55.0986 159.948C54.4254 160.349 54.4436 160.992 55.1401 161.384C55.8358 161.775 56.9456 161.766 57.6181 161.364C58.2913 160.962 58.273 160.319 57.5774 159.928Z"
          fill="#36B4C9"
        />
        <path
          d="M61.9758 162.398C61.2793 162.006 60.1694 162.015 59.497 162.417C58.8238 162.818 58.8421 163.461 59.5385 163.853C60.2342 164.244 61.3441 164.235 62.0165 163.833C62.6897 163.431 62.6715 162.789 61.9758 162.398Z"
          fill="#36B4C9"
        />
        <path
          d="M66.3739 164.874C65.6783 164.483 64.5676 164.491 63.8952 164.893C63.2219 165.295 63.241 165.938 63.9367 166.329C64.6332 166.72 65.743 166.712 66.4155 166.31C67.0887 165.908 67.0704 165.266 66.3739 164.874Z"
          fill="#36B4C9"
        />
        <path
          d="M70.7685 167.343C70.0728 166.952 68.9621 166.96 68.2897 167.362C67.6165 167.763 67.6356 168.407 68.3312 168.798C69.0269 169.189 70.1376 169.18 70.81 168.779C71.4832 168.377 71.4641 167.734 70.7685 167.343Z"
          fill="#36B4C9"
        />
        <path
          d="M75.1669 169.815C74.4713 169.424 73.3605 169.432 72.6881 169.834C72.0149 170.236 72.034 170.879 72.7296 171.27C73.4253 171.661 74.5352 171.653 75.2084 171.251C75.8817 170.85 75.8626 170.206 75.1669 169.815Z"
          fill="#36B4C9"
        />
        <path
          d="M79.5657 172.288C78.8692 171.897 77.7593 171.905 77.0869 172.307C76.4136 172.709 76.4319 173.351 77.1284 173.743C77.824 174.134 78.9339 174.125 79.6063 173.723C80.2796 173.321 80.2613 172.679 79.5657 172.288Z"
          fill="#36B4C9"
        />
        <path
          d="M83.9602 174.757C83.2637 174.366 82.1538 174.374 81.4814 174.776C80.8082 175.177 80.8264 175.82 81.5229 176.212C82.2186 176.603 83.3285 176.594 84.0009 176.192C84.6741 175.79 84.6558 175.148 83.9602 174.757Z"
          fill="#36B4C9"
        />
        <path
          d="M88.3579 177.233C87.6622 176.842 86.5524 176.851 85.88 177.253C85.2067 177.654 85.225 178.297 85.9206 178.688C86.6171 179.079 87.7262 179.071 88.3994 178.669C89.0726 178.267 89.0544 177.625 88.3579 177.233Z"
          fill="#36B4C9"
        />
        <path
          d="M92.7568 179.702C92.0611 179.311 90.9504 179.319 90.278 179.721C89.6048 180.123 89.6238 180.766 90.3195 181.157C91.0151 181.548 92.1259 181.54 92.7983 181.138C93.4715 180.736 93.4524 180.093 92.7568 179.702Z"
          fill="#36B4C9"
        />
        <path
          d="M97.1513 182.178C96.4556 181.787 95.3449 181.796 94.6725 182.198C93.9993 182.599 94.0184 183.243 94.714 183.634C95.4097 184.025 96.5204 184.016 97.1928 183.615C97.866 183.213 97.8469 182.569 97.1513 182.178Z"
          fill="#36B4C9"
        />
        <path
          d="M101.55 184.647C100.854 184.256 99.7437 184.265 99.0713 184.666C98.398 185.068 98.4163 185.711 99.1128 186.102C99.8084 186.493 100.919 186.485 101.592 186.083C102.265 185.682 102.246 185.038 101.55 184.647Z"
          fill="#36B4C9"
        />
        <path
          d="M105.948 187.12C105.252 186.729 104.142 186.737 103.47 187.139C102.796 187.541 102.815 188.183 103.511 188.575C104.207 188.966 105.317 188.957 105.989 188.555C106.662 188.153 106.644 187.511 105.948 187.12Z"
          fill="#36B4C9"
        />
        <path
          d="M110.342 189.592C109.647 189.201 108.537 189.21 107.864 189.612C107.191 190.014 107.209 190.656 107.905 191.047C108.601 191.438 109.711 191.43 110.384 191.028C111.057 190.626 111.039 189.984 110.342 189.592Z"
          fill="#36B4C9"
        />
        <path
          d="M114.741 192.061C114.045 191.67 112.935 191.679 112.262 192.08C111.589 192.482 111.608 193.126 112.304 193.516C113 193.907 114.11 193.899 114.783 193.497C115.456 193.096 115.437 192.452 114.741 192.061Z"
          fill="#36B4C9"
        />
        <path
          d="M49.3927 159.718C48.697 159.327 47.5871 159.335 46.9147 159.737C46.2415 160.138 46.2606 160.782 46.9562 161.173C47.6519 161.564 48.7618 161.555 49.435 161.154C50.1082 160.752 50.0891 160.109 49.3935 159.718"
          fill="#36B4C9"
        />
        <path
          d="M53.7914 162.186C53.0949 161.795 51.9859 161.804 51.3134 162.205C50.6402 162.607 50.6585 163.25 51.355 163.641C52.0506 164.032 53.1597 164.024 53.8329 163.622C54.5061 163.22 54.487 162.577 53.7914 162.186Z"
          fill="#36B4C9"
        />
        <path
          d="M58.1859 164.663C57.4894 164.271 56.3804 164.28 55.708 164.682C55.0347 165.084 55.053 165.727 55.7495 166.118C56.4451 166.509 57.5542 166.501 58.2274 166.098C58.9007 165.697 58.8816 165.054 58.1859 164.663Z"
          fill="#36B4C9"
        />
        <path
          d="M62.5841 167.132C61.8884 166.741 60.7785 166.749 60.1061 167.151C59.4329 167.552 59.452 168.196 60.1476 168.587C60.8441 168.978 61.9532 168.969 62.6264 168.568C63.2996 168.166 63.2805 167.523 62.5849 167.132"
          fill="#36B4C9"
        />
        <path
          d="M66.9825 169.604C66.2868 169.213 65.177 169.222 64.5045 169.623C63.8313 170.025 63.8504 170.668 64.5461 171.059C65.2417 171.45 66.3516 171.442 67.0248 171.04C67.6981 170.639 67.679 169.996 66.9833 169.605"
          fill="#36B4C9"
        />
        <path
          d="M71.3809 172.077C70.6853 171.686 69.5754 171.694 68.903 172.096C68.2298 172.498 68.2488 173.141 68.9445 173.532C69.6401 173.923 70.75 173.915 71.4233 173.513C72.0965 173.111 72.0774 172.469 71.3818 172.078"
          fill="#36B4C9"
        />
        <path
          d="M75.7758 174.55C75.0793 174.159 73.9702 174.167 73.2978 174.569C72.6246 174.97 72.6428 175.613 73.3393 176.005C74.035 176.396 75.144 176.387 75.8173 175.985C76.4905 175.583 76.4714 174.941 75.7758 174.55Z"
          fill="#36B4C9"
        />
        <path
          d="M80.1742 177.022C79.4777 176.631 78.3687 176.64 77.6963 177.041C77.023 177.443 77.0413 178.086 77.7378 178.477C78.4334 178.868 79.5425 178.86 80.2157 178.458C80.8889 178.056 80.8699 177.413 80.1742 177.022Z"
          fill="#36B4C9"
        />
        <path
          d="M84.5688 179.491C83.8732 179.1 82.7641 179.108 82.0909 179.51C81.4177 179.912 81.4359 180.554 82.1316 180.945C82.828 181.336 83.9371 181.328 84.6103 180.926C85.2836 180.524 85.2645 179.882 84.5688 179.491Z"
          fill="#36B4C9"
        />
        <path
          d="M88.9669 181.964C88.2712 181.573 87.1613 181.581 86.4889 181.983C85.8157 182.384 85.8348 183.028 86.5304 183.419C87.2261 183.81 88.336 183.802 89.0092 183.4C89.6824 182.998 89.6633 182.355 88.9677 181.964"
          fill="#36B4C9"
        />
        <path
          d="M93.3653 184.436C92.6697 184.045 91.5598 184.054 90.8874 184.455C90.2141 184.857 90.2332 185.501 90.9289 185.891C91.6245 186.282 92.7344 186.274 93.4076 185.872C94.0809 185.471 94.0618 184.828 93.3661 184.437"
          fill="#36B4C9"
        />
        <path
          d="M97.764 186.909C97.0676 186.518 95.9585 186.526 95.2861 186.928C94.6129 187.33 94.6311 187.972 95.3276 188.364C96.0233 188.755 97.1331 188.747 97.8064 188.345C98.4796 187.943 98.4605 187.301 97.7649 186.91"
          fill="#36B4C9"
        />
        <path
          d="M102.159 189.382C101.462 188.991 100.353 188.999 99.6806 189.401C99.0074 189.802 99.0257 190.445 99.7221 190.837C100.418 191.228 101.527 191.219 102.2 190.817C102.873 190.415 102.854 189.773 102.159 189.382Z"
          fill="#36B4C9"
        />
        <path
          d="M106.557 191.85C105.861 191.459 104.752 191.468 104.079 191.869C103.406 192.271 103.424 192.914 104.12 193.305C104.816 193.696 105.925 193.687 106.599 193.286C107.272 192.884 107.253 192.241 106.557 191.85Z"
          fill="#36B4C9"
        />
        <path
          d="M110.955 194.323C110.259 193.932 109.15 193.94 108.477 194.342C107.804 194.744 107.823 195.387 108.519 195.778C109.214 196.169 110.324 196.161 110.997 195.759C111.671 195.357 111.652 194.715 110.956 194.324"
          fill="#36B4C9"
        />
        <path
          d="M241.548 171.835C240.851 171.444 239.738 171.452 239.064 171.854C238.39 172.257 238.408 172.901 239.106 173.293C239.803 173.685 240.915 173.677 241.589 173.274C242.263 172.871 242.245 172.227 241.548 171.835Z"
          fill="#36B4C9"
        />
        <path
          d="M245.958 174.312C245.261 173.92 244.148 173.928 243.474 174.331C242.8 174.734 242.818 175.378 243.516 175.77C244.213 176.161 245.325 176.153 245.999 175.75C246.674 175.348 246.655 174.704 245.958 174.312Z"
          fill="#36B4C9"
        />
        <path
          d="M250.361 176.788C249.663 176.397 248.551 176.405 247.877 176.808C247.203 177.21 247.22 177.854 247.918 178.246C248.616 178.638 249.728 178.63 250.402 178.227C251.076 177.824 251.058 177.18 250.361 176.788Z"
          fill="#36B4C9"
        />
        <path
          d="M242.161 176.578C241.464 176.186 240.353 176.194 239.678 176.597C239.003 176.999 239.022 177.643 239.719 178.035C240.416 178.427 241.528 178.419 242.203 178.016C242.877 177.614 242.858 176.969 242.161 176.578Z"
          fill="#36B4C9"
        />
        <path
          d="M246.568 179.054C245.871 178.662 244.759 178.671 244.084 179.073C243.409 179.476 243.428 180.12 244.126 180.512C244.823 180.904 245.935 180.895 246.609 180.493C247.284 180.09 247.264 179.446 246.568 179.054Z"
          fill="#36B4C9"
        />
        <path
          d="M250.974 181.531C250.277 181.139 249.165 181.147 248.49 181.55C247.816 181.952 247.834 182.597 248.532 182.988C249.229 183.38 250.341 183.372 251.015 182.968C251.689 182.566 251.671 181.922 250.973 181.531"
          fill="#36B4C9"
        />
        <path
          d="M242.771 181.32C242.073 180.928 240.962 180.936 240.287 181.339C239.613 181.741 239.63 182.386 240.329 182.777C241.026 183.169 242.138 183.161 242.812 182.758C243.487 182.356 243.468 181.712 242.771 181.32Z"
          fill="#36B4C9"
        />
        <path
          d="M247.177 183.796C246.48 183.404 245.368 183.413 244.693 183.815C244.019 184.218 244.037 184.862 244.735 185.254C245.432 185.646 246.544 185.637 247.218 185.234C247.893 184.831 247.874 184.187 247.177 183.795"
          fill="#36B4C9"
        />
        <path
          d="M238.978 183.585C238.281 183.194 237.168 183.202 236.494 183.604C235.819 184.007 235.838 184.651 236.536 185.043C237.233 185.435 238.345 185.427 239.02 185.024C239.694 184.621 239.675 183.977 238.978 183.585Z"
          fill="#36B4C9"
        />
        <path
          d="M243.384 186.062C242.687 185.67 241.575 185.678 240.901 186.081C240.226 186.484 240.244 187.128 240.942 187.52C241.639 187.911 242.751 187.903 243.425 187.5C244.099 187.097 244.082 186.453 243.384 186.061"
          fill="#36B4C9"
        />
        <path
          d="M247.79 188.538C247.093 188.146 245.981 188.155 245.307 188.558C244.632 188.961 244.65 189.605 245.348 189.997C246.045 190.388 247.157 190.38 247.831 189.978C248.505 189.575 248.488 188.931 247.79 188.539"
          fill="#36B4C9"
        />
        <path
          d="M235.181 185.851C234.483 185.459 233.372 185.467 232.697 185.87C232.023 186.273 232.041 186.916 232.738 187.309C233.436 187.7 234.547 187.692 235.222 187.29C235.897 186.887 235.878 186.243 235.181 185.851Z"
          fill="#36B4C9"
        />
        <path
          d="M239.591 188.328C238.893 187.936 237.782 187.944 237.107 188.347C236.433 188.749 236.451 189.393 237.149 189.785C237.846 190.177 238.957 190.169 239.631 189.766C240.306 189.364 240.288 188.719 239.591 188.328Z"
          fill="#36B4C9"
        />
        <path
          d="M243.996 190.804C243.299 190.412 242.187 190.42 241.513 190.824C240.839 191.227 240.857 191.87 241.555 192.262C242.252 192.654 243.364 192.645 244.039 192.243C244.713 191.84 244.695 191.196 243.997 190.804"
          fill="#36B4C9"
        />
        <path
          d="M248.399 193.281C247.702 192.889 246.59 192.897 245.915 193.3C245.241 193.702 245.26 194.347 245.957 194.738C246.654 195.13 247.766 195.122 248.441 194.719C249.115 194.317 249.096 193.672 248.399 193.281Z"
          fill="#36B4C9"
        />
        <path
          d="M235.794 190.593C235.097 190.201 233.985 190.21 233.31 190.612C232.636 191.015 232.654 191.659 233.352 192.051C234.049 192.443 235.161 192.434 235.835 192.031C236.509 191.628 236.492 190.984 235.794 190.592"
          fill="#36B4C9"
        />
        <path
          d="M240.2 193.069C239.502 192.677 238.391 192.687 237.717 193.089C237.043 193.492 237.06 194.136 237.757 194.528C238.455 194.92 239.567 194.911 240.241 194.509C240.915 194.106 240.898 193.462 240.2 193.07"
          fill="#36B4C9"
        />
        <path
          d="M244.606 195.546C243.909 195.154 242.797 195.163 242.123 195.565C241.449 195.968 241.467 196.612 242.164 197.004C242.861 197.396 243.974 197.387 244.648 196.985C245.322 196.582 245.304 195.938 244.606 195.546Z"
          fill="#36B4C9"
        />
        <path
          d="M231.997 192.859C231.3 192.467 230.188 192.475 229.513 192.878C228.839 193.28 228.857 193.924 229.555 194.316C230.252 194.708 231.364 194.7 232.038 194.297C232.713 193.895 232.694 193.251 231.997 192.859Z"
          fill="#36B4C9"
        />
        <path
          d="M236.406 195.335C235.709 194.943 234.598 194.952 233.923 195.355C233.249 195.758 233.268 196.401 233.965 196.793C234.662 197.185 235.774 197.176 236.449 196.774C237.124 196.371 237.105 195.727 236.407 195.335"
          fill="#36B4C9"
        />
        <path
          d="M240.809 197.812C240.112 197.42 239 197.428 238.325 197.831C237.651 198.234 237.671 198.878 238.367 199.27C239.063 199.661 240.176 199.653 240.851 199.251C241.526 198.848 241.507 198.204 240.809 197.812Z"
          fill="#36B4C9"
        />
        <path
          d="M228.204 195.124C227.507 194.733 226.395 194.741 225.721 195.143C225.047 195.546 225.064 196.19 225.762 196.582C226.459 196.974 227.571 196.965 228.245 196.562C228.919 196.16 228.902 195.515 228.204 195.124"
          fill="#36B4C9"
        />
        <path
          d="M232.61 197.601C231.913 197.209 230.801 197.218 230.127 197.62C229.453 198.023 229.47 198.667 230.168 199.059C230.865 199.451 231.977 199.443 232.651 199.04C233.325 198.637 233.308 197.993 232.61 197.601"
          fill="#36B4C9"
        />
        <path
          d="M237.017 200.078C236.319 199.686 235.207 199.694 234.533 200.097C233.859 200.499 233.877 201.143 234.574 201.535C235.272 201.927 236.384 201.919 237.058 201.516C237.732 201.114 237.714 200.469 237.017 200.078Z"
          fill="#36B4C9"
        />
        <path
          d="M215.595 192.437C214.898 192.045 213.786 192.053 213.111 192.456C212.436 192.859 212.455 193.503 213.153 193.895C213.85 194.286 214.962 194.278 215.637 193.876C216.311 193.473 216.292 192.829 215.595 192.437Z"
          fill="#36B4C9"
        />
        <path
          d="M220.002 194.913C219.304 194.522 218.193 194.53 217.518 194.933C216.843 195.335 216.861 195.979 217.559 196.371C218.257 196.763 219.368 196.755 220.043 196.352C220.717 195.949 220.698 195.305 220.002 194.913Z"
          fill="#36B4C9"
        />
        <path
          d="M224.408 197.39C223.711 196.998 222.599 197.006 221.924 197.409C221.249 197.812 221.267 198.456 221.966 198.848C222.663 199.24 223.774 199.231 224.448 198.828C225.123 198.425 225.104 197.782 224.407 197.39"
          fill="#36B4C9"
        />
        <path
          d="M228.813 199.867C228.116 199.475 227.004 199.483 226.33 199.886C225.656 200.288 225.674 200.932 226.371 201.324C227.068 201.716 228.18 201.708 228.855 201.305C229.529 200.903 229.511 200.259 228.813 199.867Z"
          fill="#36B4C9"
        />
        <path
          d="M233.22 202.343C232.523 201.951 231.411 201.96 230.736 202.362C230.061 202.765 230.08 203.409 230.778 203.801C231.475 204.193 232.587 204.184 233.262 203.782C233.936 203.379 233.916 202.735 233.22 202.343Z"
          fill="#36B4C9"
        />
        <path
          d="M180.958 177.359C180.261 176.967 179.148 176.975 178.474 177.378C177.8 177.78 177.818 178.425 178.516 178.816C179.213 179.208 180.325 179.2 180.999 178.797C181.674 178.395 181.656 177.751 180.958 177.359Z"
          fill="#36B4C9"
        />
        <path
          d="M185.364 179.839C184.667 179.447 183.555 179.456 182.88 179.858C182.206 180.261 182.225 180.905 182.922 181.297C183.619 181.689 184.732 181.68 185.406 181.278C186.08 180.875 186.062 180.231 185.364 179.839Z"
          fill="#36B4C9"
        />
        <path
          d="M207.395 192.226C206.698 191.834 205.586 191.842 204.912 192.245C204.238 192.648 204.256 193.292 204.953 193.684C205.651 194.075 206.763 194.067 207.437 193.665C208.111 193.262 208.093 192.618 207.395 192.226Z"
          fill="#36B4C9"
        />
        <path
          d="M211.802 194.703C211.104 194.311 209.992 194.319 209.318 194.722C208.644 195.124 208.662 195.768 209.359 196.16C210.057 196.552 211.169 196.544 211.843 196.141C212.517 195.739 212.499 195.094 211.802 194.703Z"
          fill="#36B4C9"
        />
        <path
          d="M216.208 197.179C215.511 196.787 214.399 196.796 213.725 197.198C213.05 197.601 213.068 198.245 213.766 198.637C214.463 199.029 215.576 199.02 216.25 198.618C216.924 198.215 216.906 197.571 216.208 197.179Z"
          fill="#36B4C9"
        />
        <path
          d="M177.161 179.624C176.464 179.233 175.353 179.241 174.678 179.643C174.003 180.046 174.022 180.69 174.719 181.082C175.416 181.474 176.528 181.466 177.203 181.063C177.877 180.66 177.859 180.017 177.161 179.624Z"
          fill="#36B4C9"
        />
        <path
          d="M181.568 182.105C180.87 181.713 179.759 181.721 179.084 182.124C178.409 182.527 178.428 183.171 179.125 183.563C179.823 183.954 180.934 183.946 181.609 183.543C182.283 183.141 182.264 182.497 181.568 182.105Z"
          fill="#36B4C9"
        />
        <path
          d="M185.974 184.581C185.277 184.19 184.165 184.198 183.49 184.601C182.815 185.003 182.834 185.647 183.532 186.039C184.229 186.431 185.341 186.423 186.015 186.02C186.689 185.617 186.67 184.973 185.974 184.581Z"
          fill="#36B4C9"
        />
        <path
          d="M190.38 187.058C189.683 186.666 188.572 186.674 187.897 187.077C187.222 187.48 187.24 188.124 187.938 188.516C188.636 188.908 189.747 188.899 190.422 188.496C191.096 188.093 191.078 187.45 190.38 187.058Z"
          fill="#36B4C9"
        />
        <path
          d="M194.787 189.535C194.089 189.143 192.978 189.151 192.303 189.554C191.628 189.956 191.646 190.6 192.344 190.992C193.042 191.384 194.153 191.376 194.828 190.972C195.502 190.57 195.484 189.926 194.787 189.535Z"
          fill="#36B4C9"
        />
        <path
          d="M199.192 192.011C198.495 191.619 197.383 191.628 196.709 192.03C196.034 192.433 196.053 193.077 196.75 193.469C197.447 193.861 198.559 193.852 199.234 193.45C199.908 193.047 199.89 192.404 199.192 192.011Z"
          fill="#36B4C9"
        />
        <path
          d="M203.599 194.492C202.902 194.1 201.79 194.108 201.115 194.511C200.44 194.913 200.459 195.557 201.157 195.949C201.854 196.341 202.966 196.333 203.64 195.93C204.315 195.528 204.295 194.883 203.599 194.492Z"
          fill="#36B4C9"
        />
        <path
          d="M208.005 196.964C207.308 196.572 206.196 196.581 205.521 196.983C204.847 197.386 204.866 198.03 205.563 198.422C206.26 198.814 207.372 198.805 208.047 198.403C208.721 198 208.702 197.356 208.005 196.964Z"
          fill="#36B4C9"
        />
        <path
          d="M177.774 184.37C177.077 183.979 175.966 183.987 175.291 184.39C174.617 184.792 174.635 185.436 175.332 185.828C176.029 186.22 177.142 186.212 177.816 185.809C178.491 185.406 178.472 184.762 177.774 184.37Z"
          fill="#36B4C9"
        />
        <path
          d="M182.181 186.847C181.483 186.455 180.372 186.464 179.697 186.866C179.023 187.269 179.041 187.913 179.738 188.305C180.436 188.697 181.548 188.688 182.222 188.286C182.897 187.883 182.878 187.239 182.181 186.847Z"
          fill="#36B4C9"
        />
        <path
          d="M186.587 189.324C185.89 188.932 184.778 188.94 184.103 189.343C183.429 189.745 183.447 190.39 184.145 190.781C184.842 191.173 185.954 191.164 186.629 190.761C187.304 190.359 187.285 189.715 186.588 189.323"
          fill="#36B4C9"
        />
        <path
          d="M190.993 191.8C190.296 191.408 189.185 191.417 188.51 191.819C187.836 192.222 187.853 192.866 188.551 193.258C189.249 193.65 190.36 193.641 191.035 193.238C191.71 192.835 191.692 192.191 190.994 191.799"
          fill="#36B4C9"
        />
        <path
          d="M195.4 194.277C194.702 193.885 193.591 193.893 192.916 194.297C192.242 194.699 192.259 195.343 192.957 195.735C193.654 196.127 194.766 196.119 195.44 195.716C196.115 195.313 196.097 194.669 195.399 194.277"
          fill="#36B4C9"
        />
        <path
          d="M199.806 196.757C199.108 196.365 197.997 196.374 197.322 196.776C196.648 197.179 196.666 197.823 197.363 198.215C198.061 198.607 199.173 198.598 199.847 198.196C200.522 197.793 200.503 197.149 199.806 196.757Z"
          fill="#36B4C9"
        />
        <path
          d="M178.384 189.109C177.687 188.717 176.574 188.725 175.9 189.128C175.225 189.53 175.245 190.175 175.942 190.566C176.639 190.958 177.751 190.95 178.426 190.547C179.1 190.145 179.081 189.501 178.384 189.109Z"
          fill="#36B4C9"
        />
        <path
          d="M182.791 191.589C182.093 191.197 180.981 191.206 180.307 191.608C179.632 192.011 179.65 192.655 180.348 193.047C181.046 193.439 182.157 193.43 182.832 193.027C183.506 192.624 183.489 191.98 182.791 191.588"
          fill="#36B4C9"
        />
        <path
          d="M187.197 194.066C186.5 193.674 185.387 193.682 184.713 194.085C184.038 194.488 184.056 195.132 184.755 195.524C185.452 195.915 186.563 195.907 187.238 195.504C187.912 195.101 187.895 194.457 187.198 194.065"
          fill="#36B4C9"
        />
        <path
          d="M191.603 196.542C190.906 196.15 189.794 196.159 189.119 196.562C188.445 196.965 188.463 197.609 189.16 198C189.857 198.392 190.969 198.384 191.644 197.981C192.318 197.579 192.301 196.935 191.602 196.543"
          fill="#36B4C9"
        />
        <path
          d="M252.094 195.523C251.397 195.131 250.286 195.139 249.611 195.542C248.937 195.945 248.956 196.589 249.652 196.981C250.349 197.372 251.461 197.364 252.136 196.961C252.811 196.559 252.792 195.915 252.094 195.523Z"
          fill="#36B4C9"
        />
        <path
          d="M256.501 197.999C255.804 197.608 254.692 197.616 254.017 198.018C253.343 198.421 253.361 199.064 254.059 199.457C254.756 199.849 255.868 199.841 256.542 199.438C257.217 199.035 257.198 198.391 256.501 197.999Z"
          fill="#36B4C9"
        />
        <path
          d="M260.907 200.476C260.21 200.084 259.098 200.092 258.423 200.495C257.749 200.898 257.768 201.541 258.465 201.934C259.162 202.325 260.274 202.317 260.948 201.915C261.623 201.512 261.605 200.868 260.907 200.476Z"
          fill="#36B4C9"
        />
        <path
          d="M265.313 202.956C264.616 202.565 263.504 202.573 262.829 202.976C262.155 203.378 262.174 204.022 262.871 204.414C263.568 204.806 264.68 204.798 265.355 204.395C266.03 203.992 266.011 203.348 265.313 202.956Z"
          fill="#36B4C9"
        />
        <path
          d="M269.719 205.429C269.022 205.037 267.911 205.046 267.236 205.448C266.562 205.851 266.581 206.495 267.277 206.887C267.974 207.279 269.086 207.27 269.761 206.868C270.436 206.465 270.417 205.821 269.719 205.429Z"
          fill="#36B4C9"
        />
        <path
          d="M274.126 207.91C273.428 207.518 272.317 207.526 271.642 207.929C270.968 208.331 270.987 208.975 271.683 209.367C272.381 209.759 273.492 209.751 274.166 209.348C274.841 208.946 274.822 208.301 274.125 207.91"
          fill="#36B4C9"
        />
        <path
          d="M278.532 210.386C277.835 209.994 276.723 210.003 276.048 210.405C275.374 210.808 275.393 211.451 276.09 211.844C276.787 212.236 277.899 212.227 278.573 211.825C279.248 211.422 279.23 210.778 278.532 210.386Z"
          fill="#36B4C9"
        />
        <path
          d="M282.938 212.863C282.241 212.471 281.13 212.479 280.455 212.882C279.781 213.284 279.799 213.928 280.496 214.32C281.194 214.712 282.305 214.704 282.979 214.301C283.654 213.899 283.636 213.254 282.938 212.863Z"
          fill="#36B4C9"
        />
        <path
          d="M287.345 215.339C286.647 214.947 285.536 214.956 284.861 215.359C284.187 215.762 284.205 216.405 284.902 216.797C285.6 217.189 286.711 217.18 287.385 216.778C288.06 216.375 288.042 215.731 287.344 215.339"
          fill="#36B4C9"
        />
        <path
          d="M291.751 217.816C291.053 217.424 289.942 217.432 289.267 217.835C288.593 218.238 288.612 218.882 289.308 219.274C290.006 219.665 291.117 219.657 291.792 219.254C292.467 218.852 292.448 218.208 291.751 217.816Z"
          fill="#36B4C9"
        />
        <path
          d="M248.298 197.788C247.601 197.397 246.488 197.405 245.814 197.808C245.14 198.21 245.158 198.854 245.856 199.246C246.553 199.638 247.665 199.63 248.339 199.227C249.013 198.824 248.995 198.18 248.298 197.788Z"
          fill="#36B4C9"
        />
        <path
          d="M252.704 200.265C252.007 199.873 250.895 199.881 250.221 200.284C249.547 200.687 249.564 201.331 250.262 201.723C250.959 202.115 252.071 202.105 252.745 201.703C253.419 201.3 253.402 200.656 252.704 200.264"
          fill="#36B4C9"
        />
        <path
          d="M257.111 202.742C256.413 202.35 255.301 202.358 254.627 202.761C253.953 203.163 253.97 203.807 254.668 204.199C255.366 204.591 256.477 204.582 257.151 204.179C257.825 203.777 257.808 203.133 257.111 202.741"
          fill="#36B4C9"
        />
        <path
          d="M261.517 205.218C260.819 204.826 259.707 204.835 259.033 205.237C258.359 205.64 258.377 206.284 259.074 206.676C259.772 207.068 260.884 207.059 261.558 206.657C262.232 206.254 262.215 205.61 261.517 205.218Z"
          fill="#36B4C9"
        />
        <path
          d="M265.923 207.695C265.226 207.303 264.113 207.311 263.439 207.714C262.765 208.116 262.783 208.761 263.481 209.152C264.178 209.544 265.29 209.536 265.964 209.133C266.638 208.731 266.62 208.087 265.923 207.695Z"
          fill="#36B4C9"
        />
        <path
          d="M270.329 210.175C269.632 209.783 268.519 209.792 267.845 210.194C267.171 210.597 267.19 211.241 267.887 211.633C268.584 212.025 269.697 212.016 270.371 211.614C271.045 211.211 271.026 210.567 270.329 210.175Z"
          fill="#36B4C9"
        />
        <path
          d="M274.736 212.648C274.038 212.256 272.926 212.264 272.252 212.667C271.578 213.07 271.595 213.714 272.293 214.106C272.991 214.497 274.102 214.488 274.777 214.086C275.451 213.683 275.434 213.039 274.736 212.647"
          fill="#36B4C9"
        />
        <path
          d="M279.142 215.128C278.445 214.736 277.332 214.745 276.658 215.147C275.984 215.55 276.001 216.194 276.7 216.586C277.397 216.978 278.509 216.969 279.183 216.566C279.857 216.163 279.84 215.519 279.143 215.127"
          fill="#36B4C9"
        />
        <path
          d="M283.548 217.604C282.851 217.213 281.739 217.222 281.064 217.624C280.39 218.027 280.408 218.671 281.105 219.063C281.802 219.455 282.915 219.447 283.589 219.044C284.263 218.641 284.246 217.997 283.547 217.605"
          fill="#36B4C9"
        />
        <path
          d="M287.954 220.081C287.257 219.69 286.144 219.698 285.47 220.101C284.796 220.503 284.815 221.147 285.512 221.539C286.209 221.931 287.322 221.923 287.996 221.52C288.67 221.117 288.651 220.473 287.954 220.081Z"
          fill="#36B4C9"
        />
        <path
          d="M292.36 222.558C291.663 222.166 290.551 222.174 289.877 222.577C289.203 222.98 289.221 223.624 289.918 224.016C290.615 224.408 291.728 224.399 292.402 223.997C293.076 223.594 293.058 222.95 292.36 222.558Z"
          fill="#36B4C9"
        />
        <path
          d="M244.505 200.054C243.807 199.662 242.696 199.671 242.021 200.073C241.347 200.476 241.366 201.12 242.062 201.512C242.76 201.904 243.871 201.895 244.546 201.493C245.221 201.09 245.202 200.446 244.505 200.054Z"
          fill="#36B4C9"
        />
        <path
          d="M248.911 202.531C248.214 202.139 247.102 202.147 246.427 202.55C245.753 202.952 245.772 203.596 246.469 203.988C247.166 204.38 248.278 204.372 248.952 203.969C249.627 203.567 249.608 202.922 248.911 202.531Z"
          fill="#36B4C9"
        />
        <path
          d="M253.317 205.007C252.62 204.615 251.508 204.624 250.834 205.026C250.16 205.429 250.178 206.072 250.875 206.465C251.572 206.857 252.684 206.848 253.358 206.446C254.033 206.043 254.015 205.399 253.317 205.007Z"
          fill="#36B4C9"
        />
        <path
          d="M257.723 207.484C257.026 207.092 255.914 207.1 255.24 207.503C254.565 207.905 254.585 208.55 255.281 208.941C255.978 209.333 257.09 209.325 257.765 208.922C258.44 208.52 258.421 207.876 257.723 207.484Z"
          fill="#36B4C9"
        />
        <path
          d="M262.13 209.964C261.432 209.572 260.321 209.581 259.646 209.983C258.972 210.386 258.991 211.03 259.687 211.422C260.385 211.814 261.496 211.805 262.171 211.403C262.846 211 262.827 210.356 262.13 209.964Z"
          fill="#36B4C9"
        />
        <path
          d="M270.942 214.917C270.245 214.526 269.133 214.534 268.459 214.936C267.785 215.339 267.803 215.982 268.5 216.375C269.197 216.767 270.309 216.759 270.983 216.356C271.658 215.953 271.64 215.309 270.942 214.917Z"
          fill="#36B4C9"
        />
        <path
          d="M275.349 217.394C274.651 217.002 273.54 217.01 272.865 217.413C272.191 217.816 272.209 218.459 272.906 218.852C273.604 219.243 274.715 219.235 275.389 218.833C276.064 218.43 276.046 217.786 275.349 217.394Z"
          fill="#36B4C9"
        />
        <path
          d="M279.755 219.87C279.058 219.479 277.946 219.487 277.271 219.89C276.597 220.293 276.615 220.936 277.313 221.328C278.01 221.72 279.121 221.712 279.796 221.309C280.47 220.906 280.452 220.262 279.754 219.87"
          fill="#36B4C9"
        />
        <path
          d="M284.161 222.347C283.464 221.955 282.352 221.964 281.677 222.366C281.003 222.769 281.022 223.413 281.719 223.805C282.416 224.197 283.527 224.188 284.202 223.786C284.877 223.383 284.858 222.739 284.161 222.347Z"
          fill="#36B4C9"
        />
        <path
          d="M288.567 224.824C287.87 224.432 286.758 224.44 286.083 224.843C285.409 225.245 285.428 225.889 286.125 226.281C286.822 226.673 287.934 226.665 288.609 226.262C289.283 225.86 289.264 225.215 288.567 224.824Z"
          fill="#36B4C9"
        />
        <path
          d="M292.974 227.304C292.276 226.912 291.165 226.921 290.49 227.323C289.816 227.726 289.834 228.369 290.531 228.762C291.229 229.154 292.34 229.145 293.015 228.743C293.69 228.34 293.671 227.696 292.974 227.304Z"
          fill="#36B4C9"
        />
        <path
          d="M240.708 202.32C240.011 201.928 238.898 201.936 238.224 202.339C237.55 202.741 237.568 203.386 238.266 203.777C238.963 204.169 240.075 204.161 240.749 203.758C241.424 203.356 241.405 202.712 240.708 202.32Z"
          fill="#36B4C9"
        />
        <path
          d="M245.115 204.796C244.417 204.404 243.305 204.413 242.631 204.815C241.957 205.218 241.974 205.862 242.672 206.254C243.37 206.646 244.481 206.637 245.155 206.234C245.829 205.831 245.812 205.187 245.115 204.795"
          fill="#36B4C9"
        />
        <path
          d="M249.521 207.273C248.823 206.881 247.711 206.889 247.037 207.292C246.363 207.695 246.38 208.339 247.079 208.731C247.776 209.122 248.887 209.113 249.561 208.711C250.236 208.308 250.218 207.664 249.521 207.272"
          fill="#36B4C9"
        />
        <path
          d="M253.927 209.749C253.229 209.358 252.117 209.366 251.443 209.768C250.769 210.171 250.787 210.815 251.484 211.207C252.182 211.599 253.294 211.591 253.968 211.188C254.642 210.785 254.625 210.141 253.927 209.749Z"
          fill="#36B4C9"
        />
        <path
          d="M271.552 219.656C270.855 219.264 269.742 219.272 269.068 219.675C268.394 220.077 268.412 220.722 269.11 221.113C269.807 221.505 270.919 221.496 271.594 221.093C272.268 220.691 272.25 220.047 271.553 219.655"
          fill="#36B4C9"
        />
        <path
          d="M275.958 222.136C275.261 221.744 274.15 221.753 273.475 222.156C272.801 222.558 272.818 223.202 273.515 223.594C274.213 223.986 275.325 223.978 275.999 223.575C276.673 223.173 276.656 222.528 275.958 222.137"
          fill="#36B4C9"
        />
        <path
          d="M280.364 224.613C279.667 224.221 278.555 224.229 277.88 224.632C277.206 225.034 277.225 225.679 277.922 226.07C278.619 226.462 279.732 226.454 280.406 226.051C281.08 225.649 281.062 225.004 280.364 224.613Z"
          fill="#36B4C9"
        />
        <path
          d="M284.77 227.089C284.073 226.697 282.961 226.706 282.287 227.108C281.613 227.511 281.631 228.155 282.328 228.547C283.026 228.939 284.138 228.93 284.812 228.528C285.486 228.125 285.468 227.481 284.77 227.089Z"
          fill="#36B4C9"
        />
        <path
          d="M289.177 229.57C288.48 229.178 287.367 229.186 286.693 229.589C286.019 229.991 286.037 230.636 286.735 231.027C287.432 231.419 288.544 231.411 289.219 231.008C289.893 230.606 289.874 229.962 289.177 229.57Z"
          fill="#36B4C9"
        />
        <path
          d="M236.915 204.585C236.218 204.194 235.106 204.202 234.432 204.604C233.757 205.007 233.776 205.651 234.473 206.043C235.17 206.435 236.282 206.427 236.957 206.024C237.631 205.621 237.612 204.977 236.915 204.585Z"
          fill="#36B4C9"
        />
        <path
          d="M241.318 207.062C240.621 206.67 239.509 206.678 238.834 207.081C238.159 207.484 238.178 208.128 238.876 208.52C239.573 208.911 240.685 208.903 241.359 208.5C242.033 208.097 242.014 207.454 241.317 207.062"
          fill="#36B4C9"
        />
        <path
          d="M245.724 209.538C245.027 209.147 243.915 209.155 243.24 209.558C242.566 209.96 242.584 210.604 243.282 210.996C243.979 211.388 245.091 211.38 245.765 210.976C246.439 210.574 246.421 209.93 245.723 209.538"
          fill="#36B4C9"
        />
        <path
          d="M272.165 224.402C271.468 224.01 270.356 224.018 269.682 224.421C269.007 224.823 269.025 225.468 269.723 225.859C270.42 226.251 271.532 226.243 272.206 225.84C272.88 225.438 272.862 224.794 272.165 224.402Z"
          fill="#36B4C9"
        />
        <path
          d="M276.572 226.878C275.874 226.486 274.763 226.495 274.088 226.897C273.413 227.3 273.432 227.944 274.129 228.336C274.827 228.728 275.938 228.72 276.613 228.317C277.287 227.914 277.268 227.27 276.572 226.878Z"
          fill="#36B4C9"
        />
        <path
          d="M280.978 229.359C280.281 228.967 279.169 228.975 278.494 229.378C277.819 229.78 277.838 230.425 278.536 230.816C279.233 231.208 280.344 231.2 281.019 230.797C281.693 230.395 281.674 229.751 280.978 229.359Z"
          fill="#36B4C9"
        />
        <path
          d="M285.384 231.835C284.687 231.444 283.576 231.452 282.901 231.854C282.226 232.257 282.244 232.901 282.942 233.293C283.639 233.685 284.751 233.677 285.426 233.274C286.1 232.871 286.081 232.227 285.384 231.835Z"
          fill="#36B4C9"
        />
        <path
          d="M237.525 209.328C236.827 208.936 235.715 208.944 235.041 209.347C234.367 209.749 234.384 210.393 235.082 210.785C235.78 211.177 236.891 211.168 237.565 210.765C238.239 210.363 238.222 209.718 237.525 209.327"
          fill="#36B4C9"
        />
        <path
          d="M272.774 229.14C272.077 228.748 270.965 228.756 270.291 229.159C269.617 229.562 269.635 230.206 270.332 230.598C271.029 230.99 272.142 230.981 272.816 230.579C273.49 230.176 273.472 229.532 272.774 229.14Z"
          fill="#36B4C9"
        />
        <path
          d="M277.181 231.624C276.483 231.233 275.371 231.241 274.697 231.643C274.023 232.046 274.041 232.69 274.738 233.082C275.436 233.474 276.548 233.466 277.222 233.063C277.896 232.66 277.878 232.016 277.181 231.624Z"
          fill="#36B4C9"
        />
        <path
          d="M180.321 17.9771L151.306 34.788L122.129 17.9771L149.939 0.335938L180.321 17.9771Z"
          fill="#DDF3F6"
        />
        <path
          d="M180.319 17.9766V76.8777L151.305 93.6887V34.7875L180.319 17.9766Z"
          fill="#36B4C9"
        />
        <path
          d="M151.307 34.7875V93.6887L129.044 80.8607L122.129 76.8777V17.9766L151.307 34.7875Z"
          fill="#2D96A7"
        />
        <path
          d="M151.305 35.1212C151.248 35.1212 151.19 35.1062 151.138 35.0763L121.961 18.2653C121.859 18.2072 121.796 18.0993 121.793 17.9823C121.791 17.8652 121.849 17.7556 121.948 17.6925L149.759 0.0522545C149.864 -0.0149862 149.998 -0.0174765 150.105 0.0456134L180.487 17.6859C180.59 17.7457 180.653 17.8561 180.653 17.9756C180.653 18.0952 180.59 18.2047 180.487 18.2653L151.473 35.0763C151.421 35.1062 151.363 35.1212 151.305 35.1212ZM122.774 17.9615L151.305 34.3998L179.653 17.9748L149.946 0.725491L122.774 17.9607V17.9615Z"
          fill="#133345"
        />
        <path
          d="M151.303 94.0221C151.246 94.0221 151.188 94.0072 151.136 93.9773C151.033 93.9175 150.969 93.8071 150.969 93.6876V34.7865C150.969 34.6669 151.033 34.5565 151.136 34.4968L180.15 17.6858C180.253 17.626 180.38 17.6252 180.484 17.6858C180.588 17.7455 180.652 17.8559 180.652 17.9755V76.8766C180.652 76.9962 180.588 77.1066 180.485 77.1663L151.471 93.9773C151.42 94.0072 151.361 94.0221 151.303 94.0221ZM151.638 34.9791V93.1073L179.983 76.684V18.5557L151.638 34.9791Z"
          fill="#133345"
        />
        <path
          d="M151.305 94.0218C151.248 94.0218 151.19 94.0069 151.138 93.977L121.961 77.166C121.857 77.1063 121.793 76.9958 121.793 76.8763V17.9752C121.793 17.8556 121.857 17.7452 121.96 17.6855C122.064 17.6257 122.191 17.6257 122.294 17.6855L151.472 34.4964C151.576 34.5562 151.64 34.6666 151.64 34.7862V93.6873C151.64 93.8068 151.576 93.9172 151.473 93.977C151.421 94.0069 151.363 94.0218 151.305 94.0218ZM122.462 76.6829L150.97 93.1087V34.9796L122.462 18.5538V76.6829Z"
          fill="#133345"
        />
        <path
          d="M133.768 64.0836L129.044 61.3558V80.8572L122.129 76.8743V42.8015L124.329 39.7109L133.768 64.0836Z"
          fill="#36B4C9"
        />
        <path
          d="M224.039 17.9725L195.025 34.7835L165.848 17.9725L195.025 1.125L224.039 17.9725Z"
          fill="#DDF3F6"
        />
        <path
          d="M223.991 17.9688L224.038 102.122L195.024 118.933L194.977 34.7797L223.991 17.9688Z"
          fill="#36B4C9"
        />
        <path
          d="M195.025 118.933L165.848 102.122V17.9688L195.025 34.7797V118.933Z"
          fill="#2D96A7"
        />
        <path
          d="M195.024 35.1206C194.966 35.1206 194.908 35.1056 194.857 35.0757L165.679 18.2647C165.576 18.205 165.512 18.0946 165.512 17.975C165.512 17.8555 165.576 17.7451 165.679 17.6853L194.856 0.837796C194.96 0.778026 195.088 0.778026 195.191 0.837796L224.205 17.6845C224.308 17.7442 224.372 17.8547 224.372 17.9742C224.372 18.0937 224.308 18.2033 224.205 18.2639L195.191 35.0749C195.14 35.1048 195.082 35.1197 195.024 35.1197V35.1206ZM166.516 17.975L195.024 34.4L223.372 17.975L195.023 1.51435L166.515 17.9742L166.516 17.975Z"
          fill="#133345"
        />
        <path
          d="M195.022 119.267C194.964 119.267 194.906 119.252 194.855 119.222C194.751 119.162 194.687 119.052 194.687 118.932L194.641 34.7783C194.641 34.6588 194.704 34.5484 194.807 34.4886L223.821 17.6776C223.925 17.6179 224.052 17.6179 224.156 17.6776C224.26 17.7374 224.324 17.8478 224.324 17.9674L224.37 102.121C224.37 102.241 224.307 102.351 224.203 102.411L195.189 119.222C195.138 119.252 195.08 119.267 195.022 119.267ZM195.31 34.9709L195.356 118.352L223.702 101.928L223.655 18.5476L195.31 34.9709Z"
          fill="#133345"
        />
        <path
          d="M195.024 119.267C194.966 119.267 194.908 119.252 194.857 119.222L165.679 102.411C165.576 102.351 165.512 102.241 165.512 102.121V17.9674C165.512 17.8478 165.576 17.7374 165.679 17.6776C165.782 17.6179 165.909 17.6179 166.013 17.6776L195.191 34.4886C195.294 34.5484 195.358 34.6588 195.358 34.7783V118.932C195.358 119.052 195.294 119.162 195.191 119.222C195.14 119.252 195.082 119.267 195.024 119.267ZM166.181 101.928L194.689 118.353V34.9718L166.181 18.546V101.928Z"
          fill="#133345"
        />
        <path
          d="M267.759 78.2295L238.744 95.0405L209.566 78.2295L238.744 61.3828L267.759 78.2295Z"
          fill="#DDF3F6"
        />
        <path
          d="M267.757 78.2344V127.366L238.742 144.177V95.0454L267.757 78.2344Z"
          fill="#36B4C9"
        />
        <path
          d="M238.744 144.177L209.566 127.366V78.2344L238.744 95.0454V144.177Z"
          fill="#2D96A7"
        />
        <path
          d="M219.609 72.4319C219.79 72.3273 251.429 68.7486 251.429 68.7486L238.744 61.3828L219.609 72.431V72.4319Z"
          fill="#36B4C9"
        />
        <path
          d="M238.742 95.3775C238.685 95.3775 238.627 95.3626 238.576 95.3327L209.398 78.5217C209.294 78.462 209.23 78.3515 209.23 78.232C209.23 78.1125 209.294 78.0021 209.397 77.9423L238.575 61.0956C238.679 61.0358 238.806 61.0358 238.91 61.0956L267.924 77.9423C268.027 78.0021 268.091 78.1125 268.091 78.232C268.091 78.3515 268.027 78.4611 267.924 78.5217L238.91 95.3327C238.859 95.3626 238.801 95.3775 238.742 95.3775ZM210.235 78.232L238.742 94.657L267.091 78.232L238.742 61.7722L210.235 78.232Z"
          fill="#133345"
        />
        <path
          d="M238.741 144.51C238.684 144.51 238.625 144.495 238.574 144.465C238.47 144.405 238.406 144.295 238.406 144.175V95.044C238.406 94.9244 238.47 94.814 238.573 94.7543L267.587 77.9433C267.691 77.8835 267.819 77.8835 267.922 77.9433C268.025 78.003 268.089 78.1134 268.089 78.233V127.364C268.089 127.484 268.025 127.594 267.922 127.654L238.908 144.465C238.857 144.495 238.799 144.51 238.741 144.51ZM239.075 95.2366V143.594L267.42 127.171V78.8141L239.075 95.2374V95.2366Z"
          fill="#133345"
        />
        <path
          d="M238.742 144.51C238.685 144.51 238.627 144.495 238.576 144.465L209.398 127.654C209.294 127.594 209.23 127.484 209.23 127.364V78.233C209.23 78.1134 209.294 78.003 209.397 77.9433C209.501 77.8835 209.628 77.8835 209.732 77.9433L238.909 94.7543C239.013 94.814 239.077 94.9244 239.077 95.044V144.175C239.077 144.295 239.013 144.405 238.91 144.465C238.859 144.495 238.801 144.51 238.742 144.51ZM209.9 127.171L238.408 143.597V95.2374L209.9 78.8116V127.171Z"
          fill="#133345"
        />
        <path
          d="M311.359 126.487L282.345 143.298L253.168 126.487L282.345 109.641L311.359 126.487Z"
          fill="#DDF3F6"
        />
        <path
          d="M311.358 126.492V152.609L282.344 169.42V143.303L311.358 126.492Z"
          fill="#36B4C9"
        />
        <path
          d="M282.345 169.42L253.168 152.609V126.492L282.345 143.303V169.42Z"
          fill="#2D96A7"
        />
        <path
          d="M262.615 121.032L299.434 119.564L282.343 109.641L262.125 121.314"
          fill="#36B4C9"
        />
        <path
          d="M282.344 143.635C282.287 143.635 282.229 143.62 282.177 143.591L253 126.78C252.896 126.72 252.832 126.609 252.832 126.49C252.832 126.37 252.896 126.26 252.999 126.2L282.176 109.353C282.28 109.294 282.408 109.294 282.512 109.353L311.526 126.2C311.629 126.26 311.692 126.37 311.692 126.49C311.692 126.609 311.629 126.719 311.526 126.78L282.512 143.591C282.46 143.62 282.402 143.635 282.344 143.635ZM253.836 126.49L282.344 142.915L310.692 126.49L282.344 110.03L253.836 126.49Z"
          fill="#133345"
        />
        <path
          d="M282.342 169.753C282.284 169.753 282.227 169.738 282.176 169.708C282.072 169.648 282.008 169.538 282.008 169.419V143.302C282.008 143.182 282.072 143.072 282.175 143.012L311.189 126.201C311.292 126.141 311.419 126.141 311.523 126.201C311.627 126.261 311.691 126.371 311.691 126.491V152.608C311.691 152.727 311.627 152.837 311.524 152.897L282.51 169.708C282.459 169.738 282.4 169.753 282.342 169.753ZM282.677 143.494V168.837L311.022 152.414V127.071L282.677 143.494Z"
          fill="#133345"
        />
        <path
          d="M282.344 169.753C282.287 169.753 282.229 169.738 282.177 169.708L253 152.897C252.896 152.837 252.832 152.727 252.832 152.608V126.491C252.832 126.371 252.896 126.261 252.999 126.201C253.103 126.141 253.23 126.141 253.333 126.201L282.511 143.012C282.615 143.072 282.679 143.182 282.679 143.302V169.419C282.679 169.538 282.615 169.648 282.512 169.708C282.46 169.738 282.402 169.753 282.344 169.753ZM253.501 152.414L282.009 168.84V143.495L253.501 127.069V152.414Z"
          fill="#133345"
        />
        <path
          d="M1.69901 155.497L3.12684 154.673H6.20912V155.745L93.0533 105.602C94.5326 104.747 96.3531 104.747 97.8315 105.602L111.139 113.285L113.754 114.795L116.36 113.282C116.36 113.282 116.368 113.278 116.372 113.275C117.292 112.747 118.778 112.748 119.701 113.28L123.667 115.571C124.455 116.026 125.686 116.105 126.614 115.755C131.155 114.042 137.098 114.081 141.594 115.874V114.641H144.812C146.549 115.995 147.434 117.6 147.468 119.207V122.437C147.443 123.513 147.038 124.584 146.25 125.579L146.706 125.842H146.031C145.934 125.953 145.831 126.064 145.724 126.175H147.282L149.618 127.524C150.082 127.792 150.316 128.144 150.316 128.497V131.527C150.316 131.873 150.09 132.218 149.638 132.484L150.316 132.875V135.905L166.547 145.277V143.691H169.048L171.161 144.912C172.001 145.396 172.42 146.244 172.42 147.093V150.124C172.42 150.972 172 151.821 171.161 152.306L166.68 154.892L81.2596 204.208C78.6862 205.693 75.5159 205.693 72.9425 204.208L6.20995 165.676L1.69901 163.071C0.790019 162.545 0.335938 161.627 0.335938 160.709V157.858C0.335938 156.94 0.790019 156.022 1.69901 155.497V155.497Z"
          fill="#36B4C9"
        />
        <path
          d="M0.335938 157.679C0.335938 158.209 0.487852 158.739 0.79168 159.194C1.01166 159.527 1.31466 159.818 1.69901 160.04L6.20995 162.645L72.9409 201.175C75.5143 202.661 78.6846 202.661 81.258 201.175L166.546 151.937L171.16 149.273C171.469 149.094 171.722 148.865 171.917 148.606C172.252 148.162 172.42 147.627 172.42 147.09C172.42 146.242 172 145.394 171.16 144.909L169.047 143.689L150.315 132.873L149.638 132.482L147.022 130.972L144.441 129.482L116.372 113.274L113.755 111.764L97.8324 102.57C96.3547 101.716 94.5334 101.716 93.0541 102.57L3.12684 154.493L1.69901 155.317C0.790019 155.842 0.335938 156.761 0.335938 157.679Z"
          fill="#2D96A7"
        />
        <path
          d="M77.0993 202.622C75.6034 202.622 74.1075 202.237 72.7735 201.467L6.0417 162.936L1.53076 160.331C1.11238 160.09 0.769532 159.769 0.511361 159.38C0.177648 158.88 0 158.292 0 157.68C0 156.574 0.571961 155.583 1.52993 155.029L92.8851 102.28C94.4623 101.37 96.4214 101.37 97.9978 102.28L113.921 111.475L116.537 112.985L144.606 129.192L150.48 132.584L171.326 144.62C172.219 145.136 172.753 146.059 172.753 147.091C172.753 147.711 172.55 148.322 172.183 148.808C171.955 149.111 171.667 149.365 171.327 149.563L166.712 152.227L81.4243 201.465C80.0902 202.235 78.5943 202.62 77.0984 202.62L77.0993 202.622ZM95.4427 102.268C94.674 102.268 93.9061 102.465 93.2204 102.861L1.86531 155.609C1.11653 156.042 0.669916 156.816 0.669916 157.681C0.669916 158.16 0.807718 158.619 1.06921 159.01C1.2701 159.313 1.53823 159.562 1.86614 159.752L6.37707 162.357L73.108 200.887C75.5702 202.308 78.6284 202.308 81.0906 200.887L166.378 151.649L170.992 148.985C171.254 148.833 171.475 148.639 171.649 148.407C171.93 148.034 172.085 147.568 172.085 147.092C172.085 146.303 171.676 145.595 170.992 145.2L97.6641 102.86C96.9793 102.465 96.2106 102.268 95.4427 102.268Z"
          fill="#133345"
        />
        <path
          d="M95.2984 106.992L164.242 146.797L77.4597 197.23L8.51562 157.425L95.2984 106.992Z"
          fill="#DDF3F6"
        />
        <path
          d="M77.4583 197.563C77.4002 197.563 77.3429 197.548 77.2906 197.518L8.34737 157.713C8.24361 157.653 8.18052 157.543 8.17969 157.424C8.17969 157.305 8.24278 157.194 8.34654 157.135L95.1293 106.702C95.2331 106.641 95.3609 106.641 95.4647 106.702L164.409 146.506C164.513 146.566 164.576 146.677 164.576 146.795C164.576 146.915 164.513 147.025 164.41 147.085L77.6268 197.518C77.5745 197.548 77.5164 197.564 77.4591 197.564L77.4583 197.563ZM9.18166 157.423L77.4575 196.842L163.574 146.796L95.2978 107.377L9.18166 157.423Z"
          fill="#133345"
        />
        <path
          d="M105.416 118.549L106.357 119.092L135.334 135.823C136.26 136.356 137.755 136.356 138.674 135.822L139.326 135.443L141.942 133.923L144.404 132.492L144.439 132.471L147.02 130.972L148.675 130.01L149.627 129.457C150.085 129.191 150.313 128.843 150.313 128.494C150.313 128.146 150.081 127.79 149.616 127.521L147.279 126.172L146.703 125.839L146.247 125.576L145.648 125.23C144.86 124.775 144.72 124.063 145.322 123.524C146.259 122.684 146.888 121.763 147.211 120.815C147.37 120.346 147.455 119.871 147.465 119.394V119.204C147.432 117.597 146.546 115.992 144.809 114.638C144.413 114.328 143.973 114.032 143.487 113.753C138.888 111.099 131.825 110.755 126.611 112.722C125.683 113.072 124.452 112.994 123.664 112.538L119.698 110.248C118.772 109.714 117.277 109.714 116.358 110.249L113.753 111.762L111.136 113.282L108.673 114.714L106.057 116.234L105.405 116.613C104.486 117.146 104.491 118.012 105.416 118.547L105.416 118.549Z"
          fill="#2D96A7"
        />
        <path
          d="M137.006 136.558C136.345 136.558 135.684 136.409 135.168 136.111L105.25 118.838C104.694 118.516 104.387 118.068 104.387 117.577C104.387 117.089 104.689 116.644 105.239 116.324L116.192 109.96C117.22 109.363 118.833 109.363 119.868 109.959L123.834 112.249C124.541 112.657 125.661 112.725 126.496 112.409C129.083 111.433 132.21 110.994 135.302 111.171C138.44 111.351 141.407 112.166 143.657 113.464C144.152 113.75 144.609 114.056 145.018 114.376C146.802 115.768 147.765 117.436 147.802 119.2V119.396C147.791 119.913 147.7 120.425 147.53 120.925C147.182 121.95 146.515 122.909 145.548 123.775C145.417 123.893 145.266 124.081 145.289 124.307C145.312 124.53 145.505 124.761 145.818 124.942L149.785 127.233C150.343 127.555 150.649 128.003 150.649 128.495C150.649 128.988 150.346 129.428 149.797 129.747L138.844 136.112C138.33 136.411 137.669 136.559 137.008 136.559L137.006 136.558ZM105.585 118.258L135.503 135.532C136.32 136.002 137.696 136.002 138.507 135.532L149.46 129.168C149.795 128.973 149.979 128.734 149.979 128.495C149.979 128.255 149.786 128.006 149.45 127.811L145.482 125.521C144.974 125.228 144.669 124.821 144.622 124.375C144.581 123.979 144.751 123.588 145.101 123.276C145.98 122.487 146.585 121.623 146.896 120.708C147.044 120.274 147.124 119.83 147.133 119.389V119.206C147.101 117.657 146.227 116.167 144.606 114.903C144.221 114.602 143.79 114.313 143.322 114.044C138.91 111.498 131.933 111.074 126.731 113.036C125.708 113.423 124.378 113.337 123.499 112.829L119.532 110.539C118.716 110.067 117.339 110.067 116.527 110.539L105.575 116.903C105.244 117.094 105.055 117.34 105.055 117.576C105.055 117.815 105.248 118.063 105.585 118.258Z"
          fill="#133345"
        />
        <path
          d="M69.9567 164.32C69.9567 164.32 69.96 164.323 69.9625 164.323L89.9903 175.968C90.8163 176.447 90.8154 177.223 89.9903 177.7C89.166 178.176 87.8311 178.174 87.0051 177.697C87.0035 177.696 87.0018 177.694 86.9993 177.693L66.9707 166.049C66.1448 165.569 66.1456 164.793 66.9707 164.317C67.7951 163.841 69.1299 163.843 69.9567 164.319V164.32Z"
          fill="#2D96A7"
        />
        <path
          d="M36.32 151.32C36.32 151.32 36.3233 151.322 36.3258 151.323L84.3298 179.231C85.1558 179.711 85.155 180.487 84.329 180.964C83.5047 181.44 82.1698 181.438 81.3438 180.961C81.3422 180.961 81.3405 180.959 81.338 180.958L33.334 153.049C32.508 152.569 32.5089 151.794 33.334 151.317C34.1583 150.841 35.4932 150.843 36.3192 151.32H36.32Z"
          fill="#2D96A7"
        />
        <path
          d="M30.6629 154.586C30.6629 154.586 30.6662 154.588 30.6687 154.589L78.6719 182.497C79.4979 182.977 79.497 183.753 78.6719 184.23C77.8476 184.705 76.5127 184.704 75.6867 184.226C75.6851 184.226 75.6834 184.224 75.6818 184.223L27.6778 156.315C26.8518 155.835 26.8526 155.059 27.6778 154.582C28.5021 154.107 29.8369 154.108 30.6638 154.585L30.6629 154.586Z"
          fill="#2D96A7"
        />
        <path
          d="M124.219 130.586L124.179 144.604C124.17 147.907 121.999 151.205 117.663 153.724C117.371 153.894 117.073 154.057 116.77 154.216L116.809 140.198C117.113 140.039 117.411 139.876 117.703 139.707C122.039 137.186 124.21 133.888 124.219 130.586Z"
          fill="#36B4C9"
        />
        <mask
          id="mask0_1185_34932"
          maskUnits="userSpaceOnUse"
          x="116"
          y="130"
          width="9"
          height="25"
        >
          <path
            d="M124.219 130.586L124.179 144.604C124.17 147.907 121.999 151.205 117.663 153.724C117.371 153.894 117.073 154.057 116.77 154.216L116.809 140.198C117.113 140.039 117.411 139.876 117.703 139.707C122.039 137.186 124.21 133.888 124.219 130.586Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1185_34932)">
          <path
            d="M124.219 130.586L124.179 144.604C124.17 147.907 121.999 151.205 117.663 153.724C117.371 153.894 117.073 154.057 116.77 154.216L116.809 140.198C117.113 140.039 117.411 139.876 117.703 139.707C122.039 137.186 124.21 133.888 124.219 130.586Z"
            fill="#36B4C9"
          />
        </g>
        <path
          d="M121.978 124.895C126.017 129.728 124.597 135.701 117.702 139.708C117.41 139.878 117.111 140.041 116.808 140.2L101.793 130.523L121.978 124.895Z"
          fill="#DDF3F6"
        />
        <path
          d="M116.809 140.2L116.77 154.218L101.754 144.541L101.794 130.523L116.809 140.2Z"
          fill="#2D96A7"
        />
        <path
          d="M116.788 154.55C116.727 154.55 116.667 154.533 116.614 154.501C116.514 154.44 116.453 154.331 116.453 154.213L116.493 140.196C116.493 140.071 116.563 139.958 116.673 139.9C116.974 139.743 117.271 139.581 117.553 139.416C121.639 137.042 123.894 133.905 123.904 130.584C123.904 130.399 124.058 130.251 124.239 130.25C124.424 130.25 124.573 130.401 124.573 130.585L124.533 144.603C124.523 148.172 122.149 151.514 117.849 154.013C117.56 154.181 117.255 154.349 116.942 154.511C116.893 154.536 116.841 154.55 116.788 154.55ZM117.161 140.399L117.124 153.655C117.257 153.582 117.386 153.508 117.513 153.434C121.599 151.06 123.855 147.923 123.864 144.601L123.894 133.822C122.905 136.146 120.856 138.271 117.889 139.995C117.654 140.132 117.41 140.267 117.161 140.399Z"
          fill="#133345"
        />
        <mask
          id="mask1_1185_34932"
          maskUnits="userSpaceOnUse"
          x="116"
          y="130"
          width="9"
          height="25"
        >
          <path
            d="M116.788 154.55C116.727 154.55 116.667 154.533 116.614 154.501C116.514 154.44 116.453 154.331 116.453 154.213L116.493 140.196C116.493 140.071 116.563 139.958 116.673 139.9C116.974 139.743 117.271 139.581 117.553 139.416C121.639 137.042 123.894 133.905 123.904 130.584C123.904 130.399 124.058 130.251 124.239 130.25C124.424 130.25 124.573 130.401 124.573 130.585L124.533 144.603C124.523 148.172 122.149 151.514 117.849 154.013C117.56 154.181 117.255 154.349 116.942 154.511C116.893 154.536 116.841 154.55 116.788 154.55ZM117.161 140.399L117.124 153.655C117.257 153.582 117.386 153.508 117.513 153.434C121.599 151.06 123.855 147.923 123.864 144.601L123.894 133.822C122.905 136.146 120.856 138.271 117.889 139.995C117.654 140.132 117.41 140.267 117.161 140.399Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1185_34932)">
          <path
            d="M116.788 154.55C116.727 154.55 116.667 154.533 116.614 154.501C116.514 154.44 116.453 154.331 116.453 154.213L116.493 140.196C116.493 140.071 116.563 139.958 116.673 139.9C116.974 139.743 117.271 139.581 117.553 139.416C121.639 137.042 123.894 133.905 123.904 130.584C123.904 130.399 124.058 130.251 124.239 130.25C124.424 130.25 124.573 130.401 124.573 130.585L124.533 144.603C124.523 148.172 122.149 151.514 117.849 154.013C117.56 154.181 117.255 154.349 116.942 154.511C116.893 154.536 116.841 154.55 116.788 154.55ZM117.161 140.399L117.124 153.655C117.257 153.582 117.386 153.508 117.513 153.434C121.599 151.06 123.855 147.923 123.864 144.601L123.894 133.822C122.905 136.146 120.856 138.271 117.889 139.995C117.654 140.132 117.41 140.267 117.161 140.399Z"
            fill="#133345"
          />
        </g>
        <path
          d="M116.826 140.537C116.763 140.537 116.7 140.518 116.645 140.484L101.63 130.807C101.519 130.735 101.46 130.606 101.48 130.476C101.5 130.345 101.594 130.239 101.721 130.203L121.907 124.575C122.034 124.539 122.17 124.582 122.254 124.683C124.131 126.931 124.892 129.444 124.45 131.951C123.915 134.994 121.585 137.852 117.888 140C117.597 140.17 117.291 140.338 116.981 140.499C116.932 140.524 116.879 140.538 116.826 140.538V140.537ZM102.618 130.648L116.843 139.815C117.085 139.687 117.323 139.555 117.552 139.422C121.075 137.375 123.29 134.68 123.791 131.834C124.186 129.589 123.525 127.326 121.876 125.278L102.618 130.648Z"
          fill="#133345"
        />
        <path
          d="M116.787 154.551C116.724 154.551 116.661 154.534 116.606 154.498L101.591 144.821C101.496 144.76 101.438 144.653 101.438 144.539L101.477 130.521C101.477 130.399 101.545 130.286 101.653 130.228C101.76 130.17 101.891 130.174 101.994 130.241L117.009 139.917C117.105 139.979 117.163 140.086 117.163 140.2L117.123 154.217C117.123 154.339 117.056 154.452 116.948 154.51C116.898 154.538 116.843 154.551 116.788 154.551H116.787ZM102.107 144.358L116.455 153.604L116.492 140.381L102.144 131.135L102.107 144.358H102.107Z"
          fill="#133345"
        />
        <path
          d="M101.793 127.067L87.5111 137.056C86.9881 136.804 86.4792 136.536 85.9869 136.252C79.1118 132.282 77.5877 126.382 81.4345 121.573C82.5021 120.238 83.9855 118.985 85.884 117.882C88.1835 116.547 90.8607 115.562 93.7196 114.93L101.793 127.067Z"
          fill="#DDF3F6"
        />
        <path
          d="M101.79 127.066L101.75 144.542L87.4688 154.53L87.5086 137.055L101.79 127.066Z"
          fill="#36B4C9"
        />
        <path
          d="M79.3282 144.475L79.368 127C79.3589 130.345 81.567 133.697 85.9883 136.249C86.4797 136.533 86.9886 136.801 87.5116 137.054L87.4717 154.529C86.9479 154.276 86.4399 154.008 85.9485 153.724C81.5272 151.172 79.319 147.821 79.3282 144.475Z"
          fill="#2D96A7"
        />
        <path
          d="M87.5106 137.378C87.4608 137.378 87.4118 137.367 87.3654 137.345C86.8357 137.09 86.3161 136.815 85.8197 136.529C82.1048 134.384 79.7439 131.53 79.1711 128.492C78.7079 126.037 79.4002 123.567 81.1726 121.351C82.2924 119.95 83.8207 118.681 85.7151 117.58C87.9938 116.256 90.6626 115.25 93.6461 114.59C93.7814 114.56 93.9201 114.617 93.9973 114.731L102.07 126.868C102.171 127.02 102.133 127.224 101.983 127.328L87.7016 137.317C87.6443 137.357 87.577 137.378 87.5098 137.378H87.5106ZM93.5681 115.293C90.7415 115.938 88.2137 116.902 86.0521 118.158C84.2291 119.217 82.7639 120.432 81.6956 121.769C80.0486 123.828 79.4036 126.11 79.8286 128.368C80.364 131.211 82.6104 133.903 86.1542 135.948C86.5817 136.195 87.0267 136.432 87.4799 136.656L101.332 126.966L93.5673 115.293H93.5681Z"
          fill="#133345"
        />
        <path
          d="M87.4713 154.852C87.4181 154.852 87.365 154.839 87.316 154.814C87.2056 154.756 87.1359 154.641 87.1367 154.516L87.1766 137.041C87.1766 136.933 87.2305 136.83 87.3194 136.768L101.601 126.779C101.703 126.708 101.837 126.699 101.948 126.757C102.058 126.815 102.128 126.929 102.127 127.054L102.087 144.529C102.087 144.638 102.033 144.74 101.945 144.802L87.663 154.791C87.6057 154.831 87.5385 154.852 87.4713 154.852ZM87.8448 137.216L87.8066 153.874L101.418 144.354L101.456 127.697L87.8448 137.216Z"
          fill="#133345"
        />
        <path
          d="M87.4313 154.854C87.3815 154.854 87.3325 154.843 87.286 154.821C86.7531 154.564 86.2334 154.29 85.7403 154.005C81.3531 151.472 78.9424 148.084 78.9532 144.465L78.993 126.999C78.993 126.999 78.993 126.993 78.993 126.99C78.993 126.806 79.1433 126.656 79.3276 126.656H79.3284C79.5135 126.656 79.6621 126.807 79.6621 126.992V126.998C79.6555 130.364 81.9466 133.544 86.1147 135.95C86.5937 136.227 87.0984 136.493 87.6164 136.742C87.7326 136.798 87.8057 136.916 87.8057 137.045L87.7658 154.52C87.7658 154.634 87.7061 154.741 87.6089 154.803C87.555 154.837 87.4927 154.854 87.4313 154.854ZM79.6546 130.239L79.6222 144.468C79.6123 147.837 81.9043 151.018 86.0749 153.426C86.4044 153.616 86.7473 153.802 87.0976 153.982L87.1358 137.254C86.6692 137.024 86.2143 136.781 85.7802 136.531C82.7394 134.775 80.6483 132.609 79.6546 130.239Z"
          fill="#133345"
        />
        <path
          d="M116.806 145.552L116.766 154.217C108.495 158.527 95.99 158.631 87.4688 154.529L87.5086 145.863C96.0307 149.965 108.535 149.861 116.806 145.551V145.552Z"
          fill="#2D96A7"
        />
        <path
          d="M116.81 145.552C108.539 149.863 96.0338 149.967 87.5117 145.864L91.7661 142.888L101.793 135.875L116.81 145.552Z"
          fill="#DDF3F6"
        />
        <path
          d="M116.809 145.552C116.809 145.552 102.123 147.238 91.7656 142.888L101.793 135.875L116.809 145.552Z"
          fill="#36B4C9"
        />
        <path
          d="M101.827 157.866C96.5346 157.866 91.3994 156.794 87.326 154.832C87.2098 154.776 87.1359 154.658 87.1367 154.529L87.1766 145.864C87.1766 145.75 87.2363 145.643 87.3335 145.582C87.4306 145.521 87.5526 145.515 87.6556 145.564C96.0747 149.617 108.541 149.485 116.653 145.256C116.757 145.203 116.881 145.207 116.982 145.267C117.082 145.329 117.143 145.437 117.142 145.555L117.102 154.219C117.102 154.344 117.032 154.457 116.922 154.515C112.882 156.62 107.66 157.81 102.216 157.864C102.087 157.865 101.955 157.865 101.826 157.865L101.827 157.866ZM87.8066 154.32C96.1602 158.251 108.38 158.12 116.435 154.014L116.471 146.098C112.504 148.048 107.482 149.146 102.257 149.198C97.0335 149.249 91.939 148.255 87.8432 146.39L87.8066 154.319V154.32Z"
          fill="#133345"
        />
        <path
          d="M101.867 149.199C96.5749 149.199 91.4397 148.126 87.3654 146.164C87.2583 146.113 87.1869 146.008 87.177 145.89C87.167 145.771 87.2209 145.656 87.3189 145.588L91.5733 142.612L101.6 135.599C101.712 135.521 101.859 135.519 101.973 135.593L116.989 145.27C117.09 145.334 117.148 145.447 117.142 145.566C117.136 145.685 117.068 145.792 116.963 145.847C112.923 147.953 107.701 149.142 102.257 149.197C102.128 149.199 101.996 149.199 101.867 149.199ZM88.1773 145.805C96.4022 149.526 108.188 149.403 116.136 145.515L101.8 136.277L88.1773 145.805Z"
          fill="#133345"
        />
        <path
          d="M128.413 56.0593L118.975 31.6875L109.429 45.0991L112.466 46.8523V74.1994L94.2773 84.5079L105.644 91.0718L123.689 80.6661V53.3323L128.413 56.0593Z"
          fill="#2D96A7"
        />
        <path
          d="M105.644 91.4035C105.586 91.4035 105.528 91.3886 105.476 91.3587L94.1091 84.7957C94.0053 84.7359 93.9414 84.6247 93.9414 84.5043C93.9414 84.3839 94.007 84.2735 94.1107 84.2146L112.13 74.0023V47.0438L109.26 45.3868C109.178 45.3395 109.12 45.2607 109.1 45.1685C109.081 45.0764 109.1 44.9801 109.154 44.9037L118.7 31.4921C118.771 31.3917 118.892 31.3385 119.014 31.3543C119.136 31.3692 119.24 31.4506 119.284 31.5652L128.723 55.937C128.775 56.069 128.736 56.2192 128.628 56.3122C128.521 56.4043 128.366 56.4185 128.243 56.3479L124.021 53.9098V80.6641C124.021 80.7836 123.957 80.894 123.854 80.9538L105.809 91.3595C105.757 91.3894 105.699 91.4043 105.642 91.4043L105.644 91.4035ZM94.95 84.5084L105.644 90.683L123.354 80.4698V53.3295C123.354 53.21 123.418 53.0996 123.521 53.0398C123.624 52.9801 123.751 52.9801 123.855 53.0398L127.758 55.2928L118.886 32.3853L109.914 44.9909L112.633 46.5606C112.736 46.6204 112.8 46.7308 112.8 46.8504V74.1974C112.8 74.3177 112.736 74.429 112.631 74.4888L94.9508 84.5093L94.95 84.5084Z"
          fill="#133345"
        />
        <path
          d="M232.735 181.232L232.758 189.452C232.747 185.318 230.035 181.19 224.62 178.043C213.717 171.708 195.921 171.708 184.948 178.043C179.426 181.231 176.668 185.425 176.68 189.613L176.656 181.392C176.645 177.205 179.402 173.01 184.924 169.822C195.898 163.487 213.694 163.486 224.596 169.822C230.012 172.969 232.723 177.098 232.735 181.232Z"
          fill="#36B4C9"
        />
        <path
          d="M232.761 189.452C232.754 186.565 231.43 183.681 228.787 181.132C228.348 180.708 227.873 180.295 227.362 179.891C226.543 179.246 225.629 178.627 224.624 178.043C218.268 174.349 209.568 172.809 201.244 173.423C199.591 173.544 197.953 173.751 196.351 174.042C193.538 174.555 190.837 175.327 188.363 176.362C187.635 176.666 186.928 176.992 186.243 177.341C185.802 177.565 185.372 177.8 184.951 178.043C179.44 181.225 176.683 185.409 176.683 189.587L176.66 181.391C176.648 177.203 179.406 173.01 184.927 169.822C185.356 169.575 185.795 169.337 186.243 169.108C186.928 168.76 187.635 168.435 188.363 168.133C190.838 167.099 193.539 166.327 196.351 165.817C197.952 165.527 199.591 165.32 201.244 165.2C209.561 164.59 218.25 166.132 224.6 169.821C225.616 170.411 226.538 171.036 227.363 171.691C227.873 172.094 228.349 172.509 228.787 172.935C231.414 175.478 232.731 178.352 232.739 181.231L232.762 189.453L232.761 189.452Z"
          fill="#36B4C9"
        />
        <path
          d="M176.68 189.894C176.524 189.894 176.398 189.769 176.398 189.613L176.375 181.393C176.368 179.208 177.079 177.081 178.484 175.07C179.929 173.005 182.048 171.157 184.783 169.578C195.835 163.198 213.758 163.198 224.738 169.578C230.064 172.673 233.004 176.811 233.017 181.231L233.04 189.452C233.04 189.607 232.914 189.734 232.759 189.734C232.604 189.734 232.478 189.608 232.478 189.453C232.466 185.243 229.625 181.276 224.479 178.286C213.656 171.996 195.986 171.996 185.09 178.287C179.837 181.32 176.95 185.342 176.963 189.612C176.963 189.767 176.837 189.894 176.682 189.894H176.68ZM204.788 165.348C197.655 165.348 190.514 166.92 185.065 170.066C179.812 173.099 176.925 177.121 176.938 181.391L176.952 186.302C177.304 185.275 177.824 184.27 178.508 183.291C179.952 181.226 182.071 179.378 184.807 177.799C195.858 171.419 213.782 171.419 224.761 177.799C228.727 180.104 231.37 182.988 232.467 186.135L232.453 181.232C232.441 177.022 229.601 173.056 224.455 170.066C219.044 166.921 211.92 165.348 204.788 165.348Z"
          fill="#36B4C9"
        />
        <mask
          id="mask2_1185_34932"
          maskUnits="userSpaceOnUse"
          x="176"
          y="164"
          width="58"
          height="26"
        >
          <path
            d="M176.68 189.894C176.524 189.894 176.398 189.769 176.398 189.613L176.375 181.393C176.368 179.208 177.079 177.081 178.484 175.07C179.929 173.005 182.048 171.157 184.783 169.578C195.835 163.198 213.758 163.198 224.738 169.578C230.064 172.673 233.004 176.811 233.017 181.231L233.04 189.452C233.04 189.607 232.914 189.734 232.759 189.734C232.604 189.734 232.478 189.608 232.478 189.453C232.466 185.243 229.625 181.276 224.479 178.286C213.656 171.996 195.986 171.996 185.09 178.287C179.837 181.32 176.95 185.342 176.963 189.612C176.963 189.767 176.837 189.894 176.682 189.894H176.68ZM204.788 165.348C197.655 165.348 190.514 166.92 185.065 170.066C179.812 173.099 176.925 177.121 176.938 181.391L176.952 186.302C177.304 185.275 177.824 184.27 178.508 183.291C179.952 181.226 182.071 179.378 184.807 177.799C195.858 171.419 213.782 171.419 224.761 177.799C228.727 180.104 231.37 182.988 232.467 186.135L232.453 181.232C232.441 177.022 229.601 173.056 224.455 170.066C219.044 166.921 211.92 165.348 204.788 165.348Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_1185_34932)">
          <path
            d="M176.68 189.894C176.524 189.894 176.398 189.769 176.398 189.613L176.375 181.393C176.368 179.208 177.079 177.081 178.484 175.07C179.929 173.005 182.048 171.157 184.783 169.578C195.835 163.198 213.758 163.198 224.738 169.578C230.064 172.673 233.004 176.811 233.017 181.231L233.04 189.452C233.04 189.607 232.914 189.734 232.759 189.734C232.604 189.734 232.478 189.608 232.478 189.453C232.466 185.243 229.625 181.276 224.479 178.286C213.656 171.996 195.986 171.996 185.09 178.287C179.837 181.32 176.95 185.342 176.963 189.612C176.963 189.767 176.837 189.894 176.682 189.894H176.68ZM204.788 165.348C197.655 165.348 190.514 166.92 185.065 170.066C179.812 173.099 176.925 177.121 176.938 181.391L176.952 186.302C177.304 185.275 177.824 184.27 178.508 183.291C179.952 181.226 182.071 179.378 184.807 177.799C195.858 171.419 213.782 171.419 224.761 177.799C228.727 180.104 231.37 182.988 232.467 186.135L232.453 181.232C232.441 177.022 229.601 173.056 224.455 170.066C219.044 166.921 211.92 165.348 204.788 165.348Z"
            fill="#36B4C9"
          />
        </g>
        <path
          d="M241.697 181.203L241.721 189.424C241.734 194.121 239.107 198.824 233.844 202.713L233.82 194.493C239.083 190.604 241.711 185.9 241.697 181.203Z"
          fill="#36B4C9"
        />
        <path
          d="M241.722 189.428C241.727 191.486 241.227 193.543 240.219 195.534C239.824 196.317 239.35 197.089 238.797 197.846C237.547 199.561 235.895 201.201 233.843 202.718L233.82 194.496C235.885 192.97 237.543 191.32 238.796 189.593C239.349 188.83 239.823 188.053 240.218 187.266C241.204 185.302 241.697 183.271 241.697 181.242L241.72 189.427L241.722 189.428Z"
          fill="#36B4C9"
        />
        <path
          d="M233.844 202.999C233.801 202.999 233.757 202.989 233.718 202.969C233.623 202.922 233.562 202.825 233.562 202.718L233.539 194.498C233.539 194.408 233.581 194.323 233.654 194.27C238.673 190.561 241.43 185.922 241.417 181.208C241.417 181.053 241.542 180.926 241.698 180.926C241.853 180.926 241.979 181.051 241.979 181.206L242.002 189.427C242.009 191.849 241.336 194.234 240.004 196.518C238.643 198.849 236.626 201.012 234.011 202.944C233.962 202.981 233.903 203 233.843 203L233.844 202.999ZM234.103 194.638L234.124 202.153C238.859 198.502 241.453 194 241.44 189.428L241.428 184.996C241.095 186.114 240.613 187.217 239.982 188.297C238.64 190.593 236.663 192.727 234.103 194.638Z"
          fill="#36B4C9"
        />
        <mask
          id="mask3_1185_34932"
          maskUnits="userSpaceOnUse"
          x="233"
          y="180"
          width="10"
          height="23"
        >
          <path
            d="M233.844 202.999C233.801 202.999 233.757 202.989 233.718 202.969C233.623 202.922 233.562 202.825 233.562 202.718L233.539 194.498C233.539 194.408 233.581 194.323 233.654 194.27C238.673 190.561 241.43 185.922 241.417 181.208C241.417 181.053 241.542 180.926 241.698 180.926C241.853 180.926 241.979 181.051 241.979 181.206L242.002 189.427C242.009 191.849 241.336 194.234 240.004 196.518C238.643 198.849 236.626 201.012 234.011 202.944C233.962 202.981 233.903 203 233.843 203L233.844 202.999ZM234.103 194.638L234.124 202.153C238.859 198.502 241.453 194 241.44 189.428L241.428 184.996C241.095 186.114 240.613 187.217 239.982 188.297C238.64 190.593 236.663 192.727 234.103 194.638Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_1185_34932)">
          <path
            d="M233.844 202.999C233.801 202.999 233.757 202.989 233.718 202.969C233.623 202.922 233.562 202.825 233.562 202.718L233.539 194.498C233.539 194.408 233.581 194.323 233.654 194.27C238.673 190.561 241.43 185.922 241.417 181.208C241.417 181.053 241.542 180.926 241.698 180.926C241.853 180.926 241.979 181.051 241.979 181.206L242.002 189.427C242.009 191.849 241.336 194.234 240.004 196.518C238.643 198.849 236.626 201.012 234.011 202.944C233.962 202.981 233.903 203 233.843 203L233.844 202.999ZM234.103 194.638L234.124 202.153C238.859 198.502 241.453 194 241.44 189.428L241.428 184.996C241.095 186.114 240.613 187.217 239.982 188.297C238.64 190.593 236.663 192.727 234.103 194.638Z"
            fill="#36B4C9"
          />
        </g>
        <path
          d="M230.663 200.147L230.687 208.367L227.383 206.447L227.359 198.227L230.663 200.147Z"
          fill="#36B4C9"
        />
        <path
          d="M230.687 208.646C230.638 208.646 230.589 208.633 230.545 208.608L227.242 206.687C227.155 206.637 227.102 206.545 227.101 206.445L227.078 198.224C227.078 198.123 227.131 198.03 227.219 197.979C227.306 197.929 227.414 197.929 227.502 197.979L230.805 199.899C230.891 199.949 230.944 200.041 230.945 200.141L230.968 208.362C230.968 208.463 230.915 208.556 230.827 208.607C230.784 208.632 230.735 208.645 230.686 208.645L230.687 208.646ZM227.664 206.282L230.404 207.874L230.382 200.305L227.643 198.714L227.664 206.282V206.282Z"
          fill="#36B4C9"
        />
        <path
          d="M167.719 189.639L167.695 181.418C167.711 186.874 171.288 192.321 178.435 196.474C191.735 204.203 212.811 204.787 227.36 198.225L227.383 206.446C212.835 213.008 191.758 212.424 178.458 204.695C171.311 200.542 167.734 195.094 167.719 189.639Z"
          fill="#2D96A7"
        />
        <mask
          id="mask4_1185_34932"
          maskUnits="userSpaceOnUse"
          x="167"
          y="181"
          width="61"
          height="30"
        >
          <path
            d="M167.719 189.639L167.695 181.418C167.711 186.874 171.288 192.321 178.435 196.474C191.735 204.203 212.811 204.787 227.36 198.225L227.383 206.446C212.835 213.008 191.758 212.424 178.458 204.695C171.311 200.542 167.734 195.094 167.719 189.639Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_1185_34932)">
          <path
            d="M227.36 198.225L227.383 206.446C212.835 213.008 191.758 212.424 178.458 204.695C171.311 200.542 167.734 195.094 167.719 189.639L167.695 181.418C167.711 186.874 171.288 192.321 178.435 196.474C191.735 204.203 212.811 204.787 227.36 198.225Z"
            fill="#2D96A7"
          />
        </g>
        <path
          d="M204.628 211.249C195.043 211.249 185.51 209.118 178.317 204.938C174.788 202.887 172.051 200.491 170.183 197.817C168.369 195.218 167.445 192.467 167.437 189.64L167.414 181.419C167.414 181.264 167.539 181.137 167.695 181.137C167.85 181.137 167.976 181.262 167.976 181.417C167.992 187.007 171.756 192.268 178.576 196.231C191.66 203.834 212.582 204.581 227.244 197.968C227.331 197.929 227.432 197.937 227.512 197.988C227.593 198.04 227.641 198.129 227.642 198.224L227.665 206.445C227.665 206.556 227.6 206.657 227.499 206.702C220.742 209.75 212.667 211.25 204.627 211.25L204.628 211.249ZM168 189.637C168.016 195.227 171.781 200.488 178.6 204.451C191.634 212.025 212.449 212.795 227.102 206.263L227.081 198.657C212.289 205.147 191.402 204.336 178.294 196.717C174.765 194.666 172.028 192.27 170.16 189.596C169.169 188.176 168.443 186.711 167.988 185.213L168 189.638V189.637Z"
          fill="#36B4C9"
        />
        <mask
          id="mask5_1185_34932"
          maskUnits="userSpaceOnUse"
          x="167"
          y="181"
          width="61"
          height="31"
        >
          <path
            d="M204.628 211.249C195.043 211.249 185.51 209.118 178.317 204.938C174.788 202.887 172.051 200.491 170.183 197.817C168.369 195.218 167.445 192.467 167.437 189.64L167.414 181.419C167.414 181.264 167.539 181.137 167.695 181.137C167.85 181.137 167.976 181.262 167.976 181.417C167.992 187.007 171.756 192.268 178.576 196.231C191.66 203.834 212.582 204.581 227.244 197.968C227.331 197.929 227.432 197.937 227.512 197.988C227.593 198.04 227.641 198.129 227.642 198.224L227.665 206.445C227.665 206.556 227.6 206.657 227.499 206.702C220.742 209.75 212.667 211.25 204.627 211.25L204.628 211.249ZM168 189.637C168.016 195.227 171.781 200.488 178.6 204.451C191.634 212.025 212.449 212.795 227.102 206.263L227.081 198.657C212.289 205.147 191.402 204.336 178.294 196.717C174.765 194.666 172.028 192.27 170.16 189.596C169.169 188.176 168.443 186.711 167.988 185.213L168 189.638V189.637Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask5_1185_34932)">
          <path
            d="M204.628 211.249C195.043 211.249 185.51 209.118 178.317 204.938C174.788 202.887 172.051 200.491 170.183 197.817C168.369 195.218 167.445 192.467 167.437 189.64L167.414 181.419C167.414 181.264 167.539 181.137 167.695 181.137C167.85 181.137 167.976 181.262 167.976 181.417C167.992 187.007 171.756 192.268 178.576 196.231C191.66 203.834 212.582 204.581 227.244 197.968C227.331 197.929 227.432 197.937 227.512 197.988C227.593 198.04 227.641 198.129 227.642 198.224L227.665 206.445C227.665 206.556 227.6 206.657 227.499 206.702C220.742 209.75 212.667 211.25 204.627 211.25L204.628 211.249ZM167.988 185.212L168 189.637C168.016 195.227 171.781 200.488 178.6 204.451C191.634 212.025 212.449 212.795 227.102 206.263L227.081 198.657C212.289 205.147 191.402 204.336 178.294 196.717C174.765 194.666 172.028 192.27 170.16 189.596C169.169 188.176 168.443 186.711 167.988 185.213V185.212Z"
            fill="#36B4C9"
          />
        </g>
        <path
          d="M270.255 225.394L270.278 233.616L228.75 209.483L228.727 201.262L270.255 225.394Z"
          fill="#2D96A7"
        />
        <path
          d="M270.279 233.898C270.23 233.898 270.181 233.886 270.137 233.86L228.609 209.727C228.523 209.676 228.469 209.584 228.469 209.484L228.445 201.263C228.445 201.162 228.498 201.069 228.586 201.018C228.674 200.968 228.782 200.968 228.869 201.018L270.397 225.152C270.483 225.203 270.536 225.295 270.537 225.394L270.56 233.615C270.56 233.716 270.507 233.809 270.419 233.86C270.376 233.885 270.327 233.898 270.278 233.898H270.279ZM229.032 209.321L269.996 233.126L269.974 225.558L229.011 201.752L229.032 209.321Z"
          fill="#36B4C9"
        />
        <path
          d="M280.59 219.43L280.614 227.65L270.281 233.617L270.258 225.395L280.59 219.43Z"
          fill="#36B4C9"
        />
        <path
          d="M270.277 233.899C270.229 233.899 270.18 233.886 270.137 233.861C270.05 233.811 269.996 233.718 269.996 233.618L269.973 225.397C269.973 225.296 270.026 225.203 270.114 225.152L280.447 219.186C280.534 219.136 280.642 219.135 280.729 219.186C280.816 219.236 280.87 219.329 280.87 219.429L280.893 227.65C280.893 227.751 280.84 227.844 280.752 227.895L270.418 233.861C270.375 233.886 270.326 233.899 270.277 233.899V233.899ZM270.536 225.558L270.558 233.13L280.329 227.488L280.307 219.917L270.536 225.558Z"
          fill="#36B4C9"
        />
        <path
          d="M230.958 166.149C244.259 173.878 245.197 186.088 233.821 194.494L237.124 196.414L239.06 195.296L280.589 219.429L270.255 225.396L228.727 201.262L230.664 200.144L227.361 198.224C212.812 204.786 191.735 204.202 178.435 196.473C164.05 188.113 164.124 174.509 178.606 166.149C193.087 157.788 216.573 157.79 230.958 166.149ZM224.468 192.801C235.442 186.466 235.499 176.156 224.598 169.821C213.696 163.485 195.899 163.486 184.926 169.821C173.952 176.156 173.895 186.464 184.796 192.8C195.699 199.135 213.495 199.136 224.468 192.8"
          fill="#DDF3F6"
        />
        <path
          d="M270.255 225.677C270.206 225.677 270.157 225.665 270.114 225.639L228.586 201.506C228.498 201.455 228.445 201.362 228.445 201.261C228.445 201.161 228.499 201.068 228.586 201.018L230.102 200.143L227.345 198.54C212.539 205.156 191.481 204.38 178.294 196.717C174.753 194.659 172.011 192.255 170.143 189.57C168.328 186.962 167.41 184.201 167.414 181.364C167.418 178.509 168.355 175.729 170.199 173.102C172.098 170.397 174.879 167.976 178.465 165.905C193.024 157.5 216.635 157.5 231.099 165.905C237.798 169.798 241.655 174.994 241.96 180.536C242.236 185.566 239.53 190.5 234.329 194.464L237.124 196.088L238.92 195.051C239.007 195.001 239.115 195.001 239.202 195.051L280.73 219.185C280.817 219.235 280.871 219.328 280.871 219.429C280.871 219.529 280.817 219.622 280.729 219.672L270.396 225.638C270.353 225.663 270.304 225.676 270.255 225.676V225.677ZM229.289 201.263L270.256 225.07L280.026 219.429L239.059 195.622L237.264 196.658C237.177 196.709 237.069 196.709 236.982 196.658L233.678 194.739C233.596 194.692 233.544 194.605 233.539 194.511C233.534 194.416 233.576 194.325 233.653 194.268C238.919 190.377 241.669 185.511 241.398 180.567C241.104 175.221 237.346 170.188 230.817 166.393C216.508 158.078 193.15 158.078 178.747 166.393C171.81 170.399 167.985 175.716 167.978 181.365C167.969 186.974 171.734 192.254 178.578 196.23C191.661 203.833 212.584 204.58 227.246 197.968C227.329 197.93 227.424 197.935 227.503 197.981L230.806 199.9C230.893 199.951 230.947 200.044 230.947 200.144C230.947 200.245 230.893 200.338 230.805 200.387L229.29 201.262L229.289 201.263ZM204.606 197.831C197.371 197.831 190.145 196.235 184.654 193.045C179.309 189.938 176.37 185.786 176.375 181.352C176.379 179.174 177.093 177.055 178.499 175.052C179.943 172.994 182.058 171.153 184.785 169.579C195.836 163.198 213.759 163.198 224.739 169.579C230.084 172.685 233.024 176.838 233.018 181.273C233.014 183.45 232.3 185.57 230.894 187.573C229.45 189.631 227.335 191.472 224.608 193.046C219.084 196.235 211.84 197.831 204.606 197.831ZM204.789 165.348C197.656 165.348 190.515 166.921 185.066 170.067C179.831 173.089 176.945 177.097 176.939 181.352C176.933 185.578 179.774 189.557 184.937 192.558C195.761 198.848 213.432 198.848 224.327 192.558C229.562 189.535 232.448 185.527 232.454 181.271C232.46 177.046 229.619 173.066 224.456 170.065C219.045 166.921 211.921 165.348 204.789 165.348V165.348Z"
          fill="#36B4C9"
        />
        <path
          d="M188.362 168.133V176.362C187.634 176.667 186.927 176.992 186.242 177.341V169.109C186.927 168.761 187.634 168.436 188.362 168.134V168.133Z"
          fill="#DDF3F6"
        />
        <path
          d="M201.24 165.199V173.423C199.588 173.545 197.95 173.751 196.348 174.043V165.817C197.949 165.527 199.588 165.32 201.24 165.2V165.199Z"
          fill="#DDF3F6"
        />
        <path
          d="M228.784 172.932V181.13C228.346 180.706 227.871 180.293 227.359 179.889V171.688C227.87 172.091 228.346 172.506 228.784 172.932Z"
          fill="#DDF3F6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1185_34932">
          <rect width="334" height="233.899" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InvestorIllustration;
